import React__default, { useState, useRef, useEffect, useMemo } from 'react';
import { styled, createTheme } from '@mui/material/styles';
import Grow from '@mui/material/Grow';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import SvgIcon from '@mui/material/SvgIcon';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import '@mui/material/Badge';
import '@mui/material/Chip';
import '@mui/icons-material/Check';
import CardMedia from '@mui/material/CardMedia';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import Checkbox from '@mui/material/Checkbox';
import CircularProgress from '@mui/material/CircularProgress';
import DeleteIcon from '@mui/icons-material/Delete';
import Divider from '@mui/material/Divider';
import EditIcon from '@mui/icons-material/Edit';
import ErrorIcon from '@mui/icons-material/Error';
import IconButton from '@mui/material/IconButton';
import Link from '@mui/material/Link';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Menu from '@mui/material/Menu';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import PublicIcon from '@mui/icons-material/Public';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import TranslateIcon from '@mui/icons-material/Translate';
import 'react-is';
import ListSubheader from '@mui/material/ListSubheader';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import { deepPurple, grey } from '@mui/material/colors';

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var PREFIX = "HyperaudioConferences";
var classes = {
  root: PREFIX + "-root",
  path: PREFIX + "-path"
};
var Root = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'fill'].includes(prop);
  }
})(function (_ref) {
  var _svg, _ref2;

  var theme = _ref.theme,
      size = _ref.size;
  return _ref2 = {
    display: 'inline-block',
    lineHeight: 0
  }, _ref2["& svg"] = (_svg = {
    width: 'auto',
    height: theme.spacing(size === 'large' ? 6 : size === 'small' ? 4 : 5)
  }, _svg[theme.breakpoints.up('lg')] = {
    height: theme.spacing(size === 'large' ? 7 : size === 'small' ? 5 : 6)
  }, _svg), _ref2["& ." + classes.path] = {
    fill: 'currentColor'
  }, _ref2;
});
function HyperaudioConferences(props) {
  return /*#__PURE__*/React__default.createElement(Root, _extends({
    className: classes.root
  }, props, {
    "aria-label": "Hyperaudio Conferences"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: "806",
    height: "275",
    viewBox: "0 0 806 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Hyperaudio Conferences"), /*#__PURE__*/React__default.createElement("path", {
    className: classes.path,
    clipRule: "evenodd",
    fillRule: "evenodd",
    id: "hyperaudio-logo",
    d: "M4.3026 66.3026C7.05751 63.5477 10.794 62 14.69 62C18.586 62 22.3225 63.5477 25.0774 66.3026C27.8323 69.0575 29.38 72.794 29.38 76.69V164.85C29.38 168.746 27.8323 172.482 25.0774 175.237C22.3225 177.992 18.586 179.54 14.69 179.54C10.794 179.54 7.05751 177.992 4.3026 175.237C1.54769 172.482 0 168.746 0 164.85V76.69C0 72.794 1.54769 69.0575 4.3026 66.3026ZM207.33 120.42C204.44 120.361 201.566 120.88 198.879 121.946C196.191 123.012 193.744 124.605 191.68 126.63V98.9C191.723 97.8991 191.568 96.8996 191.224 95.9586C190.881 95.0177 190.355 94.1537 189.677 93.4162C188.999 92.6788 188.182 92.0822 187.273 91.6608C186.364 91.2393 185.381 91.0012 184.38 90.96H184C181.953 90.9333 179.98 91.7195 178.512 93.1461C177.044 94.5727 176.202 96.5233 176.17 98.57V172.1C176.111 174.146 176.867 176.132 178.271 177.621C179.676 179.11 181.614 179.98 183.66 180.04H184C186.022 180.064 187.971 179.284 189.418 177.873C190.866 176.461 191.694 174.532 191.72 172.51V172.1V145.51C191.72 138.95 196.21 134.46 202.54 134.46C208.87 134.46 213.13 138.84 213.13 145.51V172.1C213.097 173.11 213.263 174.117 213.619 175.062C213.975 176.008 214.514 176.875 215.205 177.612C215.896 178.349 216.725 178.943 217.646 179.36C218.566 179.777 219.56 180.008 220.57 180.04H220.84C221.878 180.062 222.91 179.87 223.871 179.475C224.831 179.081 225.7 178.493 226.424 177.748C227.147 177.003 227.709 176.117 228.075 175.146C228.441 174.174 228.603 173.137 228.55 172.1V143.32C228.51 129.51 220.11 120.42 207.33 120.42ZM728.651 107.63C726.836 109.367 724.412 110.323 721.9 110.29C719.376 110.349 716.931 109.404 715.103 107.662C713.275 105.92 712.213 103.524 712.15 101V100.9C712.243 98.3744 713.315 95.9841 715.139 94.235C716.963 92.4858 719.396 91.515 721.923 91.528C724.451 91.541 726.874 92.5367 728.68 94.3046C730.486 96.0724 731.533 98.4736 731.6 101C731.524 103.511 730.465 105.892 728.651 107.63ZM328.76 127.68C332.67 123.07 338.77 120.42 346.14 120.42C362.14 120.42 373.74 132.81 373.74 150.07C373.74 167.33 362.11 179.99 346.11 179.99C339 179.99 333.02 177.46 329.11 173.09V193.09C329.1 194.11 328.888 195.119 328.488 196.057C328.088 196.996 327.507 197.847 326.778 198.561C326.049 199.275 325.186 199.838 324.24 200.219C323.293 200.6 322.281 200.79 321.26 200.78C320.24 200.769 319.232 200.558 318.293 200.158C317.354 199.758 316.504 199.177 315.789 198.448C315.075 197.719 314.512 196.856 314.131 195.91C313.75 194.963 313.56 193.95 313.57 192.93V127.73C313.588 126.736 313.802 125.756 314.2 124.845C314.597 123.934 315.171 123.11 315.887 122.421C316.603 121.732 317.448 121.191 318.373 120.829C319.299 120.466 320.287 120.29 321.28 120.31C323.248 120.299 325.14 121.069 326.542 122.45C327.944 123.831 328.742 125.712 328.76 127.68ZM328.88 150.12C328.88 159.44 334.75 165.88 343.26 165.88C351.78 165.88 358 159.46 358 150.23C358 141 351.89 134.46 343.26 134.46C334.63 134.46 328.88 140.8 328.88 150.12ZM621.11 128.25V153.57C621.11 169.22 610.29 180 594.98 180.04C579.44 180.04 568.62 169.22 568.62 153.57V128.09C568.641 126.029 569.48 124.061 570.952 122.619C572.425 121.177 574.409 120.379 576.47 120.4C578.531 120.421 580.499 121.26 581.941 122.732C583.383 124.205 584.181 126.189 584.16 128.25V154.83C584.16 161.16 588.77 165.77 594.98 165.77C601.19 165.77 605.57 161.16 605.57 154.83V128.09C605.591 126.029 606.43 124.061 607.902 122.619C609.375 121.177 611.359 120.379 613.42 120.4C615.481 120.421 617.449 121.26 618.891 122.732C620.333 124.205 621.131 126.189 621.11 128.25ZM472.75 150.23C472.75 141.48 477.81 136.07 486.1 135.5C490.47 135.04 493.35 132.16 493.35 128.02C493.402 127.087 493.257 126.154 492.924 125.281C492.59 124.408 492.076 123.615 491.416 122.954C490.755 122.294 489.962 121.78 489.089 121.447C488.217 121.113 487.283 120.968 486.35 121.02C483.703 121.034 481.089 121.616 478.686 122.727C476.283 123.838 474.146 125.452 472.42 127.46C472.305 125.558 471.466 123.772 470.074 122.47C468.683 121.168 466.846 120.449 464.94 120.46C463.942 120.444 462.951 120.625 462.023 120.992C461.094 121.36 460.248 121.906 459.531 122.601C458.814 123.295 458.241 124.124 457.844 125.041C457.448 125.957 457.236 126.942 457.22 127.94V128.29V172.1C457.169 174.138 457.927 176.114 459.329 177.594C460.731 179.075 462.662 179.94 464.7 180H465C466.002 180.012 466.997 179.826 467.927 179.454C468.857 179.081 469.705 178.529 470.422 177.829C471.139 177.129 471.711 176.294 472.105 175.373C472.499 174.452 472.708 173.462 472.72 172.46V150.23H472.75ZM438.363 166.182C438.662 166.932 438.811 167.733 438.8 168.54C438.8 171.07 437.65 172.91 434.89 174.71C429.522 178.229 423.228 180.07 416.81 180C398.86 180 385.62 167.11 385.62 150.19C385.62 133.27 398.4 120.38 415.2 120.38C430.74 120.38 442.25 131.66 442.25 147.09V147.43C442.25 152.27 438.8 155.37 433.73 155.37H401.28C403.12 162.51 408.87 166.65 417.28 166.65C421.463 166.667 425.568 165.513 429.13 163.32C430.125 162.675 431.284 162.328 432.47 162.32H432.73C433.537 162.329 434.335 162.497 435.077 162.815C435.819 163.133 436.491 163.594 437.055 164.171C437.619 164.749 438.063 165.432 438.363 166.182ZM427.17 144.51C426.94 137.71 422.11 133 414.85 133C408.06 133 403 137.45 401.27 144.51H427.17ZM551.36 144.82C551.36 129.28 542.36 120.42 526.73 120.42C518.44 120.42 510.96 122.95 506.13 127.42C504.06 129.42 502.91 131.42 502.91 133.63C502.927 134.48 503.111 135.318 503.452 136.096C503.793 136.875 504.284 137.579 504.897 138.167C505.509 138.756 506.232 139.218 507.024 139.528C507.816 139.837 508.66 139.987 509.51 139.97H509.58C511.286 139.921 512.919 139.269 514.19 138.13C517.175 135.398 521.073 133.879 525.12 133.87C532.03 133.87 535.83 137.56 535.83 143.87V146.4H521.55C508.19 146.43 500 152.76 500 163C500 173.24 508 180 519.69 180C526.48 180 532.23 177.81 536.38 173.9C536.736 175.735 537.758 177.374 539.25 178.5C540.742 179.626 542.598 180.161 544.46 180.001C546.323 179.841 548.06 178.997 549.337 177.632C550.615 176.268 551.343 174.479 551.38 172.61V172.17L551.36 144.82ZM535.82 157.36C535.82 163.81 530.64 168.64 523.82 168.64C518.76 168.64 515.65 166.23 515.65 162.43C515.65 158.63 518.41 156.67 523.59 156.67H535.79L535.82 157.36ZM775.23 120.42C792.26 120.42 805.84 133.54 805.84 150.12C805.84 166.69 792.14 179.93 775.11 179.93C758.08 179.93 744.72 166.82 744.72 150.12C744.72 133.42 758.2 120.42 775.23 120.42ZM760.49 150.23C760.49 159.21 766.71 165.65 775.23 165.65C783.63 165.65 790 159.21 790 150.23C790 141.25 783.75 134.58 775.23 134.58C766.71 134.58 760.49 141.25 760.49 150.23ZM293.08 120.42C291.626 120.39 290.196 120.789 288.968 121.566C287.739 122.343 286.766 123.464 286.17 124.79L270.75 158.52L255.67 124.79C255.108 123.464 254.16 122.338 252.948 121.558C251.737 120.779 250.32 120.382 248.88 120.42C246.889 120.43 244.981 121.218 243.563 122.615C242.145 124.013 241.329 125.909 241.29 127.9C241.322 129.189 241.665 130.452 242.29 131.58L262 175L259.93 179.6C257.4 184.78 254.06 186.86 249.11 186.86C248.962 186.86 248.793 186.837 248.6 186.812L248.6 186.812H248.6C248.348 186.779 248.058 186.74 247.73 186.74C245.941 186.672 244.198 187.318 242.886 188.535C241.573 189.752 240.797 191.441 240.73 193.23C240.725 193.293 240.725 193.357 240.73 193.42C240.715 194.709 241.079 195.973 241.775 197.058C242.472 198.142 243.472 198.998 244.65 199.52C246.722 200.401 248.958 200.831 251.21 200.78C261.56 200.78 268.47 195.49 274.57 182.94L299.66 131.49C300.271 130.4 300.588 129.17 300.58 127.92C300.551 125.94 299.752 124.049 298.352 122.648C296.951 121.248 295.06 120.448 293.08 120.42ZM682.979 177.915C681.568 176.569 680.721 174.737 680.61 172.79C676.7 177.39 670.6 180 663.23 180C647.23 180 635.65 167.49 635.65 150.23C635.65 132.97 647.27 120.42 663.27 120.42C670.37 120.42 676.36 122.95 680.27 127.21V98.95V98.61C680.284 97.5962 680.498 96.5951 680.899 95.6639C681.301 94.7328 681.881 93.8898 682.609 93.1831C683.336 92.4764 684.195 91.9199 685.137 91.5453C686.079 91.1708 687.086 90.9855 688.1 91H688.5C690.514 91.0859 692.413 91.9644 693.782 93.4442C695.151 94.924 695.88 96.8851 695.81 98.9V172.21V172.64C695.797 173.625 695.59 174.598 695.201 175.503C694.812 176.408 694.248 177.227 693.543 177.914C692.837 178.601 692.003 179.143 691.088 179.508C690.173 179.872 689.195 180.053 688.21 180.04C686.26 180.02 684.39 179.261 682.979 177.915ZM666.11 134.46C657.59 134.46 651.38 141.12 651.38 150.12C651.38 159.32 657.48 165.88 666.11 165.88C674.74 165.88 680.5 159.55 680.5 150.23C680.5 140.91 674.63 134.46 666.11 134.46ZM722 120.39C720.98 120.379 719.968 120.57 719.022 120.951C718.076 121.332 717.214 121.895 716.486 122.61C715.758 123.324 715.177 124.175 714.778 125.113C714.379 126.052 714.169 127.06 714.16 128.08C714.154 128.112 714.151 128.145 714.153 128.178C714.153 128.191 714.154 128.204 714.156 128.218L714.158 128.231L714.16 128.24V172.1C714.126 173.11 714.292 174.117 714.648 175.062C715.004 176.008 715.543 176.875 716.234 177.612C716.925 178.349 717.755 178.943 718.675 179.36C719.596 179.777 720.59 180.008 721.6 180.04H721.87C723.917 180.067 725.89 179.281 727.358 177.854C728.826 176.427 729.668 174.477 729.7 172.43V172.1V128.24C729.71 127.219 729.52 126.205 729.138 125.258C728.757 124.311 728.192 123.448 727.477 122.719C726.762 121.99 725.91 121.409 724.97 121.009C724.031 120.61 723.021 120.399 722 120.39ZM102.85 150.15C99.9423 150.148 97.0993 151.009 94.6805 152.623C92.2618 154.237 90.3761 156.532 89.262 159.218C88.1478 161.904 87.8553 164.86 88.4214 167.712C88.9875 170.564 90.3867 173.184 92.4421 175.241C94.4976 177.298 97.1168 178.699 99.9686 179.267C102.82 179.835 105.777 179.544 108.463 178.432C111.15 177.32 113.446 175.436 115.062 173.018C116.678 170.6 117.54 167.758 117.54 164.85C117.541 162.92 117.162 161.009 116.425 159.225C115.687 157.442 114.605 155.821 113.241 154.456C111.877 153.091 110.257 152.008 108.474 151.269C106.691 150.53 104.78 150.15 102.85 150.15ZM48.3783 110.378C51.1345 107.622 54.872 106.073 58.7698 106.07C62.6668 106.073 66.4032 107.623 69.1578 110.379C71.9125 113.136 73.4598 116.873 73.4598 120.77V164.85C73.3599 168.681 71.7678 172.322 69.0229 174.996C66.2779 177.67 62.5971 179.167 58.7648 179.167C54.9325 179.167 51.2517 177.67 48.5068 174.996C45.7618 172.322 44.1698 168.681 44.0698 164.85V120.77C44.0725 116.872 45.6221 113.135 48.3783 110.378ZM451.14 236.62C452.941 236.594 454.724 236.992 456.343 237.783C457.962 238.573 459.372 239.733 460.46 241.17C460.639 241.404 460.871 241.593 461.137 241.722C461.403 241.85 461.695 241.915 461.99 241.91C462.431 241.916 462.857 241.748 463.177 241.443C463.496 241.139 463.684 240.721 463.7 240.28C463.659 239.704 463.414 239.162 463.01 238.75C461.552 237.013 459.726 235.621 457.665 234.675C455.603 233.729 453.358 233.253 451.09 233.28C448.979 233.227 446.88 233.597 444.915 234.368C442.95 235.139 441.159 236.295 439.647 237.769C438.136 239.243 436.935 241.004 436.115 242.949C435.295 244.894 434.872 246.984 434.872 249.095C434.872 251.206 435.295 253.296 436.115 255.241C436.935 257.186 438.136 258.947 439.647 260.421C441.159 261.895 442.95 263.051 444.915 263.822C446.88 264.593 448.979 264.963 451.09 264.91C453.358 264.951 455.607 264.48 457.669 263.534C459.731 262.587 461.553 261.187 463 259.44C463.404 259.028 463.649 258.486 463.69 257.91C463.674 257.469 463.486 257.051 463.167 256.747C462.847 256.442 462.421 256.275 461.98 256.28C461.684 256.277 461.392 256.344 461.126 256.474C460.86 256.604 460.629 256.795 460.45 257.03C459.353 258.455 457.94 259.607 456.323 260.395C454.706 261.183 452.928 261.585 451.13 261.57C447.882 261.478 444.799 260.123 442.534 257.794C440.27 255.464 439.003 252.344 439.003 249.095C439.003 245.846 440.27 242.726 442.534 240.396C444.799 238.067 447.882 236.712 451.13 236.62H451.14ZM479.845 235.99C482.435 234.241 485.485 233.298 488.61 233.28C490.7 233.248 492.776 233.634 494.715 234.417C496.654 235.2 498.417 236.362 499.9 237.836C501.382 239.311 502.555 241.067 503.348 243.001C504.142 244.936 504.54 247.009 504.52 249.1C504.52 252.225 503.594 255.28 501.86 257.88C500.125 260.479 497.66 262.507 494.775 263.707C491.889 264.907 488.713 265.225 485.647 264.622C482.58 264.019 479.761 262.521 477.545 260.318C475.329 258.114 473.815 255.304 473.195 252.241C472.574 249.178 472.875 246 474.058 243.108C475.242 240.216 477.256 237.739 479.845 235.99ZM476.51 249.05C476.51 256.24 481.66 261.57 488.66 261.57C495.57 261.57 500.76 256.15 500.76 249.05C500.76 241.95 495.62 236.62 488.66 236.62C481.7 236.62 476.51 241.86 476.51 249.05ZM538.19 233.28C537.946 233.284 537.705 233.336 537.481 233.434C537.257 233.532 537.055 233.674 536.887 233.851C536.718 234.028 536.587 234.236 536.5 234.464C536.413 234.693 536.372 234.936 536.38 235.18V257.58L519.08 234.49C518.43 233.61 517.97 233.28 517.36 233.28C516.904 233.292 516.469 233.476 516.143 233.795C515.816 234.114 515.622 234.544 515.6 235V263C515.588 263.245 515.625 263.49 515.711 263.72C515.796 263.95 515.928 264.161 516.097 264.338C516.266 264.516 516.47 264.658 516.696 264.754C516.922 264.851 517.164 264.9 517.41 264.9C517.654 264.896 517.895 264.844 518.119 264.746C518.343 264.648 518.545 264.506 518.713 264.329C518.882 264.153 519.013 263.944 519.1 263.716C519.187 263.487 519.228 263.244 519.22 263V240.6L536.66 264C536.833 264.265 537.064 264.487 537.336 264.648C537.609 264.81 537.914 264.906 538.23 264.93C538.698 264.93 539.146 264.745 539.478 264.415C539.81 264.085 539.997 263.638 540 263.17V235.17C540.011 234.926 539.972 234.682 539.886 234.453C539.8 234.224 539.668 234.015 539.499 233.838C539.33 233.661 539.127 233.521 538.902 233.425C538.677 233.329 538.435 233.28 538.19 233.28ZM555 233.79H570.75C571.171 233.8 571.573 233.97 571.874 234.265C572.175 234.56 572.352 234.959 572.37 235.38C572.369 235.597 572.324 235.811 572.239 236.01C572.154 236.209 572.03 236.39 571.875 236.54C571.719 236.691 571.535 236.81 571.334 236.889C571.132 236.967 570.917 237.005 570.7 237H556.7V247.57H568.12C568.347 247.552 568.575 247.582 568.79 247.656C569.005 247.731 569.202 247.849 569.369 248.004C569.536 248.158 569.669 248.346 569.76 248.554C569.851 248.762 569.898 248.988 569.898 249.215C569.898 249.442 569.851 249.668 569.76 249.876C569.669 250.084 569.536 250.272 569.369 250.426C569.202 250.581 569.005 250.699 568.79 250.774C568.575 250.848 568.347 250.878 568.12 250.86H556.72V263C556.728 263.244 556.687 263.487 556.6 263.716C556.513 263.944 556.382 264.153 556.213 264.329C556.045 264.506 555.843 264.648 555.619 264.746C555.395 264.844 555.154 264.896 554.91 264.9C554.664 264.9 554.422 264.851 554.196 264.754C553.97 264.658 553.766 264.516 553.597 264.338C553.428 264.161 553.296 263.95 553.211 263.72C553.125 263.49 553.088 263.245 553.1 263V235.69C553.094 235.439 553.14 235.189 553.233 234.956C553.327 234.724 553.467 234.512 553.644 234.334C553.822 234.157 554.033 234.017 554.266 233.924C554.499 233.83 554.749 233.785 555 233.79ZM600.71 261.15H585.63V249.65H596.44C596.876 249.655 597.296 249.488 597.609 249.184C597.922 248.881 598.102 248.466 598.11 248.03C598.11 247.813 598.067 247.598 597.982 247.398C597.898 247.198 597.774 247.018 597.618 246.866C597.462 246.715 597.278 246.597 597.075 246.519C596.873 246.44 596.657 246.403 596.44 246.41H585.63V237H600.15C600.367 237.007 600.583 236.97 600.785 236.891C600.988 236.813 601.172 236.695 601.328 236.544C601.484 236.392 601.608 236.212 601.692 236.012C601.777 235.812 601.82 235.597 601.82 235.38C601.817 235.163 601.772 234.949 601.687 234.75C601.601 234.551 601.478 234.37 601.323 234.219C601.168 234.068 600.984 233.948 600.783 233.868C600.582 233.787 600.367 233.747 600.15 233.75H583.69C583.469 233.745 583.25 233.784 583.044 233.866C582.839 233.948 582.653 234.071 582.497 234.227C582.341 234.383 582.218 234.569 582.136 234.774C582.054 234.98 582.015 235.199 582.02 235.42V262.69C582.015 262.911 582.054 263.13 582.136 263.336C582.218 263.541 582.341 263.727 582.497 263.883C582.653 264.039 582.839 264.162 583.044 264.244C583.25 264.326 583.469 264.366 583.69 264.36H600.69C601.124 264.363 601.542 264.194 601.853 263.891C602.163 263.588 602.342 263.174 602.35 262.74C602.342 262.312 602.165 261.905 601.858 261.607C601.551 261.309 601.138 261.145 600.71 261.15ZM631.843 247.868C630.742 249.381 629.168 250.483 627.37 251L635.43 261.91C635.786 262.29 636.001 262.781 636.04 263.3C636.036 263.521 635.988 263.738 635.899 263.94C635.81 264.142 635.682 264.324 635.522 264.476C635.362 264.628 635.173 264.746 634.967 264.824C634.76 264.902 634.54 264.938 634.32 264.93C633.998 264.898 633.688 264.791 633.415 264.617C633.143 264.444 632.915 264.208 632.75 263.93L623.52 251.55H616.52V263.05C616.524 263.291 616.48 263.531 616.391 263.755C616.302 263.979 616.17 264.184 616.002 264.356C615.833 264.529 615.633 264.667 615.411 264.762C615.189 264.857 614.951 264.907 614.71 264.91C614.468 264.912 614.227 264.864 614.004 264.77C613.78 264.677 613.578 264.539 613.409 264.365C613.24 264.192 613.108 263.986 613.02 263.76C612.933 263.534 612.892 263.292 612.9 263.05V235.65C612.897 235.405 612.943 235.162 613.036 234.935C613.129 234.708 613.266 234.502 613.439 234.329C613.612 234.156 613.818 234.019 614.045 233.926C614.272 233.834 614.515 233.787 614.76 233.79H623.66C629.51 233.79 633.45 237.36 633.45 242.65C633.51 244.52 632.944 246.356 631.843 247.868ZM616.52 237V248.31L623.52 248.27C627.37 248.27 629.69 246.1 629.69 242.66C629.69 239.22 627.33 237 623.52 237H616.52ZM665.08 261.15H650V249.65H660.8C661.236 249.655 661.656 249.488 661.969 249.184C662.282 248.881 662.462 248.466 662.47 248.03C662.47 247.813 662.427 247.598 662.342 247.398C662.258 247.198 662.134 247.018 661.978 246.866C661.822 246.715 661.638 246.597 661.435 246.519C661.233 246.44 661.017 246.403 660.8 246.41H650V237H664.51C664.727 237.007 664.943 236.97 665.145 236.891C665.348 236.813 665.532 236.695 665.688 236.544C665.844 236.392 665.968 236.212 666.052 236.012C666.137 235.812 666.18 235.597 666.18 235.38C666.177 235.163 666.132 234.949 666.047 234.75C665.962 234.551 665.838 234.37 665.683 234.219C665.528 234.068 665.344 233.948 665.143 233.868C664.942 233.787 664.727 233.747 664.51 233.75H648.06C647.839 233.745 647.62 233.784 647.415 233.866C647.21 233.948 647.023 234.071 646.867 234.227C646.711 234.383 646.588 234.569 646.506 234.774C646.424 234.98 646.385 235.199 646.39 235.42V262.69C646.385 262.911 646.424 263.13 646.506 263.336C646.588 263.541 646.711 263.727 646.867 263.883C647.023 264.039 647.21 264.162 647.415 264.244C647.62 264.326 647.839 264.366 648.06 264.36H665.06C665.495 264.363 665.914 264.195 666.226 263.892C666.539 263.589 666.72 263.175 666.73 262.74C666.72 262.311 666.541 261.904 666.232 261.606C665.923 261.309 665.509 261.145 665.08 261.15ZM699.151 233.434C699.375 233.336 699.616 233.284 699.86 233.28C700.105 233.28 700.347 233.329 700.572 233.425C700.797 233.521 701 233.661 701.169 233.838C701.338 234.015 701.47 234.224 701.556 234.453C701.642 234.682 701.681 234.926 701.67 235.17V263.17C701.67 263.637 701.485 264.084 701.155 264.415C700.825 264.745 700.377 264.93 699.91 264.93C699.593 264.907 699.286 264.811 699.012 264.649C698.737 264.488 698.504 264.266 698.33 264L680.89 240.64V263.04C680.898 263.284 680.857 263.527 680.77 263.756C680.683 263.984 680.552 264.193 680.383 264.369C680.215 264.546 680.013 264.688 679.789 264.786C679.565 264.884 679.324 264.936 679.08 264.94C678.835 264.94 678.593 264.891 678.367 264.794C678.142 264.697 677.939 264.556 677.771 264.378C677.602 264.2 677.472 263.99 677.387 263.76C677.303 263.53 677.267 263.285 677.28 263.04V235.04C677.291 234.57 677.485 234.122 677.821 233.793C678.158 233.464 678.61 233.28 679.08 233.28C679.69 233.28 680.15 233.61 680.8 234.49L698.1 257.58L698.05 235.18C698.042 234.936 698.083 234.693 698.17 234.464C698.257 234.236 698.388 234.028 698.557 233.851C698.725 233.674 698.927 233.532 699.151 233.434ZM728.71 236.62C730.512 236.594 732.294 236.992 733.913 237.783C735.532 238.573 736.943 239.733 738.03 241.17C738.21 241.404 738.442 241.593 738.707 241.722C738.973 241.85 739.265 241.915 739.56 241.91C740.002 241.916 740.428 241.748 740.747 241.443C741.067 241.139 741.255 240.721 741.27 240.28C741.229 239.704 740.985 239.162 740.58 238.75C739.122 237.013 737.296 235.621 735.235 234.675C733.174 233.729 730.928 233.253 728.66 233.28C726.55 233.227 724.45 233.597 722.485 234.368C720.52 235.139 718.729 236.295 717.217 237.769C715.706 239.243 714.505 241.004 713.685 242.949C712.865 244.894 712.442 246.984 712.442 249.095C712.442 251.206 712.865 253.296 713.685 255.241C714.505 257.186 715.706 258.947 717.217 260.421C718.729 261.895 720.52 263.051 722.485 263.822C724.45 264.593 726.55 264.963 728.66 264.91C730.93 264.952 733.181 264.483 735.245 263.536C737.308 262.589 739.132 261.189 740.58 259.44C740.985 259.028 741.229 258.486 741.27 257.91C741.255 257.469 741.067 257.051 740.747 256.747C740.428 256.442 740.002 256.275 739.56 256.28C739.262 256.269 738.965 256.329 738.694 256.454C738.423 256.579 738.185 256.766 738 257C736.903 258.425 735.491 259.577 733.873 260.365C732.256 261.153 730.479 261.555 728.68 261.54C725.433 261.448 722.349 260.093 720.085 257.764C717.82 255.434 716.553 252.314 716.553 249.065C716.553 245.816 717.82 242.696 720.085 240.366C722.349 238.037 725.433 236.682 728.68 236.59L728.71 236.62ZM756.16 261.15H771.24C771.668 261.145 772.081 261.309 772.388 261.607C772.695 261.905 772.872 262.312 772.88 262.74C772.872 263.174 772.693 263.588 772.383 263.891C772.072 264.194 771.654 264.363 771.22 264.36H754.22C753.999 264.366 753.779 264.326 753.574 264.244C753.369 264.162 753.183 264.039 753.027 263.883C752.871 263.727 752.748 263.541 752.666 263.336C752.584 263.13 752.544 262.911 752.55 262.69V235.42C752.544 235.199 752.584 234.98 752.666 234.774C752.748 234.569 752.871 234.383 753.027 234.227C753.183 234.071 753.369 233.948 753.574 233.866C753.779 233.784 753.999 233.745 754.22 233.75H770.68C770.896 233.747 771.112 233.787 771.313 233.868C771.514 233.948 771.697 234.068 771.852 234.219C772.008 234.37 772.131 234.551 772.217 234.75C772.302 234.949 772.347 235.163 772.35 235.38C772.35 235.597 772.306 235.812 772.222 236.012C772.137 236.212 772.014 236.392 771.858 236.544C771.702 236.695 771.518 236.813 771.315 236.891C771.113 236.97 770.897 237.007 770.68 237H756.16V246.41H767C767.217 246.403 767.433 246.44 767.635 246.519C767.838 246.597 768.022 246.715 768.178 246.866C768.334 247.018 768.457 247.198 768.542 247.398C768.626 247.598 768.67 247.813 768.67 248.03C768.662 248.466 768.482 248.881 768.169 249.184C767.856 249.488 767.436 249.655 767 249.65H756.16V261.15ZM795.12 247.84L791.74 246.22C787.74 244.32 786.82 243.22 786.82 241.07C786.82 238.38 789 236.62 792.25 236.62C793.42 236.622 794.575 236.876 795.638 237.364C796.701 237.852 797.647 238.564 798.41 239.45C798.568 239.628 798.76 239.773 798.975 239.876C799.189 239.979 799.422 240.038 799.66 240.05C800.097 240.041 800.515 239.871 800.832 239.572C801.15 239.272 801.346 238.865 801.38 238.43C801.366 237.87 801.133 237.339 800.73 236.95C799.672 235.765 798.369 234.823 796.912 234.19C795.456 233.556 793.879 233.246 792.29 233.28C787.01 233.28 783.06 236.67 783.06 241.28C783.06 244.71 785.06 247.17 789.97 249.49L793.4 251.11C797.4 252.96 798.51 254.22 798.51 256.49C798.51 259.49 796.05 261.59 792.34 261.59C790.847 261.568 789.379 261.195 788.057 260.5C786.735 259.805 785.595 258.808 784.73 257.59C784.602 257.39 784.433 257.22 784.235 257.089C784.037 256.958 783.814 256.87 783.58 256.83C783.346 256.79 783.107 256.799 782.876 256.856C782.646 256.914 782.43 257.019 782.243 257.165C782.055 257.31 781.9 257.493 781.788 257.702C781.675 257.911 781.607 258.141 781.588 258.378C781.568 258.614 781.599 258.852 781.677 259.077C781.755 259.301 781.878 259.506 782.04 259.68C783.25 261.284 784.811 262.59 786.603 263.498C788.395 264.406 790.371 264.892 792.38 264.92C798.23 264.92 802.26 261.39 802.26 256.39C802.26 252.71 800.27 250.3 795.12 247.84ZM407.415 239.485C407.742 239.813 407.927 240.257 407.93 240.72C407.925 241.199 407.735 241.657 407.4 242L400.17 249.27L407.4 256.5C407.719 256.853 407.906 257.305 407.93 257.78C407.934 258.014 407.892 258.246 407.806 258.463C407.72 258.681 407.592 258.879 407.43 259.047C407.267 259.216 407.073 259.35 406.859 259.443C406.645 259.536 406.414 259.586 406.18 259.59C405.938 259.582 405.7 259.525 405.481 259.424C405.261 259.323 405.063 259.178 404.9 259L397.67 251.73L390.44 258.96C390.201 259.218 389.889 259.398 389.546 259.474C389.202 259.551 388.844 259.521 388.518 259.388C388.192 259.256 387.914 259.027 387.721 258.733C387.529 258.438 387.431 258.092 387.44 257.74C387.464 257.265 387.652 256.813 387.97 256.46L395.2 249.23L387.97 242C387.635 241.657 387.445 241.199 387.44 240.72C387.446 240.375 387.554 240.039 387.752 239.756C387.949 239.472 388.226 239.254 388.548 239.129C388.869 239.003 389.221 238.976 389.558 239.051C389.895 239.126 390.202 239.3 390.44 239.55L397.67 246.73L404.9 239.55C405.064 239.373 405.262 239.23 405.481 239.131C405.701 239.031 405.939 238.976 406.18 238.97C406.643 238.973 407.087 239.158 407.415 239.485Z"
  })));
}

var PREFIX$1 = "HyperaudioMain";
var classes$1 = {
  root: PREFIX$1 + "-root",
  path: PREFIX$1 + "-path"
};
var Root$1 = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'fill'].includes(prop);
  }
})(function (_ref) {
  var _svg, _ref2;

  var theme = _ref.theme,
      size = _ref.size;
  return _ref2 = {
    display: 'inline-block',
    lineHeight: 0
  }, _ref2["& svg"] = (_svg = {
    width: 'auto',
    height: theme.spacing(size === 'large' ? 6 : size === 'small' ? 4 : 5)
  }, _svg[theme.breakpoints.up('lg')] = {
    height: theme.spacing(size === 'large' ? 7 : size === 'small' ? 5 : 6)
  }, _svg), _ref2["& ." + classes$1.path] = {
    fill: 'currentColor'
  }, _ref2;
});
function HyperaudioMain(props) {
  return /*#__PURE__*/React__default.createElement(Root$1, _extends({
    className: classes$1.root
  }, props, {
    "aria-label": "Hyperaudio"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: "806",
    height: "275",
    viewBox: "0 0 806 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Hyperaudio"), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: "hyperaudio-logo",
    className: classes$1.path,
    d: "M4.3026 66.3026C7.05751 63.5477 10.794 62 14.69 62C18.586 62 22.3225 63.5477 25.0774 66.3026C27.8323 69.0575 29.38 72.794 29.38 76.69V164.85C29.38 168.746 27.8323 172.482 25.0774 175.237C22.3225 177.992 18.586 179.54 14.69 179.54C10.794 179.54 7.05751 177.992 4.3026 175.237C1.54769 172.482 0 168.746 0 164.85V76.69C0 72.794 1.54769 69.0575 4.3026 66.3026ZM207.33 120.42C204.44 120.361 201.566 120.88 198.879 121.946C196.191 123.012 193.744 124.605 191.68 126.63V98.9C191.723 97.8991 191.568 96.8996 191.224 95.9586C190.881 95.0177 190.355 94.1537 189.677 93.4162C188.999 92.6788 188.182 92.0822 187.273 91.6608C186.364 91.2393 185.381 91.0012 184.38 90.96H184C181.953 90.9333 179.98 91.7195 178.512 93.1461C177.044 94.5727 176.202 96.5233 176.17 98.57V172.1C176.111 174.146 176.867 176.132 178.271 177.621C179.676 179.11 181.614 179.98 183.66 180.04H184C186.022 180.064 187.971 179.284 189.418 177.873C190.866 176.461 191.694 174.532 191.72 172.51V172.1V145.51C191.72 138.95 196.21 134.46 202.54 134.46C208.87 134.46 213.13 138.84 213.13 145.51V172.1C213.097 173.11 213.263 174.117 213.619 175.062C213.975 176.008 214.514 176.875 215.205 177.612C215.896 178.349 216.725 178.943 217.646 179.36C218.566 179.777 219.56 180.008 220.57 180.04H220.84C221.878 180.062 222.91 179.87 223.871 179.475C224.831 179.081 225.7 178.493 226.424 177.748C227.147 177.003 227.709 176.117 228.075 175.146C228.441 174.174 228.603 173.137 228.55 172.1V143.32C228.51 129.51 220.11 120.42 207.33 120.42ZM728.651 107.63C726.837 109.367 724.412 110.323 721.9 110.29C719.376 110.349 716.931 109.404 715.103 107.662C713.275 105.92 712.213 103.524 712.15 101V100.9C712.243 98.3744 713.315 95.9841 715.139 94.235C716.963 92.4858 719.397 91.515 721.924 91.528C724.451 91.541 726.874 92.5367 728.68 94.3046C730.486 96.0724 731.533 98.4736 731.6 101C731.524 103.511 730.465 105.892 728.651 107.63ZM328.76 127.68C332.67 123.07 338.77 120.42 346.14 120.42C362.14 120.42 373.74 132.81 373.74 150.07C373.74 167.33 362.11 179.99 346.11 179.99C339 179.99 333.02 177.46 329.11 173.09V193.09C329.099 194.11 328.888 195.119 328.488 196.057C328.087 196.996 327.506 197.847 326.777 198.561C326.048 199.275 325.186 199.838 324.239 200.219C323.293 200.6 322.28 200.79 321.26 200.78C320.239 200.769 319.231 200.558 318.292 200.158C317.354 199.758 316.503 199.177 315.789 198.448C315.075 197.719 314.511 196.856 314.131 195.91C313.75 194.963 313.559 193.95 313.57 192.93V127.73C313.588 126.736 313.802 125.756 314.199 124.845C314.597 123.934 315.17 123.11 315.886 122.421C316.602 121.732 317.447 121.191 318.373 120.829C319.298 120.466 320.286 120.29 321.28 120.31C323.248 120.299 325.14 121.069 326.542 122.45C327.944 123.831 328.741 125.712 328.76 127.68ZM328.88 150.12C328.88 159.44 334.75 165.88 343.26 165.88C351.78 165.88 358 159.46 358 150.23C358 141 351.89 134.46 343.26 134.46C334.63 134.46 328.88 140.8 328.88 150.12ZM621.11 128.25V153.57C621.11 169.22 610.29 180 594.98 180.04C579.44 180.04 568.62 169.22 568.62 153.57V128.09C568.641 126.029 569.48 124.061 570.952 122.619C572.425 121.177 574.409 120.379 576.47 120.4C578.531 120.421 580.499 121.26 581.941 122.732C583.383 124.205 584.181 126.189 584.16 128.25V154.83C584.16 161.16 588.77 165.77 594.98 165.77C601.19 165.77 605.57 161.16 605.57 154.83V128.09C605.591 126.029 606.43 124.061 607.902 122.619C609.375 121.177 611.359 120.379 613.42 120.4C615.481 120.421 617.449 121.26 618.891 122.732C620.333 124.205 621.131 126.189 621.11 128.25ZM472.75 150.23C472.75 141.48 477.81 136.07 486.1 135.5C490.47 135.04 493.35 132.16 493.35 128.02C493.402 127.087 493.257 126.154 492.924 125.281C492.59 124.408 492.076 123.615 491.416 122.954C490.755 122.294 489.962 121.78 489.089 121.447C488.217 121.113 487.283 120.968 486.35 121.02C483.703 121.034 481.089 121.616 478.686 122.727C476.283 123.838 474.146 125.452 472.42 127.46C472.305 125.558 471.466 123.772 470.074 122.47C468.683 121.168 466.846 120.449 464.94 120.46C463.942 120.444 462.951 120.625 462.023 120.992C461.094 121.36 460.248 121.906 459.531 122.601C458.814 123.295 458.241 124.124 457.844 125.041C457.448 125.957 457.236 126.942 457.22 127.94V128.29V172.1C457.169 174.138 457.927 176.114 459.329 177.594C460.731 179.075 462.662 179.94 464.7 180H465C466.002 180.012 466.997 179.826 467.927 179.454C468.857 179.081 469.705 178.529 470.422 177.829C471.139 177.129 471.711 176.294 472.105 175.373C472.499 174.452 472.708 173.462 472.72 172.46V150.23H472.75ZM438.363 166.182C438.662 166.932 438.811 167.733 438.8 168.54C438.8 171.07 437.65 172.91 434.89 174.71C429.522 178.229 423.228 180.07 416.81 180C398.86 180 385.62 167.11 385.62 150.19C385.62 133.27 398.4 120.38 415.2 120.38C430.74 120.38 442.25 131.66 442.25 147.09V147.43C442.25 152.27 438.8 155.37 433.73 155.37H401.28C403.12 162.51 408.87 166.65 417.28 166.65C421.463 166.667 425.568 165.513 429.13 163.32C430.125 162.675 431.284 162.328 432.47 162.32H432.73C433.537 162.329 434.335 162.497 435.077 162.815C435.819 163.133 436.491 163.594 437.055 164.171C437.619 164.749 438.063 165.432 438.363 166.182ZM427.17 144.51C426.94 137.71 422.11 133 414.85 133C408.06 133 403 137.45 401.27 144.51H427.17ZM551.36 144.82C551.36 129.28 542.36 120.42 526.73 120.42C518.44 120.42 510.96 122.95 506.13 127.42C504.06 129.42 502.91 131.42 502.91 133.63C502.927 134.48 503.111 135.318 503.452 136.096C503.793 136.875 504.284 137.579 504.897 138.167C505.509 138.756 506.232 139.218 507.024 139.528C507.816 139.837 508.66 139.987 509.51 139.97H509.58C511.286 139.921 512.919 139.269 514.19 138.13C517.175 135.398 521.073 133.879 525.12 133.87C532.03 133.87 535.83 137.56 535.83 143.87V146.4H521.55C508.19 146.43 500 152.76 500 163C500 173.24 508 180 519.69 180C526.48 180 532.23 177.81 536.38 173.9C536.736 175.735 537.758 177.374 539.25 178.5C540.742 179.626 542.598 180.161 544.46 180.001C546.323 179.841 548.06 178.997 549.337 177.632C550.615 176.268 551.343 174.479 551.38 172.61V172.17L551.36 144.82ZM535.82 157.36C535.82 163.81 530.64 168.64 523.82 168.64C518.76 168.64 515.65 166.23 515.65 162.43C515.65 158.63 518.41 156.67 523.59 156.67H535.79L535.82 157.36ZM775.23 120.42C792.26 120.42 805.84 133.54 805.84 150.12C805.84 166.69 792.14 179.93 775.11 179.93C758.08 179.93 744.72 166.82 744.72 150.12C744.72 133.42 758.2 120.42 775.23 120.42ZM760.49 150.23C760.49 159.21 766.71 165.65 775.23 165.65C783.63 165.65 790 159.21 790 150.23C790 141.25 783.75 134.58 775.23 134.58C766.71 134.58 760.49 141.25 760.49 150.23ZM293.08 120.42C291.626 120.39 290.196 120.789 288.968 121.566C287.739 122.343 286.766 123.464 286.17 124.79L270.75 158.52L255.67 124.79C255.108 123.464 254.16 122.338 252.948 121.558C251.737 120.779 250.32 120.382 248.88 120.42C246.889 120.43 244.981 121.218 243.563 122.615C242.145 124.013 241.329 125.909 241.29 127.9C241.322 129.189 241.665 130.452 242.29 131.58L262 175L259.93 179.6C257.4 184.78 254.06 186.86 249.11 186.86C248.962 186.86 248.793 186.837 248.6 186.812L248.6 186.812H248.6C248.348 186.779 248.058 186.74 247.73 186.74C245.941 186.672 244.198 187.318 242.886 188.535C241.573 189.752 240.797 191.441 240.73 193.23C240.725 193.293 240.725 193.357 240.73 193.42C240.715 194.709 241.079 195.973 241.775 197.058C242.472 198.142 243.472 198.998 244.65 199.52C246.722 200.401 248.958 200.831 251.21 200.78C261.56 200.78 268.47 195.49 274.57 182.94L299.66 131.49C300.271 130.4 300.588 129.17 300.58 127.92C300.551 125.94 299.752 124.049 298.352 122.648C296.951 121.248 295.06 120.448 293.08 120.42ZM682.98 177.915C681.569 176.569 680.722 174.737 680.61 172.79C676.7 177.39 670.6 180 663.23 180C647.23 180 635.65 167.49 635.65 150.23C635.65 132.97 647.27 120.42 663.27 120.42C670.37 120.42 676.36 122.95 680.27 127.21V98.95V98.61C680.285 97.5962 680.499 96.5951 680.9 95.6639C681.301 94.7328 681.882 93.8898 682.609 93.1831C683.336 92.4764 684.195 91.9199 685.138 91.5453C686.08 91.1708 687.086 90.9855 688.1 91H688.5C690.515 91.0859 692.413 91.9644 693.783 93.4442C695.152 94.924 695.881 96.8851 695.81 98.9V172.21V172.64C695.797 173.625 695.59 174.598 695.201 175.503C694.812 176.408 694.249 177.227 693.543 177.914C692.837 178.601 692.003 179.143 691.088 179.508C690.173 179.872 689.195 180.053 688.21 180.04C686.26 180.02 684.391 179.261 682.98 177.915ZM666.11 134.46C657.59 134.46 651.38 141.12 651.38 150.12C651.38 159.32 657.48 165.88 666.11 165.88C674.74 165.88 680.5 159.55 680.5 150.23C680.5 140.91 674.63 134.46 666.11 134.46ZM722 120.39C720.98 120.379 719.968 120.57 719.022 120.951C718.076 121.332 717.214 121.895 716.486 122.61C715.758 123.324 715.177 124.175 714.778 125.113C714.379 126.052 714.169 127.06 714.16 128.08C714.154 128.112 714.151 128.145 714.153 128.178C714.153 128.191 714.154 128.204 714.156 128.218L714.158 128.231L714.16 128.24V172.1C714.126 173.11 714.292 174.117 714.648 175.062C715.004 176.008 715.543 176.875 716.234 177.612C716.925 178.349 717.755 178.943 718.675 179.36C719.596 179.777 720.59 180.008 721.6 180.04H721.87C723.917 180.067 725.89 179.281 727.358 177.854C728.826 176.427 729.668 174.477 729.7 172.43V172.1V128.24C729.71 127.219 729.52 126.205 729.138 125.258C728.757 124.311 728.192 123.448 727.477 122.719C726.762 121.99 725.91 121.409 724.97 121.009C724.031 120.61 723.021 120.399 722 120.39ZM102.85 150.15C99.9423 150.148 97.0993 151.009 94.6805 152.623C92.2618 154.237 90.3761 156.532 89.262 159.218C88.1478 161.904 87.8553 164.86 88.4214 167.712C88.9875 170.564 90.3867 173.184 92.4421 175.241C94.4976 177.298 97.1168 178.699 99.9686 179.267C102.82 179.835 105.777 179.544 108.463 178.432C111.15 177.32 113.446 175.436 115.062 173.018C116.678 170.6 117.54 167.758 117.54 164.85C117.541 162.92 117.162 161.009 116.425 159.225C115.687 157.442 114.605 155.821 113.241 154.456C111.877 153.091 110.257 152.008 108.474 151.269C106.691 150.53 104.78 150.15 102.85 150.15ZM48.3783 110.378C51.1345 107.622 54.872 106.073 58.7698 106.07C62.6668 106.073 66.4032 107.623 69.1578 110.379C71.9125 113.136 73.4598 116.873 73.4598 120.77V164.85C73.3599 168.681 71.7678 172.322 69.0229 174.996C66.2779 177.67 62.5971 179.167 58.7648 179.167C54.9325 179.167 51.2517 177.67 48.5068 174.996C45.7618 172.322 44.1698 168.681 44.0698 164.85V120.77C44.0725 116.872 45.6221 113.135 48.3783 110.378Z"
  })));
}

var PREFIX$2 = "HyperaudioPodcasts";
var classes$2 = {
  root: PREFIX$2 + "-root",
  path: PREFIX$2 + "-path"
};
var Root$2 = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'fill'].includes(prop);
  }
})(function (_ref) {
  var _svg, _ref2;

  var theme = _ref.theme,
      size = _ref.size;
  return _ref2 = {
    display: 'inline-block',
    lineHeight: 0
  }, _ref2["& svg"] = (_svg = {
    width: 'auto',
    height: theme.spacing(size === 'large' ? 5 : size === 'small' ? 3 : 4)
  }, _svg[theme.breakpoints.up('lg')] = {
    height: theme.spacing(size === 'large' ? 6 : size === 'small' ? 4 : 5)
  }, _svg), _ref2["& ." + classes$2.path] = {
    fill: 'currentColor'
  }, _ref2;
});
function HyperaudioPodcasts(props) {
  return /*#__PURE__*/React__default.createElement(Root$2, _extends({
    className: classes$2.root
  }, props, {
    "aria-label": "Hyperaudio"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: "806",
    height: "275",
    viewBox: "0 0 806 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Hyperaudio Podcasts"), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: "hyperaudio-logo",
    className: classes$2.path,
    d: "M14.6906 62C10.7944 62 7.05781 63.5482 4.30278 66.304C1.54776 69.0599 0 72.7976 0 76.6949V164.925C0 168.822 1.54776 172.56 4.30278 175.316C7.05781 178.072 10.7944 179.62 14.6906 179.62C18.5856 179.616 22.3199 178.066 25.074 175.311C27.8282 172.556 29.3772 168.821 29.3812 164.925V76.6949C29.3812 72.7976 27.8335 69.0599 25.0785 66.304C22.3234 63.5482 18.5868 62 14.6906 62ZM695.812 98.9045V172.668C695.784 174.64 694.979 176.521 693.573 177.902C692.166 179.284 690.271 180.054 688.3 180.046C686.342 180.048 684.459 179.295 683.043 177.943C681.627 176.592 680.786 174.746 680.696 172.79C676.772 177.399 670.674 180.046 663.314 180.046C647.315 180.046 635.681 167.481 635.681 150.23C635.681 132.98 647.239 120.43 663.237 120.43C666.393 120.314 669.539 120.859 672.472 122.03C675.405 123.201 678.061 124.972 680.27 127.229V98.5698C680.284 97.5557 680.498 96.5542 680.899 95.6228C681.3 94.6914 681.881 93.8483 682.609 93.1418C683.336 92.4353 684.196 91.8792 685.139 91.5055C686.081 91.1318 687.088 90.9477 688.102 90.9638H688.513C689.514 91.0029 690.498 91.2397 691.408 91.6604C692.317 92.0812 693.135 92.6778 693.813 93.4157C694.492 94.1537 695.018 95.0185 695.361 95.9605C695.704 96.9025 695.857 97.903 695.812 98.9045ZM651.36 150.139C651.36 159.357 657.474 165.914 666.096 165.914C674.75 165.914 680.483 159.586 680.483 150.261C680.483 140.936 674.613 134.486 666.096 134.486C657.58 134.486 651.36 141.164 651.36 150.139ZM198.843 121.955C201.541 120.889 204.426 120.376 207.327 120.445C220.101 120.445 228.511 129.526 228.496 143.354V172.136C228.541 173.171 228.375 174.205 228.007 175.174C227.638 176.143 227.076 177.027 226.354 177.77C225.632 178.514 224.765 179.102 223.808 179.499C222.85 179.895 221.822 180.092 220.785 180.076H220.512C218.497 179.974 216.604 179.084 215.239 177.599C213.873 176.114 213.146 174.152 213.212 172.136V145.53C213.212 138.867 208.893 134.486 202.567 134.486C201.112 134.43 199.661 134.68 198.308 135.218C196.955 135.756 195.729 136.571 194.71 137.611C193.69 138.651 192.899 139.893 192.388 141.256C191.876 142.62 191.655 144.075 191.739 145.53V172.059C191.746 172.196 191.746 172.333 191.739 172.47C191.739 173.479 191.538 174.478 191.148 175.409C190.759 176.34 190.188 177.184 189.469 177.892C188.75 178.6 187.897 179.158 186.96 179.533C186.024 179.908 185.022 180.092 184.013 180.076H183.679C181.632 180.017 179.693 179.147 178.287 177.658C176.881 176.169 176.124 174.183 176.181 172.136V98.5699C176.213 96.5229 177.056 94.5724 178.524 93.1463C179.993 91.7203 181.967 90.9354 184.013 90.9638H184.317C185.319 91.0029 186.303 91.2397 187.212 91.6605C188.122 92.0813 188.94 92.6778 189.618 93.4158C190.296 94.1537 190.822 95.0185 191.165 95.9605C191.508 96.9025 191.662 97.903 191.617 98.9045V126.651C193.687 124.618 196.145 123.021 198.843 121.955ZM403.74 122.598C407.367 121.119 411.254 120.387 415.17 120.445C430.742 120.445 442.255 131.717 442.285 147.188V147.492C442.285 152.405 438.833 155.448 433.769 155.448H401.316C403.156 162.582 408.904 166.72 417.314 166.72C421.496 166.734 425.599 165.581 429.161 163.389C430.154 162.731 431.315 162.372 432.506 162.354H432.765C433.574 162.354 434.375 162.515 435.121 162.829C435.867 163.142 436.544 163.601 437.11 164.179C437.676 164.757 438.122 165.442 438.42 166.195C438.719 166.947 438.864 167.751 438.848 168.561C438.848 171.101 437.692 172.942 434.94 174.782C429.555 178.301 423.243 180.133 416.812 180.046C398.852 180.046 385.621 167.268 385.621 150.23C385.533 146.314 386.235 142.42 387.686 138.781C389.137 135.143 391.306 131.834 394.065 129.053C396.823 126.273 400.114 124.077 403.74 122.598ZM414.82 132.98C408.037 132.98 402.973 137.482 401.239 144.495H427.138C426.91 137.711 422.074 132.98 414.82 132.98ZM551.37 172.242C551.377 172.389 551.377 172.536 551.37 172.683L551.476 172.698C551.348 174.505 550.579 176.206 549.309 177.496C548.038 178.786 546.349 179.58 544.546 179.736C542.742 179.892 540.942 179.399 539.47 178.346C537.997 177.293 536.948 175.749 536.512 173.991C531.931 178.106 525.936 180.287 519.783 180.076C508.043 180.076 500.104 173.292 500.104 163.039C500.104 152.786 508.271 146.458 521.623 146.458H535.675V143.917C535.675 137.589 531.934 133.908 525.03 133.908C520.981 133.909 517.079 135.429 514.096 138.167C512.839 139.299 511.223 139.951 509.533 140.008H509.457C507.756 140.028 506.115 139.377 504.891 138.195C503.667 137.013 502.958 135.396 502.918 133.695C502.997 132.491 503.325 131.317 503.88 130.247C504.435 129.176 505.205 128.232 506.142 127.473C510.978 122.985 518.46 120.445 526.748 120.445C542.397 120.445 551.37 129.313 551.37 144.86V172.242ZM523.844 168.682C530.642 168.682 535.827 163.845 535.827 157.395L535.782 156.695H523.616C518.445 156.695 515.677 158.658 515.677 162.461C515.677 166.264 518.78 168.682 523.844 168.682ZM493.352 128.036C493.407 127.1 493.264 126.163 492.931 125.286C492.599 124.409 492.085 123.613 491.422 122.949C490.76 122.285 489.965 121.769 489.09 121.435C488.214 121.1 487.277 120.955 486.342 121.008C483.695 121.02 481.082 121.598 478.677 122.703C476.272 123.807 474.131 125.413 472.396 127.412C472.287 125.506 471.449 123.715 470.056 122.409C468.664 121.104 466.823 120.384 464.914 120.399C462.902 120.371 460.962 121.141 459.516 122.541C458.071 123.941 457.24 125.856 457.204 127.868V172.136C457.146 174.183 457.904 176.169 459.31 177.658C460.715 179.147 462.655 180.017 464.701 180.076H465.036C466.043 180.09 467.043 179.904 467.978 179.528C468.913 179.152 469.764 178.594 470.481 177.886C471.199 177.179 471.768 176.336 472.157 175.406C472.546 174.476 472.746 173.478 472.746 172.47C472.754 172.333 472.754 172.196 472.746 172.059V150.23C472.746 141.483 477.81 136.068 486.098 135.49C490.478 135.018 493.352 132.173 493.352 128.036ZM288.969 121.582C290.198 120.805 291.629 120.409 293.082 120.445C295.049 120.488 296.922 121.292 298.309 122.687C299.696 124.083 300.488 125.962 300.519 127.929C300.535 129.178 300.214 130.407 299.591 131.489L274.499 182.906C268.4 195.44 261.496 200.749 251.14 200.749C248.889 200.793 246.655 200.357 244.585 199.472C243.407 198.953 242.407 198.1 241.71 197.019C241.012 195.937 240.648 194.674 240.661 193.387V193.204C240.733 191.414 241.511 189.725 242.825 188.507C244.139 187.29 245.882 186.643 247.672 186.709C247.997 186.709 248.284 186.747 248.534 186.781L248.535 186.781L248.535 186.781C248.73 186.807 248.903 186.83 249.056 186.83C253.999 186.83 257.344 184.746 259.869 179.574L261.937 175.011L242.258 131.611C241.631 130.476 241.277 129.21 241.224 127.914C241.256 125.918 242.071 124.014 243.494 122.614C244.916 121.214 246.832 120.429 248.828 120.43C250.267 120.395 251.684 120.795 252.894 121.576C254.103 122.357 255.05 123.484 255.611 124.811L270.697 158.551L286.178 124.811C286.769 123.482 287.741 122.359 288.969 121.582ZM346.142 120.445C338.782 120.445 332.683 123.092 328.76 127.701C328.744 125.731 327.947 123.847 326.544 122.464C325.141 121.081 323.247 120.311 321.278 120.323C319.274 120.295 317.34 121.058 315.896 122.448C314.452 123.839 313.615 125.743 313.567 127.747V192.976C313.557 193.997 313.748 195.01 314.13 195.957C314.511 196.904 315.075 197.766 315.79 198.495C316.504 199.224 317.355 199.805 318.294 200.205C319.233 200.605 320.242 200.816 321.262 200.826C322.283 200.836 323.295 200.644 324.242 200.263C325.189 199.882 326.051 199.317 326.78 198.603C327.508 197.888 328.089 197.036 328.489 196.097C328.889 195.158 329.1 194.149 329.11 193.128V173.17C333.018 177.551 339.01 180.076 346.142 180.076C362.141 180.076 373.775 167.405 373.775 150.139C373.775 132.873 362.141 120.445 346.142 120.445ZM343.268 165.914C334.752 165.914 328.881 159.464 328.881 150.139C328.881 140.814 334.63 134.486 343.268 134.486C351.906 134.486 358.004 141.103 358.004 150.23C358.004 159.357 351.784 165.914 343.268 165.914ZM621.112 153.592C621.112 169.26 610.284 180.076 594.985 180.076C579.413 180.076 568.63 169.245 568.63 153.592V128.112C568.595 127.063 568.773 126.019 569.152 125.041C569.532 124.063 570.105 123.172 570.838 122.421C571.571 121.671 572.448 121.076 573.416 120.674C574.385 120.271 575.424 120.069 576.473 120.08C577.522 120.09 578.558 120.312 579.518 120.734C580.479 121.155 581.344 121.766 582.062 122.531C582.78 123.296 583.336 124.198 583.696 125.183C584.056 126.168 584.213 127.216 584.157 128.264V154.794C584.094 156.233 584.328 157.669 584.844 159.014C585.361 160.358 586.149 161.582 587.159 162.608C588.17 163.635 589.381 164.442 590.717 164.979C592.053 165.516 593.485 165.772 594.924 165.731C596.358 165.771 597.784 165.513 599.113 164.974C600.442 164.435 601.645 163.626 602.645 162.598C603.645 161.57 604.422 160.346 604.925 159.002C605.429 157.659 605.648 156.226 605.57 154.794V128.112C605.58 127.091 605.791 126.082 606.19 125.143C606.59 124.203 607.171 123.352 607.9 122.637C608.628 121.923 609.491 121.358 610.437 120.977C611.384 120.596 612.396 120.404 613.417 120.414C614.437 120.424 615.446 120.635 616.385 121.035C617.324 121.435 618.175 122.016 618.89 122.745C619.604 123.474 620.168 124.336 620.55 125.283C620.931 126.23 621.122 127.243 621.112 128.264V153.592ZM721.817 180.076C723.864 180.105 725.838 179.32 727.306 177.894C728.775 176.468 729.617 174.517 729.649 172.47V128.264C729.672 126.202 728.874 124.216 727.432 122.743C725.991 121.269 724.023 120.429 721.962 120.407C719.901 120.385 717.915 121.182 716.442 122.624C714.969 124.067 714.129 126.035 714.107 128.097V172.212C714.041 174.251 714.788 176.233 716.182 177.722C717.577 179.211 719.505 180.085 721.544 180.152L721.817 180.076ZM728.643 107.625C726.837 109.369 724.419 110.334 721.909 110.314C720.654 110.346 719.405 110.13 718.234 109.679C717.063 109.227 715.992 108.549 715.084 107.682C714.175 106.816 713.447 105.779 712.94 104.63C712.433 103.481 712.158 102.244 712.13 100.989V100.897C712.142 98.3192 713.178 95.8516 715.009 94.0372C716.84 92.2228 719.316 91.2103 721.894 91.2224C723.17 91.2284 724.432 91.4858 725.609 91.9798C726.786 92.4738 727.854 93.1949 728.752 94.1017C729.65 95.0086 730.361 96.0836 730.844 97.2652C731.326 98.4468 731.572 99.712 731.566 100.989C731.498 103.498 730.448 105.882 728.643 107.625ZM805.84 150.139C805.84 133.558 792.259 120.445 775.227 120.445C758.194 120.445 744.72 133.497 744.72 150.139C744.719 154.106 745.51 158.033 747.046 161.691C748.582 165.349 750.832 168.663 753.664 171.44C756.497 174.217 759.855 176.4 763.542 177.862C767.229 179.324 771.17 180.035 775.136 179.955C792.32 179.955 805.84 166.72 805.84 150.139ZM775.227 165.686C766.711 165.686 760.491 159.236 760.491 150.261C760.491 141.285 766.711 134.592 775.227 134.592C783.743 134.592 789.963 141.27 789.963 150.261C789.963 159.251 783.637 165.686 775.227 165.686ZM94.6881 152.707C97.104 151.092 99.9443 150.23 102.85 150.23C104.78 150.228 106.691 150.607 108.474 151.345C110.257 152.082 111.878 153.165 113.242 154.53C114.607 155.895 115.689 157.515 116.426 159.299C117.164 161.083 117.542 162.995 117.54 164.925C117.54 167.831 116.679 170.672 115.065 173.089C113.45 175.506 111.156 177.389 108.472 178.501C105.787 179.614 102.834 179.905 99.9838 179.338C97.1341 178.771 94.5165 177.371 92.462 175.316C90.4074 173.261 89.0083 170.642 88.4415 167.792C87.8746 164.941 88.1655 161.987 89.2774 159.302C90.3893 156.616 92.2723 154.321 94.6881 152.707ZM58.7623 106.115C54.8752 106.127 51.151 107.678 48.4039 110.429C45.6567 113.18 44.1101 116.907 44.1021 120.795V164.91C44.2248 168.727 45.8272 172.347 48.5702 175.004C51.3133 177.661 54.9819 179.147 58.8003 179.147C62.6186 179.147 66.2873 177.661 69.0303 175.004C71.7734 172.347 73.3757 168.727 73.4985 164.91V120.795C73.4945 118.863 73.1102 116.951 72.3675 115.168C71.6247 113.385 70.5382 111.765 69.1698 110.402C67.8014 109.039 66.178 107.959 64.3923 107.223C62.6065 106.488 60.6935 106.111 58.7623 106.115ZM541.865 233.897H550.716C556.601 233.897 560.494 237.426 560.494 242.75C560.494 248.074 556.556 251.695 550.716 251.695H543.583V263.104C543.594 263.349 543.555 263.593 543.468 263.822C543.382 264.052 543.251 264.261 543.082 264.439C542.913 264.616 542.71 264.758 542.485 264.855C542.261 264.952 542.019 265.004 541.774 265.005C541.528 265.008 541.284 264.96 541.057 264.864C540.83 264.768 540.625 264.626 540.456 264.448C540.286 264.27 540.155 264.058 540.07 263.827C539.986 263.596 539.949 263.35 539.964 263.104V235.798C539.956 235.546 539.999 235.295 540.092 235.061C540.184 234.826 540.324 234.613 540.502 234.435C540.68 234.256 540.893 234.117 541.128 234.024C541.362 233.932 541.613 233.888 541.865 233.897ZM543.583 248.455H550.625V248.409C554.427 248.409 556.708 246.234 556.708 242.75C556.708 239.266 554.427 237.091 550.625 237.091H543.583V248.455ZM585.04 233.334C581.914 233.352 578.863 234.296 576.273 236.047C573.683 237.799 571.67 240.279 570.489 243.174C569.307 246.069 569.009 249.249 569.633 252.313C570.258 255.377 571.776 258.188 573.996 260.389C576.216 262.591 579.038 264.085 582.107 264.683C585.175 265.281 588.352 264.956 591.236 263.749C594.12 262.541 596.581 260.507 598.31 257.901C600.038 255.295 600.956 252.236 600.947 249.109C600.961 247.021 600.559 244.952 599.763 243.023C598.967 241.094 597.793 239.343 596.311 237.873C594.83 236.404 593.069 235.245 591.133 234.466C589.198 233.686 587.126 233.301 585.04 233.334ZM585.04 261.628C582.563 261.689 580.125 261.01 578.035 259.679C575.946 258.347 574.301 256.424 573.309 254.153C572.317 251.882 572.023 249.368 572.466 246.929C572.909 244.491 574.067 242.24 575.794 240.464C577.52 238.687 579.737 237.465 582.161 236.953C584.585 236.441 587.106 236.663 589.403 237.591C591.7 238.518 593.669 240.109 595.059 242.161C596.449 244.212 597.196 246.631 597.206 249.109C597.272 250.737 597.006 252.362 596.426 253.885C595.845 255.407 594.961 256.796 593.828 257.967C592.694 259.137 591.335 260.066 589.832 260.695C588.329 261.324 586.714 261.642 585.085 261.628H585.04ZM613.934 233.897H621.112C631.119 233.897 637.765 239.981 637.765 249.154C637.765 258.327 631.043 264.503 621.112 264.503H613.934C613.683 264.51 613.433 264.465 613.199 264.371C612.966 264.278 612.754 264.138 612.576 263.96C612.398 263.783 612.259 263.57 612.165 263.337C612.072 263.103 612.027 262.853 612.033 262.602V235.798C612.025 235.546 612.068 235.295 612.161 235.061C612.253 234.826 612.393 234.613 612.571 234.435C612.749 234.256 612.962 234.117 613.197 234.024C613.431 233.932 613.682 233.888 613.934 233.897ZM615.698 261.278H621.067C628.868 261.278 634.054 256.441 634.054 249.109C634.054 241.776 629.005 237.091 621.112 237.091H615.698V261.278ZM662.812 236.68C664.615 236.657 666.398 237.057 668.017 237.85C669.637 238.643 671.047 239.805 672.134 241.244C672.31 241.48 672.54 241.671 672.805 241.8C673.069 241.93 673.361 241.995 673.655 241.989C674.096 241.994 674.522 241.827 674.843 241.523C675.164 241.219 675.354 240.803 675.373 240.362C675.329 239.79 675.087 239.253 674.689 238.841C673.231 237.101 671.406 235.708 669.344 234.761C667.282 233.813 665.035 233.336 662.766 233.364C660.649 233.298 658.54 233.659 656.565 234.424C654.59 235.189 652.788 236.343 651.267 237.818C649.746 239.293 648.537 241.059 647.711 243.01C646.885 244.961 646.46 247.058 646.46 249.177C646.46 251.296 646.885 253.393 647.711 255.345C648.537 257.296 649.746 259.061 651.267 260.536C652.788 262.011 654.59 263.165 656.565 263.93C658.54 264.695 660.649 265.056 662.766 264.99C665.035 265.027 667.283 264.556 669.346 263.611C671.409 262.666 673.235 261.271 674.689 259.529C675.085 259.115 675.327 258.578 675.373 258.008C675.354 257.567 675.164 257.15 674.843 256.847C674.522 256.543 674.096 256.376 673.655 256.38C673.361 256.378 673.071 256.445 672.807 256.574C672.543 256.703 672.313 256.892 672.134 257.125C671.039 258.556 669.628 259.713 668.01 260.505C666.392 261.297 664.613 261.702 662.812 261.689C659.505 261.689 656.333 260.375 653.994 258.036C651.655 255.696 650.342 252.523 650.342 249.215C650.342 245.907 651.655 242.734 653.994 240.395C656.333 238.055 659.505 236.741 662.812 236.741V236.68ZM698.424 233.682C698.733 233.905 698.963 234.22 699.082 234.581L710.807 261.963C711.013 262.32 711.128 262.722 711.142 263.134C711.127 263.596 710.935 264.034 710.607 264.36C710.279 264.685 709.84 264.872 709.378 264.884C708.997 264.885 708.624 264.771 708.31 264.556C707.995 264.342 707.752 264.037 707.614 263.682L705.15 258.16H689.441L687.114 263.682C686.986 264.035 686.752 264.339 686.444 264.554C686.137 264.769 685.771 264.884 685.395 264.884C684.933 264.88 684.49 264.694 684.163 264.367C683.836 264.04 683.65 263.597 683.646 263.134C683.665 262.73 683.758 262.333 683.92 261.963L695.645 234.581C695.765 234.22 695.995 233.905 696.304 233.682C696.612 233.459 696.983 233.339 697.364 233.339C697.745 233.339 698.116 233.459 698.424 233.682ZM697.364 238.765L690.779 254.996H703.766L697.364 238.765ZM733.01 247.892L729.634 246.279C725.695 244.378 724.707 243.237 724.707 241.122C724.707 238.43 726.897 236.68 730.136 236.68C731.308 236.679 732.467 236.932 733.532 237.42C734.598 237.908 735.546 238.621 736.31 239.51C736.469 239.686 736.66 239.829 736.874 239.931C737.089 240.033 737.321 240.092 737.557 240.103C737.994 240.093 738.412 239.921 738.73 239.62C739.047 239.32 739.242 238.912 739.276 238.475C739.273 238.191 739.214 237.91 739.102 237.649C738.989 237.388 738.826 237.152 738.622 236.954C737.565 235.768 736.262 234.826 734.805 234.193C733.347 233.56 731.77 233.251 730.182 233.288C724.905 233.288 720.966 236.68 720.966 241.259C720.966 244.697 723.004 247.162 727.87 249.474L731.292 251.102C735.246 252.957 736.402 254.144 736.402 256.471C736.402 259.514 733.938 261.583 730.227 261.583C728.737 261.559 727.272 261.186 725.952 260.494C724.631 259.802 723.491 258.81 722.623 257.597C722.465 257.378 722.257 257.201 722.017 257.079C721.776 256.957 721.509 256.895 721.24 256.897C720.79 256.893 720.358 257.067 720.036 257.38C719.714 257.694 719.529 258.121 719.521 258.571C719.518 258.978 719.664 259.373 719.932 259.681C721.143 261.284 722.704 262.588 724.497 263.495C726.289 264.402 728.265 264.887 730.273 264.914C736.128 264.914 740.158 261.4 740.158 256.38C740.219 252.76 738.226 250.356 733.01 247.892ZM750.104 233.897H772.261V233.851C772.487 233.829 772.715 233.855 772.931 233.926C773.146 233.998 773.344 234.113 773.512 234.266C773.68 234.418 773.814 234.604 773.906 234.812C773.998 235.02 774.046 235.244 774.046 235.471C774.046 235.698 773.998 235.923 773.906 236.13C773.814 236.338 773.68 236.524 773.512 236.676C773.344 236.829 773.146 236.945 772.931 237.016C772.715 237.088 772.487 237.113 772.261 237.091H762.939V263.104C762.954 263.35 762.918 263.596 762.833 263.827C762.748 264.058 762.617 264.27 762.447 264.448C762.278 264.626 762.073 264.768 761.846 264.864C761.62 264.96 761.375 265.008 761.129 265.005C760.884 265.004 760.642 264.952 760.418 264.855C760.193 264.758 759.99 264.616 759.821 264.439C759.652 264.261 759.521 264.052 759.435 263.822C759.349 263.593 759.309 263.349 759.32 263.104V237.137H750.104C749.878 237.159 749.65 237.133 749.434 237.062C749.219 236.99 749.021 236.875 748.853 236.722C748.685 236.569 748.551 236.383 748.459 236.176C748.367 235.968 748.319 235.744 748.319 235.517C748.319 235.29 748.367 235.065 748.459 234.858C748.551 234.65 748.685 234.464 748.853 234.311C749.021 234.159 749.219 234.043 749.434 233.972C749.65 233.9 749.878 233.875 750.104 233.897ZM795.179 247.892L791.788 246.279C787.849 244.378 786.876 243.237 786.876 241.122C786.876 238.43 789.051 236.68 792.305 236.68C793.462 236.692 794.603 236.951 795.652 237.439C796.701 237.927 797.634 238.633 798.388 239.51C798.714 239.867 799.168 240.08 799.65 240.103C800.103 240.112 800.542 239.946 800.876 239.641C801.21 239.335 801.414 238.912 801.445 238.46C801.44 237.889 801.211 237.343 800.806 236.939C799.747 235.755 798.444 234.815 796.987 234.182C795.53 233.549 793.954 233.239 792.366 233.273C787.074 233.273 783.135 236.665 783.135 241.244C783.135 244.682 785.173 247.146 790.039 249.459L793.476 251.086C797.415 252.942 798.571 254.129 798.571 256.456C798.571 259.499 796.122 261.567 792.411 261.567C790.921 261.544 789.456 261.171 788.136 260.479C786.815 259.787 785.675 258.795 784.808 257.582C784.586 257.323 784.292 257.136 783.965 257.043C783.637 256.951 783.289 256.956 782.964 257.06C782.64 257.164 782.353 257.361 782.14 257.627C781.927 257.893 781.797 258.216 781.766 258.555C781.769 258.965 781.92 259.36 782.192 259.666C783.403 261.269 784.964 262.574 786.756 263.481C788.549 264.388 790.525 264.873 792.533 264.899C798.373 264.899 802.403 261.385 802.403 256.365C802.312 252.76 800.32 250.356 795.179 247.892ZM511.197 239.539C511.527 239.866 511.715 240.308 511.723 240.772C511.727 241.247 511.547 241.705 511.221 242.05L503.983 249.291L511.221 256.517C511.538 256.87 511.726 257.321 511.754 257.795C511.771 258.155 511.675 258.511 511.48 258.814C511.285 259.117 511 259.352 510.666 259.486C510.331 259.62 509.963 259.646 509.613 259.561C509.263 259.476 508.948 259.284 508.712 259.012L501.489 251.786L494.25 259.012C494.09 259.194 493.893 259.341 493.673 259.443C493.453 259.545 493.215 259.6 492.972 259.605C492.739 259.601 492.508 259.551 492.294 259.458C492.079 259.365 491.885 259.23 491.723 259.062C491.561 258.894 491.433 258.696 491.347 258.478C491.261 258.261 491.219 258.029 491.223 257.795C491.251 257.321 491.439 256.87 491.756 256.517L498.979 249.291L491.756 242.05C491.419 241.71 491.228 241.251 491.223 240.772C491.227 240.31 491.413 239.867 491.74 239.54C492.067 239.213 492.51 239.027 492.972 239.023C493.213 239.028 493.451 239.082 493.67 239.181C493.89 239.28 494.087 239.423 494.25 239.601L501.458 246.781L508.682 239.601C509.015 239.247 509.474 239.04 509.959 239.023C510.423 239.027 510.867 239.212 511.197 239.539Z"
  })));
}

var PREFIX$3 = "HyperaudioSchools";
var classes$3 = {
  root: PREFIX$3 + "-root",
  path: PREFIX$3 + "-path"
};
var Root$3 = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'fill'].includes(prop);
  }
})(function (_ref) {
  var _svg, _ref2;

  var theme = _ref.theme,
      size = _ref.size;
  return _ref2 = {
    display: 'inline-block',
    lineHeight: 0
  }, _ref2["& svg"] = (_svg = {
    width: 'auto',
    height: theme.spacing(size === 'large' ? 5 : size === 'small' ? 3 : 4)
  }, _svg[theme.breakpoints.up('lg')] = {
    height: theme.spacing(size === 'large' ? 6 : size === 'small' ? 4 : 5)
  }, _svg), _ref2["& ." + classes$3.path] = {
    fill: 'currentColor'
  }, _ref2;
});
function HyperaudioSchools(props) {
  return /*#__PURE__*/React__default.createElement(Root$3, _extends({
    className: classes$3.root
  }, props, {
    "aria-label": "Hyperaudio"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: "806",
    height: "275",
    viewBox: "0 0 806 275",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Hyperaudio Podcasts"), /*#__PURE__*/React__default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    id: "hyperaudio-logo",
    className: classes$3.path,
    d: "M14.6901 62C12.7604 61.998 10.8492 62.3766 9.06606 63.1141C7.28288 63.8517 5.66267 64.9337 4.29817 66.2982C2.93367 67.6627 1.85168 69.2829 1.11415 71.0661C0.376612 72.8493 -0.00199283 74.7604 7.88823e-06 76.6901V164.891C7.88823e-06 168.787 1.54771 172.524 4.30263 175.279C7.05755 178.034 10.794 179.581 14.6901 179.581C18.5849 179.577 22.319 178.028 25.0731 175.274C27.8271 172.52 29.3761 168.786 29.3801 164.891V76.6901C29.3801 72.794 27.8325 69.0576 25.0775 66.3026C22.3226 63.5477 18.5861 62 14.6901 62ZM695.786 98.8924C695.831 97.8913 695.677 96.8911 695.334 95.9494C694.991 95.0077 694.466 94.1432 693.787 93.4055C693.109 92.6677 692.291 92.0714 691.382 91.6508C690.472 91.2301 689.488 90.9934 688.487 90.9543H688.076C687.062 90.9382 686.055 91.1223 685.113 91.4959C684.17 91.8695 683.311 92.4253 682.583 93.1316C681.856 93.8379 681.275 94.6807 680.873 95.6118C680.472 96.5429 680.258 97.5441 680.245 98.5579V127.208C678.035 124.951 675.379 123.181 672.446 122.011C669.513 120.84 666.368 120.295 663.213 120.411C647.215 120.411 635.657 132.956 635.657 150.201C635.657 167.446 647.291 180.007 663.289 180.007C670.649 180.007 676.747 177.361 680.67 172.753C680.76 174.709 681.601 176.554 683.017 177.905C684.434 179.256 686.316 180.009 688.274 180.007C689.26 180.023 690.24 179.844 691.157 179.48C692.074 179.116 692.91 178.574 693.616 177.886C694.323 177.198 694.886 176.376 695.275 175.469C695.663 174.563 695.867 173.588 695.877 172.601V98.8924H695.786ZM666.071 165.88C657.449 165.88 651.336 159.326 651.336 150.11C651.336 141.138 657.555 134.462 666.071 134.462C674.587 134.462 680.457 140.91 680.457 150.232C680.457 159.554 674.724 165.88 666.071 165.88ZM721.912 91.5322C719.378 91.4751 716.924 92.4264 715.091 94.1772C713.257 95.928 712.194 98.335 712.134 100.869V100.961C712.159 102.213 712.432 103.449 712.936 104.596C713.441 105.743 714.166 106.78 715.072 107.646C715.978 108.512 717.045 109.191 718.214 109.643C719.382 110.096 720.629 110.313 721.882 110.283C724.391 110.303 726.809 109.338 728.615 107.595C730.421 105.852 731.47 103.47 731.538 100.961C731.498 98.4383 730.465 96.0335 728.663 94.2682C726.86 92.503 724.435 91.5199 721.912 91.5322ZM594.963 180.038C610.261 180.038 621.089 169.225 621.089 153.562V128.242C621.099 127.222 620.907 126.209 620.526 125.263C620.145 124.316 619.581 123.454 618.866 122.725C618.152 121.996 617.301 121.416 616.362 121.016C615.423 120.616 614.414 120.405 613.394 120.395C612.373 120.385 611.361 120.576 610.414 120.958C609.468 121.339 608.605 121.903 607.877 122.618C607.148 123.332 606.567 124.183 606.168 125.122C605.768 126.061 605.557 127.07 605.547 128.09V154.763C605.625 156.195 605.406 157.628 604.902 158.971C604.399 160.314 603.623 161.537 602.622 162.565C601.622 163.592 600.419 164.401 599.09 164.94C597.762 165.48 596.335 165.737 594.902 165.697C593.463 165.738 592.03 165.482 590.694 164.945C589.358 164.408 588.147 163.601 587.137 162.575C586.127 161.549 585.339 160.326 584.822 158.982C584.306 157.638 584.072 156.202 584.135 154.763V128.242C584.191 127.195 584.034 126.147 583.674 125.162C583.313 124.177 582.758 123.276 582.04 122.511C581.322 121.747 580.457 121.136 579.496 120.714C578.536 120.293 577.5 120.071 576.451 120.061C575.403 120.05 574.363 120.252 573.394 120.655C572.426 121.057 571.549 121.651 570.816 122.401C570.083 123.152 569.51 124.042 569.131 125.02C568.751 125.998 568.574 127.042 568.609 128.09V153.562C568.609 169.21 579.391 180.038 594.963 180.038ZM328.747 127.68C332.67 123.072 338.768 120.426 346.129 120.426C362.127 120.426 373.76 132.85 373.76 150.11C373.76 167.37 362.127 180.038 346.129 180.038C338.997 180.038 333.005 177.513 329.097 173.134V193.085C329.087 194.106 328.876 195.114 328.476 196.053C328.076 196.992 327.496 197.843 326.767 198.558C326.038 199.272 325.176 199.836 324.229 200.218C323.283 200.599 322.27 200.79 321.25 200.78C320.229 200.77 319.221 200.559 318.282 200.159C317.343 199.76 316.492 199.179 315.777 198.45C315.063 197.722 314.499 196.859 314.117 195.913C313.736 194.966 313.545 193.954 313.555 192.933V127.725C313.603 125.722 314.44 123.818 315.884 122.429C317.327 121.039 319.261 120.275 321.265 120.304C323.235 120.292 325.129 121.062 326.531 122.444C327.934 123.827 328.731 125.71 328.747 127.68ZM328.869 150.11C328.869 159.432 334.739 165.88 343.255 165.88C351.771 165.88 357.99 159.326 357.99 150.201C357.99 141.077 351.892 134.462 343.255 134.462C334.617 134.462 328.869 140.788 328.869 150.11ZM500.761 241.002C501.091 241.328 501.279 241.771 501.287 242.235C501.279 242.716 501.082 243.174 500.74 243.512L493.501 250.751L500.74 257.974C501.057 258.327 501.244 258.778 501.272 259.251C501.289 259.611 501.193 259.967 500.998 260.27C500.803 260.573 500.519 260.808 500.184 260.942C499.85 261.076 499.482 261.102 499.132 261.017C498.782 260.932 498.467 260.74 498.231 260.468L491.007 253.245L483.769 260.468C483.611 260.649 483.417 260.795 483.2 260.897C482.983 260.999 482.747 261.055 482.507 261.061C482.033 261.053 481.582 260.858 481.252 260.52C480.922 260.181 480.738 259.725 480.742 259.251C480.77 258.778 480.958 258.327 481.275 257.974L488.513 250.751L481.275 243.512C480.938 243.172 480.747 242.714 480.742 242.235C480.736 241.879 480.839 241.529 481.037 241.234C481.236 240.939 481.521 240.711 481.853 240.584C482.185 240.456 482.549 240.433 482.894 240.519C483.24 240.605 483.55 240.795 483.784 241.064L491.023 248.242L498.246 241.064C498.579 240.71 499.038 240.502 499.523 240.486C499.987 240.49 500.431 240.675 500.761 241.002ZM486.08 135.496C490.46 135.04 493.334 132.15 493.334 128.014C493.389 127.078 493.246 126.142 492.913 125.265C492.58 124.389 492.066 123.593 491.404 122.929C490.742 122.266 489.947 121.75 489.071 121.415C488.196 121.081 487.259 120.935 486.323 120.988C483.677 121.001 481.064 121.579 478.659 122.683C476.254 123.787 474.113 125.392 472.379 127.391C472.269 125.485 471.432 123.695 470.039 122.39C468.646 121.085 466.805 120.365 464.897 120.38C462.885 120.352 460.944 121.121 459.499 122.521C458.054 123.92 457.223 125.836 457.187 127.847V172.1C457.129 174.146 457.887 176.132 459.292 177.62C460.698 179.108 462.637 179.978 464.684 180.038H465.018C466.026 180.052 467.026 179.866 467.961 179.49C468.896 179.114 469.746 178.556 470.464 177.849C471.181 177.141 471.751 176.298 472.139 175.369C472.528 174.439 472.728 173.442 472.728 172.434C472.736 172.297 472.736 172.16 472.728 172.024V150.201C472.728 141.488 477.792 136.074 486.08 135.496ZM546.686 179.4C545.784 179.757 544.821 179.932 543.851 179.916C542.123 179.93 540.445 179.343 539.102 178.255C537.759 177.168 536.836 175.648 536.491 173.955C531.911 178.068 525.916 180.248 519.763 180.038C508.023 180.038 500.085 173.255 500.085 163.006C500.085 152.756 508.251 146.43 521.603 146.43H535.654V143.89C535.654 137.564 531.913 133.884 525.009 133.884C520.96 133.885 517.059 135.405 514.076 138.142C512.819 139.274 511.203 139.925 509.513 139.982H509.437C507.736 140.003 506.095 139.351 504.871 138.17C503.647 136.988 502.938 135.372 502.898 133.671C502.978 132.468 503.305 131.295 503.86 130.224C504.415 129.154 505.185 128.21 506.122 127.451C510.958 122.965 518.44 120.426 526.728 120.426C542.376 120.426 551.348 129.291 551.348 144.833V172.206C551.356 172.353 551.356 172.5 551.348 172.647C551.334 173.617 551.129 174.574 550.745 175.465C550.36 176.356 549.804 177.161 549.107 177.837C548.411 178.512 547.588 179.043 546.686 179.4ZM523.823 168.647C530.621 168.647 535.806 163.812 535.806 157.364L535.761 156.664H523.595C518.425 156.664 515.657 158.626 515.657 162.428C515.657 166.23 518.759 168.647 523.823 168.647ZM288.959 121.562C290.187 120.786 291.618 120.39 293.072 120.426C295.038 120.469 296.912 121.272 298.298 122.667C299.685 124.063 300.477 125.941 300.508 127.908C300.524 129.156 300.203 130.385 299.58 131.466L274.489 182.866C268.39 195.397 261.486 200.704 251.13 200.704C248.88 200.747 246.646 200.312 244.576 199.427C243.398 198.908 242.399 198.056 241.701 196.974C241.004 195.893 240.639 194.631 240.653 193.344V193.161C240.724 191.372 241.502 189.683 242.816 188.466C244.13 187.249 245.873 186.602 247.663 186.668C247.988 186.668 248.275 186.706 248.525 186.74C248.721 186.766 248.894 186.79 249.047 186.79C253.989 186.79 257.335 184.706 259.859 179.536L261.927 174.974L242.249 131.588C241.622 130.453 241.268 129.188 241.215 127.892C241.247 125.897 242.062 123.994 243.485 122.594C244.907 121.195 246.823 120.41 248.819 120.41C250.258 120.376 251.675 120.775 252.884 121.556C254.094 122.337 255.04 123.464 255.601 124.79L270.687 158.52L286.168 124.79C286.759 123.462 287.73 122.339 288.959 121.562ZM415.154 120.426C411.239 120.367 407.352 121.099 403.725 122.578C400.099 124.057 396.809 126.252 394.05 129.031C391.292 131.811 389.122 135.119 387.672 138.756C386.221 142.393 385.519 146.286 385.607 150.201C385.607 167.233 398.837 180.007 416.797 180.007C423.228 180.094 429.539 178.263 434.924 174.745C437.676 172.905 438.832 171.065 438.832 168.526C438.848 167.717 438.703 166.913 438.404 166.161C438.106 165.408 437.66 164.723 437.094 164.146C436.527 163.568 435.851 163.109 435.105 162.796C434.359 162.482 433.558 162.321 432.749 162.321C432.663 162.314 432.577 162.314 432.491 162.321C431.299 162.339 430.138 162.698 429.145 163.355C425.583 165.547 421.48 166.7 417.299 166.686C408.889 166.686 403.141 162.549 401.301 155.417H433.753C438.817 155.417 442.269 152.376 442.269 147.464V147.16C442.238 131.694 430.727 120.426 415.154 120.426ZM401.225 144.468C402.958 137.458 408.022 132.956 414.805 132.956C422.058 132.956 426.894 137.686 427.122 144.468H401.225ZM744.692 150.11C744.692 133.428 758.059 120.426 775.198 120.426C792.291 120.426 805.84 133.534 805.84 150.11C805.84 166.686 792.26 179.916 775.107 179.916C771.142 179.997 767.2 179.286 763.513 177.824C759.827 176.362 756.469 174.18 753.636 171.404C750.804 168.628 748.554 165.315 747.018 161.659C745.482 158.002 744.692 154.076 744.692 150.11ZM760.462 150.232C760.462 159.204 766.682 165.652 775.198 165.652C783.607 165.652 789.934 159.219 789.934 150.232C789.934 141.244 783.714 134.568 775.198 134.568C766.682 134.568 760.462 141.259 760.462 150.232ZM727.405 122.723C728.847 124.196 729.644 126.181 729.622 128.242V172.51C729.59 174.556 728.747 176.506 727.279 177.932C725.81 179.357 723.836 180.142 721.79 180.114H721.516C719.478 180.046 717.55 179.172 716.155 177.684C714.761 176.195 714.015 174.214 714.08 172.176V128.075C714.102 126.014 714.942 124.046 716.415 122.605C717.888 121.163 719.874 120.366 721.935 120.388C723.996 120.41 725.963 121.25 727.405 122.723ZM198.835 121.936C201.533 120.87 204.418 120.356 207.318 120.426C220.092 120.426 228.502 129.504 228.486 143.328V172.099C228.532 173.135 228.366 174.169 227.997 175.137C227.629 176.106 227.067 176.989 226.345 177.732C225.623 178.476 224.756 179.064 223.799 179.46C222.841 179.857 221.813 180.053 220.776 180.038H220.503C218.488 179.935 216.595 179.046 215.23 177.561C213.865 176.076 213.137 174.115 213.203 172.099V145.502C213.203 138.841 208.884 134.462 202.558 134.462C201.103 134.406 199.653 134.656 198.3 135.194C196.947 135.732 195.721 136.547 194.702 137.586C193.682 138.626 192.891 139.867 192.38 141.23C191.868 142.594 191.647 144.049 191.731 145.502V172.023C191.738 172.16 191.738 172.297 191.731 172.434C191.731 173.443 191.53 174.442 191.141 175.372C190.751 176.303 190.18 177.146 189.461 177.854C188.742 178.562 187.889 179.119 186.953 179.494C186.016 179.869 185.014 180.054 184.006 180.038H183.671C181.625 179.978 179.686 179.108 178.28 177.62C176.874 176.132 176.117 174.146 176.174 172.099V98.5579C176.206 96.5116 177.049 94.5617 178.517 93.1361C179.985 91.7105 181.959 90.9259 184.006 90.9543H184.31C185.311 90.9934 186.295 91.2301 187.205 91.6507C188.114 92.0714 188.932 92.6677 189.61 93.4054C190.289 94.1432 190.814 95.0077 191.157 95.9494C191.501 96.891 191.654 97.8912 191.609 98.8924V126.63C193.679 124.598 196.136 123.001 198.835 121.936ZM94.684 152.677C97.0998 151.063 99.9399 150.201 102.845 150.201C104.775 150.199 106.686 150.578 108.469 151.315C110.253 152.053 111.873 153.135 113.237 154.499C114.602 155.864 115.684 157.484 116.421 159.267C117.159 161.051 117.537 162.962 117.535 164.891C117.535 167.797 116.674 170.637 115.06 173.053C113.446 175.469 111.151 177.351 108.467 178.463C105.783 179.575 102.829 179.866 99.9795 179.299C97.1299 178.732 94.5123 177.333 92.4579 175.279C90.4035 173.224 89.0044 170.607 88.4375 167.757C87.8707 164.908 88.1616 161.954 89.2735 159.27C90.3854 156.585 92.2682 154.291 94.684 152.677ZM58.7602 106.101C54.8733 106.113 51.1493 107.663 48.4022 110.413C45.6552 113.163 44.1086 116.889 44.1006 120.776V164.876C44.2234 168.692 45.8256 172.311 48.5686 174.967C51.3115 177.624 54.98 179.109 58.7983 179.109C62.6165 179.109 66.285 177.624 69.0279 174.967C71.7709 172.311 73.3732 168.692 73.4959 164.876V120.776C73.4919 118.844 73.1076 116.933 72.3649 115.15C71.6222 113.368 70.5357 111.749 69.1674 110.386C67.799 109.024 66.1757 107.944 64.39 107.208C62.6044 106.473 60.6914 106.097 58.7602 106.101ZM558.462 239.038C558.159 240.354 558.007 241.013 556.58 242.965C556.111 242.873 555.703 242.811 555.339 242.756C553.707 242.509 552.934 242.392 551.318 240.303C551.558 238.645 550.809 237.941 549.899 237.086C549.599 236.805 549.282 236.506 548.976 236.152C546.541 236.205 545.188 238.423 543.976 240.411C543.796 240.707 543.618 240.999 543.441 241.277C542.726 245.839 544.946 245.96 548.125 245.96C548.423 245.96 548.731 245.95 549.046 245.94H549.047H549.047C550.998 245.877 553.208 245.805 554.831 248.044C554.958 248.166 555.091 248.291 555.227 248.42L555.233 248.426C556.976 250.071 559.314 252.277 557.751 256.362C557.804 258.674 557.197 260.952 556.002 262.932C554.787 265.01 553.118 266.788 551.12 268.132C549.536 268.519 547.888 268.563 546.286 268.262C544.683 267.96 543.164 267.32 541.829 266.384C540.074 265.251 538.457 263.919 537.008 262.414L536.628 259.495C536.824 258.713 537.28 258.022 537.921 257.533C538.955 256.499 541.631 254.674 543.638 257.868C544.178 258.643 544.9 259.273 545.741 259.702C546.581 260.132 547.515 260.348 548.459 260.331C548.322 260.392 548.322 260.59 548.322 260.787C549.442 259.549 550.287 258.087 550.801 256.499C551.304 255.732 550.402 254.315 549.78 253.339C549.612 253.076 549.465 252.844 549.372 252.667C549.258 252.517 549.106 252.402 548.932 252.332C548.758 252.262 548.568 252.241 548.383 252.271H547.744C545.712 252.768 543.566 252.463 541.753 251.42C540.048 250.641 538.556 249.462 537.404 247.983C536.206 245.797 535.86 243.246 536.43 240.82C537.139 238.226 538.353 235.796 540.004 233.673C541.525 231.52 543.762 229.978 546.315 229.324C547.475 228.972 548.697 228.877 549.897 229.045C551.097 229.213 552.246 229.64 553.265 230.297C555.857 231.935 557.844 234.375 558.922 237.247C558.703 237.993 558.572 238.559 558.462 239.038ZM592.636 260.939C591.954 262.307 591.055 263.555 589.975 264.635C588.454 265.745 585.093 267.676 585.23 267.174C582.554 266.52 579.634 263.601 579.314 262.232C579.171 261.64 578.864 260.875 578.534 260.054C577.958 258.618 577.314 257.012 577.353 255.86C577.367 255.435 577.375 255.022 577.382 254.611V254.608C577.407 253.269 577.432 251.932 577.687 250.142C578.007 247.283 580.212 240.912 582.812 239.604C587.061 237.486 589.7 240.926 591.651 243.469C592.151 244.121 592.606 244.714 593.031 245.139C594.78 246.888 597.183 243.71 597.441 242.402C598.066 239.422 596.288 237.657 594.382 235.764C593.876 235.262 593.361 234.751 592.879 234.205C591.984 233.749 591.51 233.403 590.992 233.025C590.631 232.761 590.248 232.481 589.686 232.137C587.622 231.087 585.292 230.679 582.995 230.966C581.117 231.776 579.293 232.705 577.535 233.749C576.015 234.776 574.746 236.132 573.825 237.718L572.076 240.516C571.891 241.521 571.606 242.396 571.308 243.31L571.308 243.311C570.871 244.652 570.407 246.077 570.19 248.12C569.894 250.534 569.894 252.975 570.19 255.389C570.547 259.318 571.533 263.163 573.11 266.779C574.083 268.786 576.82 272.36 579.193 273.075C580.714 274.595 586.675 274.322 588.743 273.47C589.37 273.22 589.877 273.028 590.304 272.866C592.32 272.103 592.542 272.019 595.115 269.76C596.436 268.449 597.499 266.901 598.247 265.197C598.534 264.456 598.572 263.641 598.355 262.876C598.138 262.111 597.678 261.437 597.044 260.956C596.411 260.475 595.638 260.214 594.843 260.211C594.048 260.208 593.273 260.464 592.636 260.939ZM632.879 247.635C632.945 249.011 633.011 250.39 633.148 251.77C633.254 252.778 633.289 253.736 633.323 254.645C633.393 256.493 633.454 258.139 634.076 259.586C634.173 260.434 634.275 261.244 634.373 262.024C634.863 265.898 635.256 269.013 634.395 272.254C633.802 274.474 630.578 274.854 629.057 273.881C627.512 272.371 627.546 270.861 627.578 269.428C627.602 268.394 627.624 267.399 627.05 266.475C627.122 263.846 627.036 261.216 626.792 258.598C623.935 258.778 621.091 259.128 618.276 259.647C618.725 263.532 618.725 267.456 618.276 271.341C616.451 274.991 613.881 273.485 612.36 272.512C611.12 270.125 610.983 266.464 610.853 262.968V262.967C610.77 260.761 610.69 258.622 610.338 256.91C610.068 252.611 609.524 248.334 608.71 244.105L608.696 244.023L608.671 243.877L608.626 243.628C608.193 241.198 607.852 239.291 611.752 237.277C613.83 237.277 614.507 237.972 615.696 239.191L615.698 239.193C615.848 239.347 616.006 239.509 616.177 239.68C616.782 241.835 617.024 244.076 616.892 246.31C616.892 246.769 616.875 247.141 616.861 247.462C616.82 248.417 616.798 248.916 617.287 249.884C617.109 250.564 617.022 251.264 617.029 251.967C618.458 251.906 624.495 251.329 625.864 250.994V246.432C625.631 245.565 625.523 244.668 625.545 243.771C625.235 241.92 625.057 240.05 625.012 238.174C625.071 237.046 624.895 235.917 624.495 234.859C623.72 232.654 625.149 230.769 627.233 229.856C630.152 228.609 631.126 230.632 631.582 233.171C631.694 233.744 631.847 234.308 632.038 234.859C631.947 236.551 631.947 238.247 632.038 239.938C632.633 242.479 632.756 245.051 632.879 247.635ZM681.659 237.596C678.983 232.776 673.599 231.088 668.915 231.027C665.415 230.942 662.887 232.005 660.304 233.09C658.713 233.759 657.101 234.436 655.229 234.859C648.462 239.224 646.196 245.976 645.405 252.743C645.707 254.031 645.846 255.335 645.984 256.627C646.262 259.24 646.535 261.808 648.143 264.118C649.663 268.406 653.739 273.607 659.198 274.2C660.833 275.06 662.312 274.989 663.831 274.916C664.728 274.873 665.639 274.829 666.604 274.976C668.991 274.416 671.338 273.7 673.63 272.831C675.213 272.396 676.508 271.409 677.822 270.408C678.666 269.764 679.518 269.115 680.458 268.604C680.977 267.255 681.722 266.124 682.452 265.014C683.73 263.07 684.964 261.195 684.868 258.339C685.779 256.182 686.205 253.851 686.115 251.511C686.115 250.259 686.037 248.97 685.954 247.599C685.886 246.473 685.814 245.291 685.78 244.029C685.284 243.254 684.934 242.45 684.59 241.663C683.924 240.135 683.285 238.671 681.659 237.596ZM677.492 257.548C675.864 261.482 672.797 264.648 668.915 266.399C668.229 266.399 667.445 266.465 666.615 266.534C663.772 266.773 660.402 267.056 658.635 264.878C654.073 260.924 652.659 253.898 654.347 248.15C654.562 247.406 654.966 246.72 655.373 246.029C655.714 245.45 656.058 244.866 656.294 244.242C659.867 241.581 663.258 239.3 667.03 238.98C670.801 238.661 673.979 239.695 675.926 242.812C679.724 246.714 678.539 252.467 677.576 257.143L677.492 257.548ZM714.917 231.544C718.947 231.681 723.372 233.293 725.379 237.855C726.727 238.904 727.371 240.377 728.015 241.847C728.322 242.55 728.63 243.253 729.014 243.907C729.014 245.261 729.063 246.508 729.111 247.703V247.705V247.706C729.154 248.806 729.196 249.862 729.196 250.918C729.335 253.087 729.003 255.261 728.223 257.29C728.347 259.932 727.3 261.659 726.212 263.455C725.559 264.533 724.891 265.636 724.452 266.977C723.733 267.452 723.073 268.066 722.408 268.683C721.327 269.687 720.236 270.701 718.871 271.143C717 271.981 715.062 272.658 713.077 273.166C712.311 273.049 711.607 273.084 710.921 273.119C709.644 273.183 708.428 273.244 706.994 272.314C702.31 271.66 699.117 266.536 697.946 262.688C696.626 260.626 696.439 258.11 696.251 255.589C696.162 254.392 696.073 253.194 695.862 252.043C696.455 245.778 698.204 239.406 703.664 235.315C705.208 234.892 706.53 234.242 707.836 233.6C709.951 232.561 712.021 231.544 714.917 231.544ZM714.658 265.228C717.843 263.346 720.225 260.358 721.349 256.833H721.319C721.361 256.557 721.404 256.277 721.447 255.994L721.448 255.992L721.448 255.991C722.149 251.426 722.961 246.139 720.026 242.402C719.48 241.171 718.534 240.162 717.341 239.538C716.148 238.914 714.779 238.712 713.457 238.965C710.659 239.269 708.058 241.292 705.26 243.831C705.07 244.442 704.811 245.012 704.554 245.579L704.553 245.58C704.233 246.284 703.917 246.981 703.74 247.74C702.432 252.94 703.223 259.89 707.176 264.057C708.471 265.969 710.959 265.656 713.102 265.388L713.103 265.388L713.109 265.387C713.656 265.318 714.182 265.253 714.658 265.228ZM748.965 267.174C748.509 267.144 748.052 267.144 747.596 267.174H747.399C747.437 265.863 747.523 264.556 747.609 263.255C747.835 259.847 748.059 256.472 747.399 253.138C747.547 252.213 747.608 251.276 747.581 250.34C747.581 249.651 747.523 248.898 747.463 248.123V248.122C747.324 246.334 747.177 244.43 747.718 242.934C748.126 241.808 747.908 241.181 747.684 240.537C747.482 239.956 747.275 239.361 747.52 238.372C747.52 235.331 746.608 232.913 742.958 233.567C741.438 234.54 740.039 236.167 740.175 237.733C740.822 247.709 740.822 257.716 740.175 267.691C739.703 268.331 739.688 269.089 739.672 269.862C739.662 270.358 739.652 270.86 739.521 271.341C740.885 274.25 741.464 274.382 744.056 274.969L744.084 274.976C748.646 274.595 752.219 274.519 757.101 274.459C758.136 274.588 759.183 274.588 760.218 274.459C762.423 273.607 762.56 269.379 761.648 268.376C758.847 266.983 752.863 267.099 749.44 267.165C749.276 267.168 749.117 267.172 748.965 267.174ZM796.225 239.051C795.928 240.358 795.777 241.02 794.344 242.965C793.871 242.873 793.461 242.812 793.094 242.757C791.443 242.509 790.675 242.394 789.082 240.303C789.322 238.645 788.573 237.941 787.663 237.087C787.363 236.805 787.046 236.506 786.74 236.152C784.313 236.205 782.973 238.408 781.767 240.391C781.583 240.694 781.401 240.992 781.22 241.277C780.505 245.839 782.71 245.96 785.904 245.96C786.2 245.96 786.506 245.95 786.82 245.94C788.762 245.877 790.971 245.805 792.595 248.044C792.726 248.171 792.864 248.3 793.006 248.434C794.75 250.078 797.09 252.283 795.515 256.362C795.576 258.675 794.968 260.955 793.766 262.932C792.555 265.014 790.886 266.793 788.884 268.132C787.3 268.519 785.652 268.563 784.05 268.262C782.447 267.96 780.928 267.32 779.593 266.384C777.84 265.255 776.227 263.923 774.787 262.415L774.392 259.495C774.588 258.713 775.044 258.022 775.685 257.533C776.734 256.499 779.395 254.674 781.418 257.868C781.953 258.643 782.672 259.274 783.51 259.704C784.349 260.134 785.281 260.35 786.223 260.331C786.19 260.364 786.175 260.437 786.156 260.528C786.14 260.605 786.121 260.696 786.086 260.787C787.206 259.549 788.051 258.088 788.565 256.499C789.087 255.723 788.157 254.278 787.528 253.301C787.368 253.054 787.228 252.836 787.135 252.667C787.024 252.519 786.875 252.404 786.704 252.334C786.532 252.264 786.345 252.243 786.162 252.271H785.508C783.481 252.769 781.34 252.464 779.532 251.42C777.823 250.64 776.326 249.461 775.167 247.983C773.977 245.795 773.631 243.247 774.194 240.82C774.915 238.231 776.129 235.804 777.768 233.673C779.291 231.523 781.527 229.982 784.079 229.324C785.238 228.971 786.461 228.875 787.661 229.043C788.861 229.211 790.011 229.639 791.029 230.297C793.629 231.926 795.618 234.37 796.686 237.247C796.464 238 796.335 238.57 796.225 239.051Z"
  })));
}

var PREFIX$4 = "Brandmark";
var classes$4 = {
  root: PREFIX$4 + "-root",
  path: PREFIX$4 + "-path"
};
var Root$4 = styled('span', {
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['size', 'fill'].includes(prop);
  }
})(function (_ref) {
  var _svg, _ref2;

  var theme = _ref.theme,
      size = _ref.size;
  return _ref2 = {
    display: 'inline-block'
  }, _ref2["& svg"] = (_svg = {
    width: 'auto',
    height: theme.spacing(size === 'large' ? 5 : size === 'small' ? 3 : 4)
  }, _svg[theme.breakpoints.up('lg')] = {
    height: theme.spacing(size === 'large' ? 6 : size === 'small' ? 4 : 5)
  }, _svg), _ref2["& ." + classes$4.path] = {
    fill: 'currentColor'
  }, _ref2;
});
function Brandmark(props) {
  return /*#__PURE__*/React__default.createElement(Root$4, _extends({
    className: classes$4.root
  }, props, {
    "aria-label": "Hyperaudio Logo"
  }), /*#__PURE__*/React__default.createElement("svg", {
    width: "200px",
    height: "35px",
    viewBox: "0 0 200 35",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React__default.createElement("title", null, "Hyperaudio"), /*#__PURE__*/React__default.createElement("path", {
    d: "M7.962512,3.87725117 L7.962512,25.6570655 C7.96234999,26.6196117 7.57979673,27.5426642 6.89902103,28.2231343 C6.21824533,28.9036045 5.29502121,29.2854734 4.33247505,29.2854734 C2.3284154,29.2854734 0.703681347,27.6611252 0.703456402,25.6570655 L0.703456402,3.87725117 C0.703456402,2.91475902 1.08572697,1.99167254 1.7663117,1.31108782 C2.44689642,0.630503093 3.3699829,0.24823243 4.33247505,0.24823243 C5.29511051,0.24823243 6.21839583,0.630256485 6.89917738,1.31084707 C7.57995894,1.99143765 7.962512,2.91461569 7.962512,3.87725117 Z M26.1118821,29.2862879 C24.1071805,29.2862879 22.4820488,27.6611561 22.4820488,25.6564546 C22.4820488,23.651753 24.1071805,22.0266213 26.1118821,22.0266213 C28.1165837,22.0266213 29.7417154,23.651753 29.7417154,25.6564546 C29.7417154,27.6611561 28.1165837,29.2862879 26.1118821,29.2862879 Z M18.8526229,14.767362 L18.8526229,25.6572692 C18.8520605,27.6619242 17.22663,29.2866253 15.2219749,29.2862879 C13.2174789,29.2862879 11.5922966,27.6617651 11.5917343,25.6572692 L11.5917343,14.767362 C11.5920716,12.7625423 13.2171552,11.1373675 15.2219749,11.1369178 C17.2269072,11.137255 18.8521731,12.7624298 18.8526229,14.767362 Z M51.9247767,14.6808065 L51.9239621,14.6808065 C55.0802857,14.6808065 57.1559891,16.927177 57.1559891,20.3392977 L57.1559891,27.4480521 C57.1559891,28.5854936 56.3596782,29.4101132 55.2507492,29.4101132 C54.7352328,29.4113204 54.2413366,29.203082 53.882304,28.8331439 C53.5232714,28.4632059 53.3299001,27.9633017 53.3465276,27.4480521 L53.3465276,20.8796078 C53.3465276,19.2311833 52.2944197,18.150563 50.7305141,18.150563 C49.1666085,18.150563 48.0576794,19.258881 48.0576794,20.8796078 L48.0576794,27.4484595 C48.0791299,27.9652148 47.8872042,28.4680653 47.5269006,28.8391146 C47.1665969,29.2101638 46.6696021,29.4167799 46.1524396,29.4107189 C45.6323844,29.4180169 45.1318341,29.2127595 44.7667629,28.8423049 C44.4016917,28.4718503 44.203783,27.9683492 44.2188909,27.4484595 L44.2188909,9.36344593 C44.203783,8.84355621 44.4016917,8.34005509 44.7667629,7.96960051 C45.1318341,7.59914593 45.6323844,7.39388844 46.1524396,7.40118652 C46.6696021,7.3951255 47.1665969,7.60174162 47.5269006,7.97279084 C47.8872042,8.34384005 48.0791299,8.84669055 48.0576794,9.36344593 L48.0576794,16.2161997 C49.0874606,15.2046893 50.4816124,14.651155 51.9247767,14.6808065 Z M73.1078671,14.6808065 L73.1086817,14.6812138 C74.1218553,14.6992561 74.9388545,15.5162554 74.956943,16.5294289 C74.9591261,16.8380403 74.8807085,17.1418821 74.7294085,17.4108696 L68.5306072,30.1223124 C67.0235227,33.2216112 65.3174624,34.5297198 62.7582701,34.5297198 C62.2019475,34.541671 61.6494562,34.4350328 61.1375433,34.216898 C60.5424035,33.9536498 60.1619156,33.3605151 60.170769,32.7098135 C60.1759286,32.2590269 60.3631192,31.8294746 60.6897911,31.5187969 C61.016463,31.2081191 61.4548638,31.0427096 61.9053417,31.060167 C62.0474964,31.060167 62.1611388,31.0886794 62.2464723,31.0886794 C63.4690437,31.0886794 64.2936633,30.576067 64.919307,29.2964709 L65.4311047,28.1590294 L60.5687207,17.4387711 C60.4124855,17.1600251 60.3247406,16.8481364 60.31272,16.5288179 C60.3341166,15.5059794 61.1664013,14.6863393 62.1894475,14.6806028 C62.917664,14.661672 63.583261,15.0903753 63.8671991,15.7612231 L67.592549,24.0927526 L71.4018068,15.7614268 C71.7017366,15.0911689 72.3737212,14.6655332 73.1078671,14.6808065 Z M86.217058,14.6812138 L86.217058,14.6810102 C90.1698961,14.6810102 93.041503,17.7522039 93.041503,22.0172529 C93.041503,26.2823019 90.1694888,29.4101132 86.217058,29.4101132 C84.4539728,29.4101132 82.9754008,28.7846731 82.0086265,27.7040528 L82.0086265,32.5947456 C82.0157387,33.2851902 81.6514677,33.9262526 81.0546822,34.2735444 C80.4578968,34.6208362 79.7205676,34.6208362 79.1237822,34.2735444 C78.5269967,33.9262526 78.1627257,33.2851902 78.1698379,32.5947456 L78.1698379,16.5587559 C78.1601691,16.0505525 78.3577927,15.5603091 78.7172119,15.20089 C79.076631,14.8414708 79.5668744,14.6438472 80.0750778,14.653516 C81.0986733,14.653516 81.8664717,15.4213145 81.9232929,16.4734224 C82.8900672,15.3351663 84.3971517,14.6812138 86.217058,14.6812138 Z M85.5062844,25.9128626 C87.6105001,25.9128626 89.1458933,24.2921358 89.1458933,22.0457653 C89.1458933,19.7708824 87.6390125,18.1501557 85.5062844,18.1501557 C83.3735562,18.1501557 81.9518053,19.7140613 81.9518053,22.0172529 C81.9518053,24.3204446 83.4020686,25.9128626 85.5062844,25.9128626 Z M103.277865,14.6808065 L103.278069,14.6818248 C107.116857,14.6818248 109.960359,17.4685054 109.960359,21.2787815 L109.960359,21.3641151 C109.960359,22.5583777 109.107227,23.3261761 107.856143,23.3261761 L99.8382503,23.3261761 C100.293227,25.0892613 101.714978,26.1128568 103.790681,26.1128568 C104.824675,26.115892 105.838998,25.8303072 106.719516,25.2882372 C106.964658,25.1266557 107.250587,25.0378895 107.544136,25.0322365 C107.957641,25.0197779 108.358325,25.176591 108.653529,25.4664126 C108.948732,25.7562343 109.112891,26.1539653 109.108042,26.5676297 C109.108042,27.1930697 108.823732,27.6480463 108.141267,28.1030229 C106.815509,28.9721306 105.26117,29.4271958 103.67602,29.4103168 C99.2401007,29.4103168 95.9701347,26.2539932 95.9701347,22.0455617 C95.9701347,17.8654389 99.1262547,14.6808065 103.277865,14.6808065 Z M103.192328,17.7801053 L103.192531,17.7801053 C101.514984,17.7801053 100.263696,18.8890344 99.837232,20.6236071 L106.234806,20.6236071 C106.177984,18.9458555 104.984536,17.7801053 103.192328,17.7801053 Z M120.849655,14.8229612 L120.851285,14.8229612 C121.875084,14.8229612 122.585857,15.5054261 122.585857,16.557534 C122.585857,17.5811294 121.874269,18.2921067 120.793649,18.405749 C118.745439,18.5479038 117.494356,19.8843211 117.494356,22.045358 L117.494356,27.4490704 C117.515806,27.9658258 117.32388,28.4686763 116.963577,28.8397255 C116.603273,29.2107747 116.106278,29.4173909 115.589116,29.4111315 C115.069061,29.4186279 114.56851,29.2133704 114.203439,28.8429159 C113.838368,28.4724613 113.640459,27.9689602 113.655567,27.4490704 L113.655567,16.6143551 C113.63998,16.1018588 113.834757,15.6053001 114.194631,15.2400792 C114.554504,14.8748584 115.048137,14.6727798 115.560807,14.6808065 C116.540176,14.6753751 117.352376,15.4376351 117.409022,16.4153792 C118.272341,15.4129042 119.526709,14.832349 120.849655,14.8229612 Z M130.831646,14.6803992 L130.830424,14.6806028 C134.697725,14.6806028 136.915583,16.8701522 136.915583,20.7089407 L136.915583,27.4759536 C136.938077,27.9778765 136.752513,28.4668468 136.402682,28.827472 C136.05285,29.1880973 135.569742,29.3884299 135.067368,29.3811934 C134.17456,29.4008443 133.395963,28.7779667 133.219153,27.9026214 C132.195557,28.8693957 130.773806,29.4097059 129.096055,29.4097059 C126.195732,29.4097059 124.233671,27.7036455 124.233671,25.2012743 C124.233671,22.6705944 126.251738,21.1066888 129.551031,21.1066888 L133.078627,21.1066888 L133.078627,20.4810451 C133.078627,18.9171394 132.140162,18.0071863 130.434101,18.0071863 C129.433789,18.0078597 128.470017,18.3832254 127.732754,19.0592942 C127.277778,19.4006284 126.964956,19.5142708 126.595313,19.5142708 C126.168452,19.5282441 125.753765,19.3707329 125.44382,19.0768971 C125.133875,18.7830613 124.954475,18.377364 124.945666,17.9503651 C124.945666,17.4102586 125.229976,16.8984609 125.741774,16.4149719 C126.936036,15.3060429 128.784251,14.6803992 130.831646,14.6803992 Z M130.119447,26.5947165 C131.797198,26.5947165 133.076794,25.4004539 133.076794,23.8080358 L133.076794,23.6373687 L130.062625,23.6373687 C128.783029,23.6373687 128.100564,24.120654 128.100564,25.0591196 C128.100564,25.9975852 128.868363,26.5947165 130.119447,26.5947165 Z M147.692051,29.4101132 C143.853263,29.4101132 141.180326,26.7370749 141.180326,22.8699776 L141.180326,16.6143551 C141.173316,15.9239105 141.537587,15.2828481 142.134372,14.9355563 C142.731158,14.5882645 143.468487,14.5882645 144.065273,14.9355563 C144.662058,15.2828481 145.026329,15.9239105 145.019217,16.6143551 L145.019217,23.1827995 C145.019217,24.7467051 146.128146,25.8841465 147.692051,25.8841465 C149.227445,25.8841465 150.308065,24.7467051 150.308065,23.1827995 L150.308065,16.6143551 C150.300953,15.9239105 150.665224,15.2828481 151.262009,14.9355563 C151.858795,14.5882645 152.596124,14.5882645 153.192909,14.9355563 C153.789695,15.2828481 154.153966,15.9239105 154.146956,16.6143551 L154.146956,22.8699776 C154.146956,26.7372785 151.473815,29.4101132 147.692051,29.4101132 Z M170.69627,7.40118652 C171.213433,7.3951255 171.710427,7.60174162 172.070731,7.97279084 C172.431035,8.34384005 172.62296,8.84669055 172.60151,9.36344593 L172.60151,27.4765645 C172.623632,27.9859354 172.434933,28.4819221 172.079829,28.8477768 C171.724726,29.2136315 171.234587,29.4170365 170.724783,29.4102843 C169.724507,29.4010027 168.903217,28.6166993 168.848055,27.6179046 C167.881281,28.7561607 166.374196,29.4102843 164.55429,29.4102843 C160.601452,29.4102843 157.729845,26.3106107 157.729845,22.045358 C157.729845,17.7801053 160.601859,14.6806028 164.55429,14.6806028 C166.317375,14.6806028 167.795947,15.3062465 168.762721,16.3583544 L168.762721,9.36344593 C168.747614,8.84355621 168.945522,8.34005509 169.310593,7.96960051 C169.675665,7.59914593 170.176215,7.39388844 170.69627,7.40118652 Z M165.265267,25.9126589 C167.397995,25.9126589 168.819746,24.3487533 168.819746,22.0455617 C168.819746,19.74237 167.369483,18.149952 165.265267,18.149952 C163.161051,18.149952 161.625658,19.7991912 161.625658,22.0170493 C161.625658,24.2919322 163.132743,25.9126589 165.265267,25.9126589 Z M179.055701,7.54353961 C180.356385,7.53474837 181.421705,8.57472523 181.444226,9.87524366 C181.444226,11.1548398 180.335297,12.1784353 179.055701,12.1784353 C178.42953,12.1946162 177.822684,11.9608164 177.369233,11.5286889 C176.915782,11.0965613 176.653046,10.5016716 176.639071,9.87544732 C176.647061,9.24469922 176.906967,8.64334136 177.360895,8.20532723 C177.814823,7.76731311 178.425069,7.52902414 179.055701,7.54353961 Z M179.027189,29.4101132 C178.511496,29.4115971 178.017334,29.2034802 177.658079,28.833511 C177.298824,28.4635418 177.105315,27.9634788 177.121949,27.4480521 L177.121949,16.6133368 C177.114837,15.9228922 177.479108,15.2818298 178.075893,14.934538 C178.672678,14.5872462 179.410008,14.5872462 180.006793,14.934538 C180.603578,15.2818298 180.967849,15.9228922 180.960737,16.6133368 L180.960737,27.4480521 C180.975845,27.9679419 180.777936,28.471443 180.412865,28.8418976 C180.047794,29.2123521 179.547244,29.4176096 179.027189,29.4101132 Z M192.221509,14.6808065 C196.429737,14.6808065 199.78524,17.92226 199.78524,22.0170493 C199.78524,26.1118385 196.429126,29.3818044 192.192997,29.3818044 C187.98538,29.3818044 184.686087,26.1401472 184.686087,22.0170493 C184.686087,17.8939513 187.98538,14.6808065 192.221509,14.6808065 Z M192.221509,18.1782607 C190.117294,18.1782607 188.5819,19.7989875 188.5819,22.045358 C188.5819,24.2632161 190.117294,25.8556341 192.221509,25.8556341 C194.297213,25.8556341 195.861118,24.2349073 195.861118,22.045358 C195.861118,19.8279072 194.297213,18.1782607 192.221509,18.1782607 Z",
    id: "hyperaudio-logo",
    className: classes$4.path
  })));
}

var _excluded = ["MenuListProps"];
var StyledMenuItem = styled(MenuItem, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isActive';
  }
})(function (_ref) {
  var theme = _ref.theme,
      isActive = _ref.isActive;
  return {
    background: isActive ? theme.palette.action.hover : 'transparent'
  };
});
function RecursiveMenuItem(_ref2) {
  var _props$placement;

  var MenuListProps = _ref2.MenuListProps,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded);

  var _useState = useState(false),
      open = _useState[0],
      setOpen = _useState[1];

  var ref = useRef();
  return /*#__PURE__*/React__default.createElement(StyledMenuItem, _extends({}, props, {
    isActive: open,
    onMouseEnter: function onMouseEnter() {
      return setOpen(true);
    },
    onMouseLeave: function onMouseLeave() {
      return setOpen(false);
    },
    ref: ref
  }), props.label, /*#__PURE__*/React__default.createElement(Popper, {
    anchorEl: ref.current,
    open: open,
    placement: (_props$placement = props.placement) != null ? _props$placement : 'right'
  }, /*#__PURE__*/React__default.createElement(Grow, {
    appear: open,
    "in": open
  }, /*#__PURE__*/React__default.createElement(Paper, {
    elevation: 12
  }, /*#__PURE__*/React__default.createElement(MenuList, MenuListProps, props.children)))));
}

var PREFIX$5 = 'Thumb';
var classes$5 = {
  title: PREFIX$5 + "-title",
  actionArea: PREFIX$5 + "-actionArea"
};
var Root$5 = styled(Card, {
  shouldForwardProp: function shouldForwardProp(prop) {
    return prop !== 'isActive';
  }
})(function (_ref) {
  var _ref2;

  var theme = _ref.theme,
      isActive = _ref.isActive;
  return _ref2 = {
    background: isActive ? theme.palette.primary.main : 'transparent',
    color: isActive ? theme.palette.primary.contrastText : theme.palette.primary.dark,
    outline: "3px solid " + (isActive ? theme.palette.primary.main : 'transparent'),
    transitionDuration: theme.transitions.duration["short"],
    transitionProperty: 'background, background-color, outline, color'
  }, _ref2["&:hover"] = {
    background: isActive ? theme.palette.primary.main : theme.palette.primary.light,
    color: isActive ? theme.palette.primary.contrastText : theme.palette.primary.dark,
    outline: isActive ? "3px solid " + theme.palette.primary.main : "3px solid " + theme.palette.primary.light
  }, _ref2["& img"] = {
    display: 'inline-block',
    position: 'relative',
    width: '100%'
  }, _ref2["& ." + classes$5.title] = {
    margin: theme.spacing(0.5, 0, 0),
    padding: theme.spacing(0, 0.5)
  }, _ref2["& .MuiCardActionArea-focusHighlight"] = {
    display: 'none'
  }, _ref2["& ." + classes$5.actionArea] = {
    lineHeight: 0
  }, _ref2;
});
var Thumb = function Thumb(props) {
  var isActive = props.isActive,
      onClick = props.onClick,
      title = props.title,
      img = props.img,
      height = props.height,
      width = props.width;
  return /*#__PURE__*/React__default.createElement(Root$5, {
    elevation: 0,
    isActive: isActive,
    onClick: !isActive ? onClick : null
  }, /*#__PURE__*/React__default.createElement(CardActionArea, {
    disabled: isActive,
    className: classes$5.actionArea
  }, /*#__PURE__*/React__default.createElement("img", {
    alt: "Poster image for " + title,
    src: img,
    height: height + "px",
    width: width + "px"
  }), title && /*#__PURE__*/React__default.createElement(Tooltip, {
    enterDelay: 1500,
    title: title
  }, /*#__PURE__*/React__default.createElement(Typography, {
    display: "block",
    noWrap: true,
    variant: "caption",
    className: classes$5.title
  }, title))));
};

var useWindowSize = function useWindowSize() {
  var _useState = useState({
    width: undefined,
    height: undefined
  }),
      windowSize = _useState[0],
      setWindowSize = _useState[1];

  useEffect(function () {
    function handleResize() {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }

    window.addEventListener('resize', handleResize);
    handleResize();
    return function () {
      return window.removeEventListener('resize', handleResize);
    };
  }, []);
  return windowSize;
};

var FullSizeIcon = function FullSizeIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M21.1428667,3.9047619 L21.1428667,20 L2.85713333,20 L2.85713333,3.9047619 L21.1428667,3.9047619 Z M19.642,5.404 L4.357,5.404 L4.357,18.5 L19.642,18.5 L19.642,5.404 Z"
  }));
};

var HideSourceIcon = function HideSourceIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.915838,2.47741283 C10.6521239,2.47741283 11.2489859,3.08647012 11.2489859,3.83777847 L11.2489859,3.83777847 L11.2489859,20.1621239 C11.2489859,20.9134832 10.6521239,21.5225872 9.915838,21.5225872 L9.915838,21.5225872 L3.25007412,21.5225872 C2.51379532,21.5225872 1.91692191,20.9134832 1.91692191,20.1621239 L1.91692191,20.1621239 L1.91692191,3.83777993 C1.91692191,3.08647012 2.51379532,2.47741283 3.25007412,2.47741283 L3.25007412,2.47741283 Z M20.809594,2.90358796 C21.4689698,2.90358796 22.0112891,3.41493514 22.0765033,4.07020709 L22.0830781,4.20307161 L22.0830781,19.7968351 C22.0830781,20.4697097 21.5819697,21.0231507 20.9398018,21.0897024 L20.809594,21.096412 L14.4421506,21.096412 C13.7827813,21.096412 13.2404528,20.5850257 13.1752374,19.9297087 L13.1686625,19.7968351 L13.1686625,4.203073 C13.1686625,3.53024277 13.6697804,2.97684369 14.311944,2.91029705 L14.4421506,2.90358796 L20.809594,2.90358796 Z M20.8095872,4.20307161 L14.4421534,4.20307161 L14.4421534,19.7968351 L20.8095872,19.7968351 L20.8095872,4.20307161 Z"
  }));
};

var HyperaudioIcon = function HyperaudioIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M19.8744729,17.2495259 C21.3241505,17.2495259 22.4993463,18.4247217 22.4993463,19.8743993 C22.4993463,21.3240768 21.3241505,22.4992727 19.8744729,22.4992727 C18.4247954,22.4992727 17.2495995,21.3240768 17.2495995,19.8743993 C17.2495995,18.4247217 18.4247954,17.2495259 19.8744729,17.2495259 Z M11.9995582,9.37475839 C13.4494026,9.37500223 14.6246954,10.5502292 14.6250207,12.0000736 L14.6250207,19.8749883 C14.624614,21.3246322 13.4492021,22.4995167 11.9995582,22.4992728 C10.5500293,22.4992728 9.37479684,21.3245172 9.37439022,19.8749883 L9.37439022,12.0000736 C9.37463413,10.5503106 10.5497952,9.37508358 11.9995582,9.37475839 Z M4.12493796,1.50072717 C4.82105704,1.50072717 5.48872051,1.7769836 5.98102009,2.26914508 C6.47331967,2.76130656 6.74995864,3.42889245 6.74995864,4.12501154 L6.74995864,19.874841 C6.74984149,20.5708956 6.47320237,21.2383907 5.98090702,21.730465 C5.48861168,22.2225395 4.82099247,22.4986837 4.12493796,22.4986837 C2.67572461,22.4986837 1.50081632,21.3240544 1.50065366,19.874841 L1.50065366,4.12501154 C1.50065366,3.4289961 1.77708835,2.76147642 2.2692456,2.26931918 C2.76140283,1.77716193 3.42892251,1.50072717 4.12493796,1.50072717 Z"
  }));
};

var LowerThirdsIcon = function LowerThirdsIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.22856,14.0571467 L19.7714,14.0571467 L19.7714,5.37142667 L4.22856,5.37142667 L4.22856,14.0571467 Z M19.7714,15.4285733 L4.22856,15.4285733 L4.22856,18.6285333 L19.7714,18.6285333 L19.7714,15.4285733 Z M2.85713333,15.4285733 L2.85713333,14.0571467 L2.85713333,5.37142667 L2.85713333,4 L4.22856,4 L19.7714,4 L21.1428667,4 L21.1428667,5.37142667 L21.1428667,14.0571467 L21.1428667,15.4285733 L21.1428667,18.6285333 L21.1428667,20 L19.7714,20 L4.22856,20 L2.85713333,20 L2.85713333,18.6285333 L2.85713333,15.4285733 Z"
  }));
};

var MoveDownIcon = function MoveDownIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M4.33333333,18 L4.33333333,20 L3,20 L3,18 L4.33333333,18 Z M7,18.6666667 L7,20 L5,20 L5,18.6666667 L7,18.6666667 Z M9.66666667,18.6666667 L9.66666667,20 L7.66666667,20 L7.66666667,18.6666667 L9.66666667,18.6666667 Z M17.6666667,6.66666667 L17.6666667,14.6666667 L21,14.6666667 L17,18.6666667 L13,14.6666667 L16.3333333,14.6666667 L16.3333333,6.66666667 L17.6666667,6.66666667 Z M9.66666667,16 L9.66666667,18 L8.33333333,18 L8.33333333,16 L9.66666667,16 Z M4.33333333,15.3333333 L4.33333333,17.3333333 L3,17.3333333 L3,15.3333333 L4.33333333,15.3333333 Z M9.66666667,13.3333333 L9.66666667,15.3333333 L8.33333333,15.3333333 L8.33333333,13.3333333 L9.66666667,13.3333333 Z M5,13.3333333 L5,14.6666667 L3,14.6666667 L3,13.3333333 L5,13.3333333 Z M7.66666667,13.3333333 L7.66666667,14.6666667 L5.66666667,14.6666667 L5.66666667,13.3333333 L7.66666667,13.3333333 Z M9.66666667,4 L9.66666667,10.6666667 L3,10.6666667 L3,4 L9.66666667,4 Z M8.33333333,5.33333333 L4.33333333,5.33333333 L4.33333333,9.33333333 L8.33333333,9.33333333 L8.33333333,5.33333333 Z"
  }));
};

var MoveUpIcon = function MoveUpIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M9.66666667,13.3333333 L9.66666667,20 L3,20 L3,13.3333333 L9.66666667,13.3333333 Z M17,6.66666667 L21,10.6666667 L17.6666667,10.6666667 L17.6666667,18.6666667 L16.3333333,18.6666667 L16.3333333,10.6666667 L13,10.6666667 L17,6.66666667 Z M8.33333333,14.6666667 L4.33333333,14.6666667 L4.33333333,18.6666667 L8.33333333,18.6666667 L8.33333333,14.6666667 Z M4.33333333,8.66666667 L4.33333333,10.6666667 L3,10.6666667 L3,8.66666667 L4.33333333,8.66666667 Z M7,9.33333333 L7,10.6666667 L5,10.6666667 L5,9.33333333 L7,9.33333333 Z M9.66666667,9.33333333 L9.66666667,10.6666667 L7.66666667,10.6666667 L7.66666667,9.33333333 L9.66666667,9.33333333 Z M9.66666667,6.66666667 L9.66666667,8.66666667 L8.33333333,8.66666667 L8.33333333,6.66666667 L9.66666667,6.66666667 Z M4.33333333,6 L4.33333333,8 L3,8 L3,6 L4.33333333,6 Z M9.66666667,4 L9.66666667,6 L8.33333333,6 L8.33333333,4 L9.66666667,4 Z M5,4 L5,5.33333333 L3,5.33333333 L3,4 L5,4 Z M7.66666667,4 L7.66666667,5.33333333 L5.66666667,5.33333333 L5.66666667,4 L7.66666667,4 Z"
  }));
};

var Share1Pane = function Share1Pane(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M18.9666 2.5C19.6662 2.5 20.2333 3.06711 20.2333 3.76667V10.7333H3.7666V3.76667C3.7666 3.06711 4.33371 2.5 5.03327 2.5H18.9666ZM11.0499 4.97122C10.8388 4.84933 10.5749 5.00169 10.5749 5.24546V7.98787C10.5749 8.23164 10.8388 8.384 11.0499 8.26212L13.4249 6.89091C13.636 6.76902 13.636 6.46431 13.4249 6.34243L11.0499 4.97122ZM20.2333 11.3667H3.7666V20.2333C3.7666 20.9329 4.33371 21.5 5.03327 21.5H18.9666C19.6662 21.5 20.2333 20.9329 20.2333 20.2333V11.3667Z"
  }));
};

var Share2Panes = function Share2Panes(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M21.1829 2.50049C21.8824 2.50049 22.4495 3.06756 22.4495 3.76708V10.7333H12.3168V2.50049H21.1829ZM15.9582 5.24578V7.98802C15.9582 8.23178 16.2221 8.38413 16.4332 8.26225L18.808 6.89112C19.0191 6.76925 19.0191 6.46456 18.808 6.34268L16.4332 4.97155C16.2221 4.84967 15.9582 5.00203 15.9582 5.24578ZM11.6835 11.3666H1.55078V20.2327C1.55078 20.9323 2.11785 21.4993 2.81737 21.4993H11.6835V11.3666ZM22.4495 11.3666H12.3168V21.4993H21.1829C21.8824 21.4993 22.4495 20.9323 22.4495 20.2327V11.3666ZM1.55078 3.76708C1.55078 3.06756 2.11785 2.50049 2.81737 2.50049H11.6835V10.7333H1.55078V3.76708ZM8.04205 6.34268C8.25312 6.46456 8.25312 6.76925 8.04205 6.89112L5.66719 8.26225C5.4561 8.38413 5.19222 8.23178 5.19222 7.98802V5.24578C5.19222 5.00203 5.4561 4.84967 5.66719 4.97155L8.04205 6.34268Z"
  }));
};

var ShareIcon = function ShareIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M18.2035691,8.0859276 C14.8076295,8.0859276 12.2226431,9.23551412 10.4486387,11.5346728 C11.4623555,7.13202454 14.0473419,4.66163923 18.2035691,4.1235456 L18.2035691,1.48194802 L23.3735419,6.17810713 L18.2035691,10.8008957 L18.2035691,8.0859276 Z M20.5181372,18.3561646 L20.5181372,17.279087 C20.5181372,17.0092431 20.5144034,16.6744874 20.5105259,16.3206315 C20.506074,15.9244105 20.5013348,15.5043215 20.5013348,15.1249317 L20.5013348,12.9707764 L20.5013348,12.2527246 L18.3471795,12.2527246 L18.3471795,15.1081005 L18.3471795,18.3561646 L5.42227635,18.3561646 L5.42227635,6.49147928 L10.0896129,6.49147928 L10.0896129,4.37098624 L5.42227635,4.37098624 C4.81641299,4.37098624 4.30312373,4.58134668 3.88238991,5.00208194 C3.46165609,5.42281719 3.2512899,5.91927819 3.2512899,6.49147928 L3.2512899,18.3561646 C3.2512899,18.9620567 3.46165609,19.4753201 3.88238991,19.8960985 C4.30312373,20.3167332 4.81641299,20.5271224 5.42227635,20.5271224 L18.3471795,20.5271224 C18.9530716,20.5271224 19.466335,20.3167332 19.8871133,19.8960985 C20.3078917,19.4753201 20.5181372,18.9620567 20.5181372,18.3561646 Z"
  }));
};

var ShowContextIcon = function ShowContextIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M5,15 L3,15 L3,19 C3,20.1 3.9,21 5,21 L9,21 L9,19 L5,19 L5,15 Z M5,5 L9,5 L9,3 L5,3 C3.9,3 3,3.9 3,5 L3,9 L5,9 L5,5 Z M19,3 L15,3 L15,5 L19,5 L19,9 L21,9 L21,5 C21,3.9 20.1,3 19,3 Z M19,19 L15,19 L15,21 L19,21 C20.1,21 21,20.1 21,19 L21,15 L19,15 L19,19 Z"
  }));
};

var ShowSourceIcon = function ShowSourceIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("path", {
    d: "M20.809594,2.90358796 C21.4689698,2.90358796 22.0112891,3.41493514 22.0765033,4.07020709 L22.0830781,4.20307161 L22.0830781,19.7968351 C22.0830781,20.4697097 21.5819697,21.0231507 20.9398018,21.0897024 L20.809594,21.096412 L14.4421506,21.096412 C13.7827813,21.096412 13.2404528,20.5850257 13.1752374,19.9297087 L13.1686625,19.7968351 L13.1686625,4.203073 C13.1686625,3.53024277 13.6697804,2.97684369 14.311944,2.91029705 L14.4421506,2.90358796 L20.809594,2.90358796 Z M9.76667766,2.90358796 C10.4260534,2.90358796 10.9683727,3.41493514 11.0335869,4.07020709 L11.0401617,4.20307161 L11.0401617,19.7968351 C11.0401617,20.4697097 10.5390534,21.0231507 9.89688537,21.0897024 L9.76667766,21.096412 L3.39923426,21.096412 C2.73986493,21.096412 2.19753641,20.5850257 2.13232101,19.9297087 L2.12574612,19.7968351 L2.12574612,4.203073 C2.12574612,3.53024277 2.62686406,2.97684369 3.26902763,2.91029705 L3.39923426,2.90358796 L9.76667766,2.90358796 Z M20.8095872,4.20307161 L14.4421534,4.20307161 L14.4421534,19.7968351 L20.8095872,19.7968351 L20.8095872,4.20307161 Z M9.76667084,4.20307161 L3.39923699,4.20307161 L3.39923699,19.7968351 L9.76667084,19.7968351 L9.76667084,4.20307161 Z"
  }));
};

var StartDropIcon = function StartDropIcon(props) {
  return /*#__PURE__*/React__default.createElement(SvgIcon, props, /*#__PURE__*/React__default.createElement("polygon", {
    points: "8.30578512 13.5867769 9.79338843 12.0991736 13.6115702 15.9173554 13.6115702 6.19834711 3 6.19834711 3 4.0661157 15.6942149 4.0661157 15.6942149 15.9173554 19.5123967 12.0991736 21 13.5867769 14.6528926 19.9338843"
  }));
};

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

function getCjsExportFromNamespace (n) {
	return n && n['default'] || n;
}

var lodash = createCommonjsModule(function (module, exports) {
  (function () {
    var undefined$1;
    var VERSION = '4.17.21';
    var LARGE_ARRAY_SIZE = 200;
    var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
        FUNC_ERROR_TEXT = 'Expected a function',
        INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';
    var HASH_UNDEFINED = '__lodash_hash_undefined__';
    var MAX_MEMOIZE_SIZE = 500;
    var PLACEHOLDER = '__lodash_placeholder__';
    var CLONE_DEEP_FLAG = 1,
        CLONE_FLAT_FLAG = 2,
        CLONE_SYMBOLS_FLAG = 4;
    var COMPARE_PARTIAL_FLAG = 1,
        COMPARE_UNORDERED_FLAG = 2;
    var WRAP_BIND_FLAG = 1,
        WRAP_BIND_KEY_FLAG = 2,
        WRAP_CURRY_BOUND_FLAG = 4,
        WRAP_CURRY_FLAG = 8,
        WRAP_CURRY_RIGHT_FLAG = 16,
        WRAP_PARTIAL_FLAG = 32,
        WRAP_PARTIAL_RIGHT_FLAG = 64,
        WRAP_ARY_FLAG = 128,
        WRAP_REARG_FLAG = 256,
        WRAP_FLIP_FLAG = 512;
    var DEFAULT_TRUNC_LENGTH = 30,
        DEFAULT_TRUNC_OMISSION = '...';
    var HOT_COUNT = 800,
        HOT_SPAN = 16;
    var LAZY_FILTER_FLAG = 1,
        LAZY_MAP_FLAG = 2,
        LAZY_WHILE_FLAG = 3;
    var INFINITY = 1 / 0,
        MAX_SAFE_INTEGER = 9007199254740991,
        MAX_INTEGER = 1.7976931348623157e+308,
        NAN = 0 / 0;
    var MAX_ARRAY_LENGTH = 4294967295,
        MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
        HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
    var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];
    var argsTag = '[object Arguments]',
        arrayTag = '[object Array]',
        asyncTag = '[object AsyncFunction]',
        boolTag = '[object Boolean]',
        dateTag = '[object Date]',
        domExcTag = '[object DOMException]',
        errorTag = '[object Error]',
        funcTag = '[object Function]',
        genTag = '[object GeneratorFunction]',
        mapTag = '[object Map]',
        numberTag = '[object Number]',
        nullTag = '[object Null]',
        objectTag = '[object Object]',
        promiseTag = '[object Promise]',
        proxyTag = '[object Proxy]',
        regexpTag = '[object RegExp]',
        setTag = '[object Set]',
        stringTag = '[object String]',
        symbolTag = '[object Symbol]',
        undefinedTag = '[object Undefined]',
        weakMapTag = '[object WeakMap]',
        weakSetTag = '[object WeakSet]';
    var arrayBufferTag = '[object ArrayBuffer]',
        dataViewTag = '[object DataView]',
        float32Tag = '[object Float32Array]',
        float64Tag = '[object Float64Array]',
        int8Tag = '[object Int8Array]',
        int16Tag = '[object Int16Array]',
        int32Tag = '[object Int32Array]',
        uint8Tag = '[object Uint8Array]',
        uint8ClampedTag = '[object Uint8ClampedArray]',
        uint16Tag = '[object Uint16Array]',
        uint32Tag = '[object Uint32Array]';
    var reEmptyStringLeading = /\b__p \+= '';/g,
        reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
        reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
    var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
        reUnescapedHtml = /[&<>"']/g,
        reHasEscapedHtml = RegExp(reEscapedHtml.source),
        reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
    var reEscape = /<%-([\s\S]+?)%>/g,
        reEvaluate = /<%([\s\S]+?)%>/g,
        reInterpolate = /<%=([\s\S]+?)%>/g;
    var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
        reIsPlainProp = /^\w*$/,
        rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
    var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
        reHasRegExpChar = RegExp(reRegExpChar.source);
    var reTrimStart = /^\s+/;
    var reWhitespace = /\s/;
    var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
        reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
        reSplitDetails = /,? & /;
    var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
    var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
    var reEscapeChar = /\\(\\)?/g;
    var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
    var reFlags = /\w*$/;
    var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
    var reIsBinary = /^0b[01]+$/i;
    var reIsHostCtor = /^\[object .+?Constructor\]$/;
    var reIsOctal = /^0o[0-7]+$/i;
    var reIsUint = /^(?:0|[1-9]\d*)$/;
    var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
    var reNoMatch = /($^)/;
    var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
    var rsAstralRange = "\\ud800-\\udfff",
        rsComboMarksRange = "\\u0300-\\u036f",
        reComboHalfMarksRange = "\\ufe20-\\ufe2f",
        rsComboSymbolsRange = "\\u20d0-\\u20ff",
        rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
        rsDingbatRange = "\\u2700-\\u27bf",
        rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
        rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
        rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
        rsPunctuationRange = "\\u2000-\\u206f",
        rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
        rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
        rsVarRange = "\\ufe0e\\ufe0f",
        rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
    var rsApos = "['\u2019]",
        rsAstral = '[' + rsAstralRange + ']',
        rsBreak = '[' + rsBreakRange + ']',
        rsCombo = '[' + rsComboRange + ']',
        rsDigits = '\\d+',
        rsDingbat = '[' + rsDingbatRange + ']',
        rsLower = '[' + rsLowerRange + ']',
        rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
        rsFitz = "\\ud83c[\\udffb-\\udfff]",
        rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
        rsNonAstral = '[^' + rsAstralRange + ']',
        rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
        rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
        rsUpper = '[' + rsUpperRange + ']',
        rsZWJ = "\\u200d";
    var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
        rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
        rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
        rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
        reOptMod = rsModifier + '?',
        rsOptVar = '[' + rsVarRange + ']?',
        rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
        rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
        rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
        rsSeq = rsOptVar + reOptMod + rsOptJoin,
        rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
        rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
    var reApos = RegExp(rsApos, 'g');
    var reComboMark = RegExp(rsCombo, 'g');
    var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
    var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');
    var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');
    var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
    var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];
    var templateCounter = -1;
    var typedArrayTags = {};
    typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
    typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
    var cloneableTags = {};
    cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
    cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
    var deburredLetters = {
      '\xc0': 'A',
      '\xc1': 'A',
      '\xc2': 'A',
      '\xc3': 'A',
      '\xc4': 'A',
      '\xc5': 'A',
      '\xe0': 'a',
      '\xe1': 'a',
      '\xe2': 'a',
      '\xe3': 'a',
      '\xe4': 'a',
      '\xe5': 'a',
      '\xc7': 'C',
      '\xe7': 'c',
      '\xd0': 'D',
      '\xf0': 'd',
      '\xc8': 'E',
      '\xc9': 'E',
      '\xca': 'E',
      '\xcb': 'E',
      '\xe8': 'e',
      '\xe9': 'e',
      '\xea': 'e',
      '\xeb': 'e',
      '\xcc': 'I',
      '\xcd': 'I',
      '\xce': 'I',
      '\xcf': 'I',
      '\xec': 'i',
      '\xed': 'i',
      '\xee': 'i',
      '\xef': 'i',
      '\xd1': 'N',
      '\xf1': 'n',
      '\xd2': 'O',
      '\xd3': 'O',
      '\xd4': 'O',
      '\xd5': 'O',
      '\xd6': 'O',
      '\xd8': 'O',
      '\xf2': 'o',
      '\xf3': 'o',
      '\xf4': 'o',
      '\xf5': 'o',
      '\xf6': 'o',
      '\xf8': 'o',
      '\xd9': 'U',
      '\xda': 'U',
      '\xdb': 'U',
      '\xdc': 'U',
      '\xf9': 'u',
      '\xfa': 'u',
      '\xfb': 'u',
      '\xfc': 'u',
      '\xdd': 'Y',
      '\xfd': 'y',
      '\xff': 'y',
      '\xc6': 'Ae',
      '\xe6': 'ae',
      '\xde': 'Th',
      '\xfe': 'th',
      '\xdf': 'ss',
      "\u0100": 'A',
      "\u0102": 'A',
      "\u0104": 'A',
      "\u0101": 'a',
      "\u0103": 'a',
      "\u0105": 'a',
      "\u0106": 'C',
      "\u0108": 'C',
      "\u010A": 'C',
      "\u010C": 'C',
      "\u0107": 'c',
      "\u0109": 'c',
      "\u010B": 'c',
      "\u010D": 'c',
      "\u010E": 'D',
      "\u0110": 'D',
      "\u010F": 'd',
      "\u0111": 'd',
      "\u0112": 'E',
      "\u0114": 'E',
      "\u0116": 'E',
      "\u0118": 'E',
      "\u011A": 'E',
      "\u0113": 'e',
      "\u0115": 'e',
      "\u0117": 'e',
      "\u0119": 'e',
      "\u011B": 'e',
      "\u011C": 'G',
      "\u011E": 'G',
      "\u0120": 'G',
      "\u0122": 'G',
      "\u011D": 'g',
      "\u011F": 'g',
      "\u0121": 'g',
      "\u0123": 'g',
      "\u0124": 'H',
      "\u0126": 'H',
      "\u0125": 'h',
      "\u0127": 'h',
      "\u0128": 'I',
      "\u012A": 'I',
      "\u012C": 'I',
      "\u012E": 'I',
      "\u0130": 'I',
      "\u0129": 'i',
      "\u012B": 'i',
      "\u012D": 'i',
      "\u012F": 'i',
      "\u0131": 'i',
      "\u0134": 'J',
      "\u0135": 'j',
      "\u0136": 'K',
      "\u0137": 'k',
      "\u0138": 'k',
      "\u0139": 'L',
      "\u013B": 'L',
      "\u013D": 'L',
      "\u013F": 'L',
      "\u0141": 'L',
      "\u013A": 'l',
      "\u013C": 'l',
      "\u013E": 'l',
      "\u0140": 'l',
      "\u0142": 'l',
      "\u0143": 'N',
      "\u0145": 'N',
      "\u0147": 'N',
      "\u014A": 'N',
      "\u0144": 'n',
      "\u0146": 'n',
      "\u0148": 'n',
      "\u014B": 'n',
      "\u014C": 'O',
      "\u014E": 'O',
      "\u0150": 'O',
      "\u014D": 'o',
      "\u014F": 'o',
      "\u0151": 'o',
      "\u0154": 'R',
      "\u0156": 'R',
      "\u0158": 'R',
      "\u0155": 'r',
      "\u0157": 'r',
      "\u0159": 'r',
      "\u015A": 'S',
      "\u015C": 'S',
      "\u015E": 'S',
      "\u0160": 'S',
      "\u015B": 's',
      "\u015D": 's',
      "\u015F": 's',
      "\u0161": 's',
      "\u0162": 'T',
      "\u0164": 'T',
      "\u0166": 'T',
      "\u0163": 't',
      "\u0165": 't',
      "\u0167": 't',
      "\u0168": 'U',
      "\u016A": 'U',
      "\u016C": 'U',
      "\u016E": 'U',
      "\u0170": 'U',
      "\u0172": 'U',
      "\u0169": 'u',
      "\u016B": 'u',
      "\u016D": 'u',
      "\u016F": 'u',
      "\u0171": 'u',
      "\u0173": 'u',
      "\u0174": 'W',
      "\u0175": 'w',
      "\u0176": 'Y',
      "\u0177": 'y',
      "\u0178": 'Y',
      "\u0179": 'Z',
      "\u017B": 'Z',
      "\u017D": 'Z',
      "\u017A": 'z',
      "\u017C": 'z',
      "\u017E": 'z',
      "\u0132": 'IJ',
      "\u0133": 'ij',
      "\u0152": 'Oe',
      "\u0153": 'oe',
      "\u0149": "'n",
      "\u017F": 's'
    };
    var htmlEscapes = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;'
    };
    var htmlUnescapes = {
      '&amp;': '&',
      '&lt;': '<',
      '&gt;': '>',
      '&quot;': '"',
      '&#39;': "'"
    };
    var stringEscapes = {
      '\\': '\\',
      "'": "'",
      '\n': 'n',
      '\r': 'r',
      "\u2028": 'u2028',
      "\u2029": 'u2029'
    };
    var freeParseFloat = parseFloat,
        freeParseInt = parseInt;
    var freeGlobal = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
    var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
    var root = freeGlobal || freeSelf || Function('return this')();
    var freeExports =  exports && !exports.nodeType && exports;
    var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
    var moduleExports = freeModule && freeModule.exports === freeExports;
    var freeProcess = moduleExports && freeGlobal.process;

    var nodeUtil = function () {
      try {
        var types = freeModule && freeModule.require && freeModule.require('util').types;

        if (types) {
          return types;
        }

        return freeProcess && freeProcess.binding && freeProcess.binding('util');
      } catch (e) {}
    }();

    var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
        nodeIsDate = nodeUtil && nodeUtil.isDate,
        nodeIsMap = nodeUtil && nodeUtil.isMap,
        nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
        nodeIsSet = nodeUtil && nodeUtil.isSet,
        nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

    function apply(func, thisArg, args) {
      switch (args.length) {
        case 0:
          return func.call(thisArg);

        case 1:
          return func.call(thisArg, args[0]);

        case 2:
          return func.call(thisArg, args[0], args[1]);

        case 3:
          return func.call(thisArg, args[0], args[1], args[2]);
      }

      return func.apply(thisArg, args);
    }

    function arrayAggregator(array, setter, iteratee, accumulator) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        var value = array[index];
        setter(accumulator, value, iteratee(value), array);
      }

      return accumulator;
    }

    function arrayEach(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (iteratee(array[index], index, array) === false) {
          break;
        }
      }

      return array;
    }

    function arrayEachRight(array, iteratee) {
      var length = array == null ? 0 : array.length;

      while (length--) {
        if (iteratee(array[length], length, array) === false) {
          break;
        }
      }

      return array;
    }

    function arrayEvery(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (!predicate(array[index], index, array)) {
          return false;
        }
      }

      return true;
    }

    function arrayFilter(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];

        if (predicate(value, index, array)) {
          result[resIndex++] = value;
        }
      }

      return result;
    }

    function arrayIncludes(array, value) {
      var length = array == null ? 0 : array.length;
      return !!length && baseIndexOf(array, value, 0) > -1;
    }

    function arrayIncludesWith(array, value, comparator) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (comparator(value, array[index])) {
          return true;
        }
      }

      return false;
    }

    function arrayMap(array, iteratee) {
      var index = -1,
          length = array == null ? 0 : array.length,
          result = Array(length);

      while (++index < length) {
        result[index] = iteratee(array[index], index, array);
      }

      return result;
    }

    function arrayPush(array, values) {
      var index = -1,
          length = values.length,
          offset = array.length;

      while (++index < length) {
        array[offset + index] = values[index];
      }

      return array;
    }

    function arrayReduce(array, iteratee, accumulator, initAccum) {
      var index = -1,
          length = array == null ? 0 : array.length;

      if (initAccum && length) {
        accumulator = array[++index];
      }

      while (++index < length) {
        accumulator = iteratee(accumulator, array[index], index, array);
      }

      return accumulator;
    }

    function arrayReduceRight(array, iteratee, accumulator, initAccum) {
      var length = array == null ? 0 : array.length;

      if (initAccum && length) {
        accumulator = array[--length];
      }

      while (length--) {
        accumulator = iteratee(accumulator, array[length], length, array);
      }

      return accumulator;
    }

    function arraySome(array, predicate) {
      var index = -1,
          length = array == null ? 0 : array.length;

      while (++index < length) {
        if (predicate(array[index], index, array)) {
          return true;
        }
      }

      return false;
    }

    var asciiSize = baseProperty('length');

    function asciiToArray(string) {
      return string.split('');
    }

    function asciiWords(string) {
      return string.match(reAsciiWord) || [];
    }

    function baseFindKey(collection, predicate, eachFunc) {
      var result;
      eachFunc(collection, function (value, key, collection) {
        if (predicate(value, key, collection)) {
          result = key;
          return false;
        }
      });
      return result;
    }

    function baseFindIndex(array, predicate, fromIndex, fromRight) {
      var length = array.length,
          index = fromIndex + (fromRight ? 1 : -1);

      while (fromRight ? index-- : ++index < length) {
        if (predicate(array[index], index, array)) {
          return index;
        }
      }

      return -1;
    }

    function baseIndexOf(array, value, fromIndex) {
      return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
    }

    function baseIndexOfWith(array, value, fromIndex, comparator) {
      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (comparator(array[index], value)) {
          return index;
        }
      }

      return -1;
    }

    function baseIsNaN(value) {
      return value !== value;
    }

    function baseMean(array, iteratee) {
      var length = array == null ? 0 : array.length;
      return length ? baseSum(array, iteratee) / length : NAN;
    }

    function baseProperty(key) {
      return function (object) {
        return object == null ? undefined$1 : object[key];
      };
    }

    function basePropertyOf(object) {
      return function (key) {
        return object == null ? undefined$1 : object[key];
      };
    }

    function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
      eachFunc(collection, function (value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
      });
      return accumulator;
    }

    function baseSortBy(array, comparer) {
      var length = array.length;
      array.sort(comparer);

      while (length--) {
        array[length] = array[length].value;
      }

      return array;
    }

    function baseSum(array, iteratee) {
      var result,
          index = -1,
          length = array.length;

      while (++index < length) {
        var current = iteratee(array[index]);

        if (current !== undefined$1) {
          result = result === undefined$1 ? current : result + current;
        }
      }

      return result;
    }

    function baseTimes(n, iteratee) {
      var index = -1,
          result = Array(n);

      while (++index < n) {
        result[index] = iteratee(index);
      }

      return result;
    }

    function baseToPairs(object, props) {
      return arrayMap(props, function (key) {
        return [key, object[key]];
      });
    }

    function baseTrim(string) {
      return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
    }

    function baseUnary(func) {
      return function (value) {
        return func(value);
      };
    }

    function baseValues(object, props) {
      return arrayMap(props, function (key) {
        return object[key];
      });
    }

    function cacheHas(cache, key) {
      return cache.has(key);
    }

    function charsStartIndex(strSymbols, chrSymbols) {
      var index = -1,
          length = strSymbols.length;

      while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

      return index;
    }

    function charsEndIndex(strSymbols, chrSymbols) {
      var index = strSymbols.length;

      while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}

      return index;
    }

    function countHolders(array, placeholder) {
      var length = array.length,
          result = 0;

      while (length--) {
        if (array[length] === placeholder) {
          ++result;
        }
      }

      return result;
    }

    var deburrLetter = basePropertyOf(deburredLetters);
    var escapeHtmlChar = basePropertyOf(htmlEscapes);

    function escapeStringChar(chr) {
      return '\\' + stringEscapes[chr];
    }

    function getValue(object, key) {
      return object == null ? undefined$1 : object[key];
    }

    function hasUnicode(string) {
      return reHasUnicode.test(string);
    }

    function hasUnicodeWord(string) {
      return reHasUnicodeWord.test(string);
    }

    function iteratorToArray(iterator) {
      var data,
          result = [];

      while (!(data = iterator.next()).done) {
        result.push(data.value);
      }

      return result;
    }

    function mapToArray(map) {
      var index = -1,
          result = Array(map.size);
      map.forEach(function (value, key) {
        result[++index] = [key, value];
      });
      return result;
    }

    function overArg(func, transform) {
      return function (arg) {
        return func(transform(arg));
      };
    }

    function replaceHolders(array, placeholder) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];

        if (value === placeholder || value === PLACEHOLDER) {
          array[index] = PLACEHOLDER;
          result[resIndex++] = index;
        }
      }

      return result;
    }

    function setToArray(set) {
      var index = -1,
          result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = value;
      });
      return result;
    }

    function setToPairs(set) {
      var index = -1,
          result = Array(set.size);
      set.forEach(function (value) {
        result[++index] = [value, value];
      });
      return result;
    }

    function strictIndexOf(array, value, fromIndex) {
      var index = fromIndex - 1,
          length = array.length;

      while (++index < length) {
        if (array[index] === value) {
          return index;
        }
      }

      return -1;
    }

    function strictLastIndexOf(array, value, fromIndex) {
      var index = fromIndex + 1;

      while (index--) {
        if (array[index] === value) {
          return index;
        }
      }

      return index;
    }

    function stringSize(string) {
      return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
    }

    function stringToArray(string) {
      return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
    }

    function trimmedEndIndex(string) {
      var index = string.length;

      while (index-- && reWhitespace.test(string.charAt(index))) {}

      return index;
    }

    var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

    function unicodeSize(string) {
      var result = reUnicode.lastIndex = 0;

      while (reUnicode.test(string)) {
        ++result;
      }

      return result;
    }

    function unicodeToArray(string) {
      return string.match(reUnicode) || [];
    }

    function unicodeWords(string) {
      return string.match(reUnicodeWord) || [];
    }

    var runInContext = function runInContext(context) {
      context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
      var Array = context.Array,
          Date = context.Date,
          Error = context.Error,
          Function = context.Function,
          Math = context.Math,
          Object = context.Object,
          RegExp = context.RegExp,
          String = context.String,
          TypeError = context.TypeError;
      var arrayProto = Array.prototype,
          funcProto = Function.prototype,
          objectProto = Object.prototype;
      var coreJsData = context['__core-js_shared__'];
      var funcToString = funcProto.toString;
      var hasOwnProperty = objectProto.hasOwnProperty;
      var idCounter = 0;

      var maskSrcKey = function () {
        var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
        return uid ? 'Symbol(src)_1.' + uid : '';
      }();

      var nativeObjectToString = objectProto.toString;
      var objectCtorString = funcToString.call(Object);
      var oldDash = root._;
      var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
      var Buffer = moduleExports ? context.Buffer : undefined$1,
          Symbol = context.Symbol,
          Uint8Array = context.Uint8Array,
          allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined$1,
          getPrototype = overArg(Object.getPrototypeOf, Object),
          objectCreate = Object.create,
          propertyIsEnumerable = objectProto.propertyIsEnumerable,
          splice = arrayProto.splice,
          spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined$1,
          symIterator = Symbol ? Symbol.iterator : undefined$1,
          symToStringTag = Symbol ? Symbol.toStringTag : undefined$1;

      var defineProperty = function () {
        try {
          var func = getNative(Object, 'defineProperty');
          func({}, '', {});
          return func;
        } catch (e) {}
      }();

      var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
          ctxNow = Date && Date.now !== root.Date.now && Date.now,
          ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
      var nativeCeil = Math.ceil,
          nativeFloor = Math.floor,
          nativeGetSymbols = Object.getOwnPropertySymbols,
          nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined$1,
          nativeIsFinite = context.isFinite,
          nativeJoin = arrayProto.join,
          nativeKeys = overArg(Object.keys, Object),
          nativeMax = Math.max,
          nativeMin = Math.min,
          nativeNow = Date.now,
          nativeParseInt = context.parseInt,
          nativeRandom = Math.random,
          nativeReverse = arrayProto.reverse;
      var DataView = getNative(context, 'DataView'),
          Map = getNative(context, 'Map'),
          Promise = getNative(context, 'Promise'),
          Set = getNative(context, 'Set'),
          WeakMap = getNative(context, 'WeakMap'),
          nativeCreate = getNative(Object, 'create');
      var metaMap = WeakMap && new WeakMap();
      var realNames = {};
      var dataViewCtorString = toSource(DataView),
          mapCtorString = toSource(Map),
          promiseCtorString = toSource(Promise),
          setCtorString = toSource(Set),
          weakMapCtorString = toSource(WeakMap);
      var symbolProto = Symbol ? Symbol.prototype : undefined$1,
          symbolValueOf = symbolProto ? symbolProto.valueOf : undefined$1,
          symbolToString = symbolProto ? symbolProto.toString : undefined$1;

      function lodash(value) {
        if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
          if (value instanceof LodashWrapper) {
            return value;
          }

          if (hasOwnProperty.call(value, '__wrapped__')) {
            return wrapperClone(value);
          }
        }

        return new LodashWrapper(value);
      }

      var baseCreate = function () {
        function object() {}

        return function (proto) {
          if (!isObject(proto)) {
            return {};
          }

          if (objectCreate) {
            return objectCreate(proto);
          }

          object.prototype = proto;
          var result = new object();
          object.prototype = undefined$1;
          return result;
        };
      }();

      function baseLodash() {}

      function LodashWrapper(value, chainAll) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__chain__ = !!chainAll;
        this.__index__ = 0;
        this.__values__ = undefined$1;
      }

      lodash.templateSettings = {
        'escape': reEscape,
        'evaluate': reEvaluate,
        'interpolate': reInterpolate,
        'variable': '',
        'imports': {
          '_': lodash
        }
      };
      lodash.prototype = baseLodash.prototype;
      lodash.prototype.constructor = lodash;
      LodashWrapper.prototype = baseCreate(baseLodash.prototype);
      LodashWrapper.prototype.constructor = LodashWrapper;

      function LazyWrapper(value) {
        this.__wrapped__ = value;
        this.__actions__ = [];
        this.__dir__ = 1;
        this.__filtered__ = false;
        this.__iteratees__ = [];
        this.__takeCount__ = MAX_ARRAY_LENGTH;
        this.__views__ = [];
      }

      function lazyClone() {
        var result = new LazyWrapper(this.__wrapped__);
        result.__actions__ = copyArray(this.__actions__);
        result.__dir__ = this.__dir__;
        result.__filtered__ = this.__filtered__;
        result.__iteratees__ = copyArray(this.__iteratees__);
        result.__takeCount__ = this.__takeCount__;
        result.__views__ = copyArray(this.__views__);
        return result;
      }

      function lazyReverse() {
        if (this.__filtered__) {
          var result = new LazyWrapper(this);
          result.__dir__ = -1;
          result.__filtered__ = true;
        } else {
          result = this.clone();
          result.__dir__ *= -1;
        }

        return result;
      }

      function lazyValue() {
        var array = this.__wrapped__.value(),
            dir = this.__dir__,
            isArr = isArray(array),
            isRight = dir < 0,
            arrLength = isArr ? array.length : 0,
            view = getView(0, arrLength, this.__views__),
            start = view.start,
            end = view.end,
            length = end - start,
            index = isRight ? end : start - 1,
            iteratees = this.__iteratees__,
            iterLength = iteratees.length,
            resIndex = 0,
            takeCount = nativeMin(length, this.__takeCount__);

        if (!isArr || !isRight && arrLength == length && takeCount == length) {
          return baseWrapperValue(array, this.__actions__);
        }

        var result = [];

        outer: while (length-- && resIndex < takeCount) {
          index += dir;
          var iterIndex = -1,
              value = array[index];

          while (++iterIndex < iterLength) {
            var data = iteratees[iterIndex],
                iteratee = data.iteratee,
                type = data.type,
                computed = iteratee(value);

            if (type == LAZY_MAP_FLAG) {
              value = computed;
            } else if (!computed) {
              if (type == LAZY_FILTER_FLAG) {
                continue outer;
              } else {
                break outer;
              }
            }
          }

          result[resIndex++] = value;
        }

        return result;
      }

      LazyWrapper.prototype = baseCreate(baseLodash.prototype);
      LazyWrapper.prototype.constructor = LazyWrapper;

      function Hash(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      function hashClear() {
        this.__data__ = nativeCreate ? nativeCreate(null) : {};
        this.size = 0;
      }

      function hashDelete(key) {
        var result = this.has(key) && delete this.__data__[key];
        this.size -= result ? 1 : 0;
        return result;
      }

      function hashGet(key) {
        var data = this.__data__;

        if (nativeCreate) {
          var result = data[key];
          return result === HASH_UNDEFINED ? undefined$1 : result;
        }

        return hasOwnProperty.call(data, key) ? data[key] : undefined$1;
      }

      function hashHas(key) {
        var data = this.__data__;
        return nativeCreate ? data[key] !== undefined$1 : hasOwnProperty.call(data, key);
      }

      function hashSet(key, value) {
        var data = this.__data__;
        this.size += this.has(key) ? 0 : 1;
        data[key] = nativeCreate && value === undefined$1 ? HASH_UNDEFINED : value;
        return this;
      }

      Hash.prototype.clear = hashClear;
      Hash.prototype['delete'] = hashDelete;
      Hash.prototype.get = hashGet;
      Hash.prototype.has = hashHas;
      Hash.prototype.set = hashSet;

      function ListCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      function listCacheClear() {
        this.__data__ = [];
        this.size = 0;
      }

      function listCacheDelete(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          return false;
        }

        var lastIndex = data.length - 1;

        if (index == lastIndex) {
          data.pop();
        } else {
          splice.call(data, index, 1);
        }

        --this.size;
        return true;
      }

      function listCacheGet(key) {
        var data = this.__data__,
            index = assocIndexOf(data, key);
        return index < 0 ? undefined$1 : data[index][1];
      }

      function listCacheHas(key) {
        return assocIndexOf(this.__data__, key) > -1;
      }

      function listCacheSet(key, value) {
        var data = this.__data__,
            index = assocIndexOf(data, key);

        if (index < 0) {
          ++this.size;
          data.push([key, value]);
        } else {
          data[index][1] = value;
        }

        return this;
      }

      ListCache.prototype.clear = listCacheClear;
      ListCache.prototype['delete'] = listCacheDelete;
      ListCache.prototype.get = listCacheGet;
      ListCache.prototype.has = listCacheHas;
      ListCache.prototype.set = listCacheSet;

      function MapCache(entries) {
        var index = -1,
            length = entries == null ? 0 : entries.length;
        this.clear();

        while (++index < length) {
          var entry = entries[index];
          this.set(entry[0], entry[1]);
        }
      }

      function mapCacheClear() {
        this.size = 0;
        this.__data__ = {
          'hash': new Hash(),
          'map': new (Map || ListCache)(),
          'string': new Hash()
        };
      }

      function mapCacheDelete(key) {
        var result = getMapData(this, key)['delete'](key);
        this.size -= result ? 1 : 0;
        return result;
      }

      function mapCacheGet(key) {
        return getMapData(this, key).get(key);
      }

      function mapCacheHas(key) {
        return getMapData(this, key).has(key);
      }

      function mapCacheSet(key, value) {
        var data = getMapData(this, key),
            size = data.size;
        data.set(key, value);
        this.size += data.size == size ? 0 : 1;
        return this;
      }

      MapCache.prototype.clear = mapCacheClear;
      MapCache.prototype['delete'] = mapCacheDelete;
      MapCache.prototype.get = mapCacheGet;
      MapCache.prototype.has = mapCacheHas;
      MapCache.prototype.set = mapCacheSet;

      function SetCache(values) {
        var index = -1,
            length = values == null ? 0 : values.length;
        this.__data__ = new MapCache();

        while (++index < length) {
          this.add(values[index]);
        }
      }

      function setCacheAdd(value) {
        this.__data__.set(value, HASH_UNDEFINED);

        return this;
      }

      function setCacheHas(value) {
        return this.__data__.has(value);
      }

      SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
      SetCache.prototype.has = setCacheHas;

      function Stack(entries) {
        var data = this.__data__ = new ListCache(entries);
        this.size = data.size;
      }

      function stackClear() {
        this.__data__ = new ListCache();
        this.size = 0;
      }

      function stackDelete(key) {
        var data = this.__data__,
            result = data['delete'](key);
        this.size = data.size;
        return result;
      }

      function stackGet(key) {
        return this.__data__.get(key);
      }

      function stackHas(key) {
        return this.__data__.has(key);
      }

      function stackSet(key, value) {
        var data = this.__data__;

        if (data instanceof ListCache) {
          var pairs = data.__data__;

          if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
            pairs.push([key, value]);
            this.size = ++data.size;
            return this;
          }

          data = this.__data__ = new MapCache(pairs);
        }

        data.set(key, value);
        this.size = data.size;
        return this;
      }

      Stack.prototype.clear = stackClear;
      Stack.prototype['delete'] = stackDelete;
      Stack.prototype.get = stackGet;
      Stack.prototype.has = stackHas;
      Stack.prototype.set = stackSet;

      function arrayLikeKeys(value, inherited) {
        var isArr = isArray(value),
            isArg = !isArr && isArguments(value),
            isBuff = !isArr && !isArg && isBuffer(value),
            isType = !isArr && !isArg && !isBuff && isTypedArray(value),
            skipIndexes = isArr || isArg || isBuff || isType,
            result = skipIndexes ? baseTimes(value.length, String) : [],
            length = result.length;

        for (var key in value) {
          if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (key == 'length' || isBuff && (key == 'offset' || key == 'parent') || isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || isIndex(key, length)))) {
            result.push(key);
          }
        }

        return result;
      }

      function arraySample(array) {
        var length = array.length;
        return length ? array[baseRandom(0, length - 1)] : undefined$1;
      }

      function arraySampleSize(array, n) {
        return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
      }

      function arrayShuffle(array) {
        return shuffleSelf(copyArray(array));
      }

      function assignMergeValue(object, key, value) {
        if (value !== undefined$1 && !eq(object[key], value) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      function assignValue(object, key, value) {
        var objValue = object[key];

        if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined$1 && !(key in object)) {
          baseAssignValue(object, key, value);
        }
      }

      function assocIndexOf(array, key) {
        var length = array.length;

        while (length--) {
          if (eq(array[length][0], key)) {
            return length;
          }
        }

        return -1;
      }

      function baseAggregator(collection, setter, iteratee, accumulator) {
        baseEach(collection, function (value, key, collection) {
          setter(accumulator, value, iteratee(value), collection);
        });
        return accumulator;
      }

      function baseAssign(object, source) {
        return object && copyObject(source, keys(source), object);
      }

      function baseAssignIn(object, source) {
        return object && copyObject(source, keysIn(source), object);
      }

      function baseAssignValue(object, key, value) {
        if (key == '__proto__' && defineProperty) {
          defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
          });
        } else {
          object[key] = value;
        }
      }

      function baseAt(object, paths) {
        var index = -1,
            length = paths.length,
            result = Array(length),
            skip = object == null;

        while (++index < length) {
          result[index] = skip ? undefined$1 : get(object, paths[index]);
        }

        return result;
      }

      function baseClamp(number, lower, upper) {
        if (number === number) {
          if (upper !== undefined$1) {
            number = number <= upper ? number : upper;
          }

          if (lower !== undefined$1) {
            number = number >= lower ? number : lower;
          }
        }

        return number;
      }

      function baseClone(value, bitmask, customizer, key, object, stack) {
        var result,
            isDeep = bitmask & CLONE_DEEP_FLAG,
            isFlat = bitmask & CLONE_FLAT_FLAG,
            isFull = bitmask & CLONE_SYMBOLS_FLAG;

        if (customizer) {
          result = object ? customizer(value, key, object, stack) : customizer(value);
        }

        if (result !== undefined$1) {
          return result;
        }

        if (!isObject(value)) {
          return value;
        }

        var isArr = isArray(value);

        if (isArr) {
          result = initCloneArray(value);

          if (!isDeep) {
            return copyArray(value, result);
          }
        } else {
          var tag = getTag(value),
              isFunc = tag == funcTag || tag == genTag;

          if (isBuffer(value)) {
            return cloneBuffer(value, isDeep);
          }

          if (tag == objectTag || tag == argsTag || isFunc && !object) {
            result = isFlat || isFunc ? {} : initCloneObject(value);

            if (!isDeep) {
              return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
            }
          } else {
            if (!cloneableTags[tag]) {
              return object ? value : {};
            }

            result = initCloneByTag(value, tag, isDeep);
          }
        }

        stack || (stack = new Stack());
        var stacked = stack.get(value);

        if (stacked) {
          return stacked;
        }

        stack.set(value, result);

        if (isSet(value)) {
          value.forEach(function (subValue) {
            result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
          });
        } else if (isMap(value)) {
          value.forEach(function (subValue, key) {
            result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
          });
        }

        var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
        var props = isArr ? undefined$1 : keysFunc(value);
        arrayEach(props || value, function (subValue, key) {
          if (props) {
            key = subValue;
            subValue = value[key];
          }

          assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
        return result;
      }

      function baseConforms(source) {
        var props = keys(source);
        return function (object) {
          return baseConformsTo(object, source, props);
        };
      }

      function baseConformsTo(object, source, props) {
        var length = props.length;

        if (object == null) {
          return !length;
        }

        object = Object(object);

        while (length--) {
          var key = props[length],
              predicate = source[key],
              value = object[key];

          if (value === undefined$1 && !(key in object) || !predicate(value)) {
            return false;
          }
        }

        return true;
      }

      function baseDelay(func, wait, args) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        return setTimeout(function () {
          func.apply(undefined$1, args);
        }, wait);
      }

      function baseDifference(array, values, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            isCommon = true,
            length = array.length,
            result = [],
            valuesLength = values.length;

        if (!length) {
          return result;
        }

        if (iteratee) {
          values = arrayMap(values, baseUnary(iteratee));
        }

        if (comparator) {
          includes = arrayIncludesWith;
          isCommon = false;
        } else if (values.length >= LARGE_ARRAY_SIZE) {
          includes = cacheHas;
          isCommon = false;
          values = new SetCache(values);
        }

        outer: while (++index < length) {
          var value = array[index],
              computed = iteratee == null ? value : iteratee(value);
          value = comparator || value !== 0 ? value : 0;

          if (isCommon && computed === computed) {
            var valuesIndex = valuesLength;

            while (valuesIndex--) {
              if (values[valuesIndex] === computed) {
                continue outer;
              }
            }

            result.push(value);
          } else if (!includes(values, computed, comparator)) {
            result.push(value);
          }
        }

        return result;
      }

      var baseEach = createBaseEach(baseForOwn);
      var baseEachRight = createBaseEach(baseForOwnRight, true);

      function baseEvery(collection, predicate) {
        var result = true;
        baseEach(collection, function (value, index, collection) {
          result = !!predicate(value, index, collection);
          return result;
        });
        return result;
      }

      function baseExtremum(array, iteratee, comparator) {
        var index = -1,
            length = array.length;

        while (++index < length) {
          var value = array[index],
              current = iteratee(value);

          if (current != null && (computed === undefined$1 ? current === current && !isSymbol(current) : comparator(current, computed))) {
            var computed = current,
                result = value;
          }
        }

        return result;
      }

      function baseFill(array, value, start, end) {
        var length = array.length;
        start = toInteger(start);

        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }

        end = end === undefined$1 || end > length ? length : toInteger(end);

        if (end < 0) {
          end += length;
        }

        end = start > end ? 0 : toLength(end);

        while (start < end) {
          array[start++] = value;
        }

        return array;
      }

      function baseFilter(collection, predicate) {
        var result = [];
        baseEach(collection, function (value, index, collection) {
          if (predicate(value, index, collection)) {
            result.push(value);
          }
        });
        return result;
      }

      function baseFlatten(array, depth, predicate, isStrict, result) {
        var index = -1,
            length = array.length;
        predicate || (predicate = isFlattenable);
        result || (result = []);

        while (++index < length) {
          var value = array[index];

          if (depth > 0 && predicate(value)) {
            if (depth > 1) {
              baseFlatten(value, depth - 1, predicate, isStrict, result);
            } else {
              arrayPush(result, value);
            }
          } else if (!isStrict) {
            result[result.length] = value;
          }
        }

        return result;
      }

      var baseFor = createBaseFor();
      var baseForRight = createBaseFor(true);

      function baseForOwn(object, iteratee) {
        return object && baseFor(object, iteratee, keys);
      }

      function baseForOwnRight(object, iteratee) {
        return object && baseForRight(object, iteratee, keys);
      }

      function baseFunctions(object, props) {
        return arrayFilter(props, function (key) {
          return isFunction(object[key]);
        });
      }

      function baseGet(object, path) {
        path = castPath(path, object);
        var index = 0,
            length = path.length;

        while (object != null && index < length) {
          object = object[toKey(path[index++])];
        }

        return index && index == length ? object : undefined$1;
      }

      function baseGetAllKeys(object, keysFunc, symbolsFunc) {
        var result = keysFunc(object);
        return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
      }

      function baseGetTag(value) {
        if (value == null) {
          return value === undefined$1 ? undefinedTag : nullTag;
        }

        return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
      }

      function baseGt(value, other) {
        return value > other;
      }

      function baseHas(object, key) {
        return object != null && hasOwnProperty.call(object, key);
      }

      function baseHasIn(object, key) {
        return object != null && key in Object(object);
      }

      function baseInRange(number, start, end) {
        return number >= nativeMin(start, end) && number < nativeMax(start, end);
      }

      function baseIntersection(arrays, iteratee, comparator) {
        var includes = comparator ? arrayIncludesWith : arrayIncludes,
            length = arrays[0].length,
            othLength = arrays.length,
            othIndex = othLength,
            caches = Array(othLength),
            maxLength = Infinity,
            result = [];

        while (othIndex--) {
          var array = arrays[othIndex];

          if (othIndex && iteratee) {
            array = arrayMap(array, baseUnary(iteratee));
          }

          maxLength = nativeMin(array.length, maxLength);
          caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined$1;
        }

        array = arrays[0];
        var index = -1,
            seen = caches[0];

        outer: while (++index < length && result.length < maxLength) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;

          if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;

            while (--othIndex) {
              var cache = caches[othIndex];

              if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
                continue outer;
              }
            }

            if (seen) {
              seen.push(computed);
            }

            result.push(value);
          }
        }

        return result;
      }

      function baseInverter(object, setter, iteratee, accumulator) {
        baseForOwn(object, function (value, key, object) {
          setter(accumulator, iteratee(value), key, object);
        });
        return accumulator;
      }

      function baseInvoke(object, path, args) {
        path = castPath(path, object);
        object = parent(object, path);
        var func = object == null ? object : object[toKey(last(path))];
        return func == null ? undefined$1 : apply(func, object, args);
      }

      function baseIsArguments(value) {
        return isObjectLike(value) && baseGetTag(value) == argsTag;
      }

      function baseIsArrayBuffer(value) {
        return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
      }

      function baseIsDate(value) {
        return isObjectLike(value) && baseGetTag(value) == dateTag;
      }

      function baseIsEqual(value, other, bitmask, customizer, stack) {
        if (value === other) {
          return true;
        }

        if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
          return value !== value && other !== other;
        }

        return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
      }

      function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
        var objIsArr = isArray(object),
            othIsArr = isArray(other),
            objTag = objIsArr ? arrayTag : getTag(object),
            othTag = othIsArr ? arrayTag : getTag(other);
        objTag = objTag == argsTag ? objectTag : objTag;
        othTag = othTag == argsTag ? objectTag : othTag;
        var objIsObj = objTag == objectTag,
            othIsObj = othTag == objectTag,
            isSameTag = objTag == othTag;

        if (isSameTag && isBuffer(object)) {
          if (!isBuffer(other)) {
            return false;
          }

          objIsArr = true;
          objIsObj = false;
        }

        if (isSameTag && !objIsObj) {
          stack || (stack = new Stack());
          return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
        }

        if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
          var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
              othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

          if (objIsWrapped || othIsWrapped) {
            var objUnwrapped = objIsWrapped ? object.value() : object,
                othUnwrapped = othIsWrapped ? other.value() : other;
            stack || (stack = new Stack());
            return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
          }
        }

        if (!isSameTag) {
          return false;
        }

        stack || (stack = new Stack());
        return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
      }

      function baseIsMap(value) {
        return isObjectLike(value) && getTag(value) == mapTag;
      }

      function baseIsMatch(object, source, matchData, customizer) {
        var index = matchData.length,
            length = index,
            noCustomizer = !customizer;

        if (object == null) {
          return !length;
        }

        object = Object(object);

        while (index--) {
          var data = matchData[index];

          if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
            return false;
          }
        }

        while (++index < length) {
          data = matchData[index];
          var key = data[0],
              objValue = object[key],
              srcValue = data[1];

          if (noCustomizer && data[2]) {
            if (objValue === undefined$1 && !(key in object)) {
              return false;
            }
          } else {
            var stack = new Stack();

            if (customizer) {
              var result = customizer(objValue, srcValue, key, object, source, stack);
            }

            if (!(result === undefined$1 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
              return false;
            }
          }
        }

        return true;
      }

      function baseIsNative(value) {
        if (!isObject(value) || isMasked(value)) {
          return false;
        }

        var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
        return pattern.test(toSource(value));
      }

      function baseIsRegExp(value) {
        return isObjectLike(value) && baseGetTag(value) == regexpTag;
      }

      function baseIsSet(value) {
        return isObjectLike(value) && getTag(value) == setTag;
      }

      function baseIsTypedArray(value) {
        return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
      }

      function baseIteratee(value) {
        if (typeof value == 'function') {
          return value;
        }

        if (value == null) {
          return identity;
        }

        if (typeof value == 'object') {
          return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
        }

        return property(value);
      }

      function baseKeys(object) {
        if (!isPrototype(object)) {
          return nativeKeys(object);
        }

        var result = [];

        for (var key in Object(object)) {
          if (hasOwnProperty.call(object, key) && key != 'constructor') {
            result.push(key);
          }
        }

        return result;
      }

      function baseKeysIn(object) {
        if (!isObject(object)) {
          return nativeKeysIn(object);
        }

        var isProto = isPrototype(object),
            result = [];

        for (var key in object) {
          if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
            result.push(key);
          }
        }

        return result;
      }

      function baseLt(value, other) {
        return value < other;
      }

      function baseMap(collection, iteratee) {
        var index = -1,
            result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value, key, collection) {
          result[++index] = iteratee(value, key, collection);
        });
        return result;
      }

      function baseMatches(source) {
        var matchData = getMatchData(source);

        if (matchData.length == 1 && matchData[0][2]) {
          return matchesStrictComparable(matchData[0][0], matchData[0][1]);
        }

        return function (object) {
          return object === source || baseIsMatch(object, source, matchData);
        };
      }

      function baseMatchesProperty(path, srcValue) {
        if (isKey(path) && isStrictComparable(srcValue)) {
          return matchesStrictComparable(toKey(path), srcValue);
        }

        return function (object) {
          var objValue = get(object, path);
          return objValue === undefined$1 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
        };
      }

      function baseMerge(object, source, srcIndex, customizer, stack) {
        if (object === source) {
          return;
        }

        baseFor(source, function (srcValue, key) {
          stack || (stack = new Stack());

          if (isObject(srcValue)) {
            baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
          } else {
            var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined$1;

            if (newValue === undefined$1) {
              newValue = srcValue;
            }

            assignMergeValue(object, key, newValue);
          }
        }, keysIn);
      }

      function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
        var objValue = safeGet(object, key),
            srcValue = safeGet(source, key),
            stacked = stack.get(srcValue);

        if (stacked) {
          assignMergeValue(object, key, stacked);
          return;
        }

        var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined$1;
        var isCommon = newValue === undefined$1;

        if (isCommon) {
          var isArr = isArray(srcValue),
              isBuff = !isArr && isBuffer(srcValue),
              isTyped = !isArr && !isBuff && isTypedArray(srcValue);
          newValue = srcValue;

          if (isArr || isBuff || isTyped) {
            if (isArray(objValue)) {
              newValue = objValue;
            } else if (isArrayLikeObject(objValue)) {
              newValue = copyArray(objValue);
            } else if (isBuff) {
              isCommon = false;
              newValue = cloneBuffer(srcValue, true);
            } else if (isTyped) {
              isCommon = false;
              newValue = cloneTypedArray(srcValue, true);
            } else {
              newValue = [];
            }
          } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
            newValue = objValue;

            if (isArguments(objValue)) {
              newValue = toPlainObject(objValue);
            } else if (!isObject(objValue) || isFunction(objValue)) {
              newValue = initCloneObject(srcValue);
            }
          } else {
            isCommon = false;
          }
        }

        if (isCommon) {
          stack.set(srcValue, newValue);
          mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
          stack['delete'](srcValue);
        }

        assignMergeValue(object, key, newValue);
      }

      function baseNth(array, n) {
        var length = array.length;

        if (!length) {
          return;
        }

        n += n < 0 ? length : 0;
        return isIndex(n, length) ? array[n] : undefined$1;
      }

      function baseOrderBy(collection, iteratees, orders) {
        if (iteratees.length) {
          iteratees = arrayMap(iteratees, function (iteratee) {
            if (isArray(iteratee)) {
              return function (value) {
                return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
              };
            }

            return iteratee;
          });
        } else {
          iteratees = [identity];
        }

        var index = -1;
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        var result = baseMap(collection, function (value, key, collection) {
          var criteria = arrayMap(iteratees, function (iteratee) {
            return iteratee(value);
          });
          return {
            'criteria': criteria,
            'index': ++index,
            'value': value
          };
        });
        return baseSortBy(result, function (object, other) {
          return compareMultiple(object, other, orders);
        });
      }

      function basePick(object, paths) {
        return basePickBy(object, paths, function (value, path) {
          return hasIn(object, path);
        });
      }

      function basePickBy(object, paths, predicate) {
        var index = -1,
            length = paths.length,
            result = {};

        while (++index < length) {
          var path = paths[index],
              value = baseGet(object, path);

          if (predicate(value, path)) {
            baseSet(result, castPath(path, object), value);
          }
        }

        return result;
      }

      function basePropertyDeep(path) {
        return function (object) {
          return baseGet(object, path);
        };
      }

      function basePullAll(array, values, iteratee, comparator) {
        var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
            index = -1,
            length = values.length,
            seen = array;

        if (array === values) {
          values = copyArray(values);
        }

        if (iteratee) {
          seen = arrayMap(array, baseUnary(iteratee));
        }

        while (++index < length) {
          var fromIndex = 0,
              value = values[index],
              computed = iteratee ? iteratee(value) : value;

          while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
            if (seen !== array) {
              splice.call(seen, fromIndex, 1);
            }

            splice.call(array, fromIndex, 1);
          }
        }

        return array;
      }

      function basePullAt(array, indexes) {
        var length = array ? indexes.length : 0,
            lastIndex = length - 1;

        while (length--) {
          var index = indexes[length];

          if (length == lastIndex || index !== previous) {
            var previous = index;

            if (isIndex(index)) {
              splice.call(array, index, 1);
            } else {
              baseUnset(array, index);
            }
          }
        }

        return array;
      }

      function baseRandom(lower, upper) {
        return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
      }

      function baseRange(start, end, step, fromRight) {
        var index = -1,
            length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
            result = Array(length);

        while (length--) {
          result[fromRight ? length : ++index] = start;
          start += step;
        }

        return result;
      }

      function baseRepeat(string, n) {
        var result = '';

        if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
          return result;
        }

        do {
          if (n % 2) {
            result += string;
          }

          n = nativeFloor(n / 2);

          if (n) {
            string += string;
          }
        } while (n);

        return result;
      }

      function baseRest(func, start) {
        return setToString(overRest(func, start, identity), func + '');
      }

      function baseSample(collection) {
        return arraySample(values(collection));
      }

      function baseSampleSize(collection, n) {
        var array = values(collection);
        return shuffleSelf(array, baseClamp(n, 0, array.length));
      }

      function baseSet(object, path, value, customizer) {
        if (!isObject(object)) {
          return object;
        }

        path = castPath(path, object);
        var index = -1,
            length = path.length,
            lastIndex = length - 1,
            nested = object;

        while (nested != null && ++index < length) {
          var key = toKey(path[index]),
              newValue = value;

          if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
            return object;
          }

          if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined$1;

            if (newValue === undefined$1) {
              newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
            }
          }

          assignValue(nested, key, newValue);
          nested = nested[key];
        }

        return object;
      }

      var baseSetData = !metaMap ? identity : function (func, data) {
        metaMap.set(func, data);
        return func;
      };
      var baseSetToString = !defineProperty ? identity : function (func, string) {
        return defineProperty(func, 'toString', {
          'configurable': true,
          'enumerable': false,
          'value': constant(string),
          'writable': true
        });
      };

      function baseShuffle(collection) {
        return shuffleSelf(values(collection));
      }

      function baseSlice(array, start, end) {
        var index = -1,
            length = array.length;

        if (start < 0) {
          start = -start > length ? 0 : length + start;
        }

        end = end > length ? length : end;

        if (end < 0) {
          end += length;
        }

        length = start > end ? 0 : end - start >>> 0;
        start >>>= 0;
        var result = Array(length);

        while (++index < length) {
          result[index] = array[index + start];
        }

        return result;
      }

      function baseSome(collection, predicate) {
        var result;
        baseEach(collection, function (value, index, collection) {
          result = predicate(value, index, collection);
          return !result;
        });
        return !!result;
      }

      function baseSortedIndex(array, value, retHighest) {
        var low = 0,
            high = array == null ? low : array.length;

        if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
          while (low < high) {
            var mid = low + high >>> 1,
                computed = array[mid];

            if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }

          return high;
        }

        return baseSortedIndexBy(array, value, identity, retHighest);
      }

      function baseSortedIndexBy(array, value, iteratee, retHighest) {
        var low = 0,
            high = array == null ? 0 : array.length;

        if (high === 0) {
          return 0;
        }

        value = iteratee(value);
        var valIsNaN = value !== value,
            valIsNull = value === null,
            valIsSymbol = isSymbol(value),
            valIsUndefined = value === undefined$1;

        while (low < high) {
          var mid = nativeFloor((low + high) / 2),
              computed = iteratee(array[mid]),
              othIsDefined = computed !== undefined$1,
              othIsNull = computed === null,
              othIsReflexive = computed === computed,
              othIsSymbol = isSymbol(computed);

          if (valIsNaN) {
            var setLow = retHighest || othIsReflexive;
          } else if (valIsUndefined) {
            setLow = othIsReflexive && (retHighest || othIsDefined);
          } else if (valIsNull) {
            setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
          } else if (valIsSymbol) {
            setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
          } else if (othIsNull || othIsSymbol) {
            setLow = false;
          } else {
            setLow = retHighest ? computed <= value : computed < value;
          }

          if (setLow) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }

        return nativeMin(high, MAX_ARRAY_INDEX);
      }

      function baseSortedUniq(array, iteratee) {
        var index = -1,
            length = array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;

          if (!index || !eq(computed, seen)) {
            var seen = computed;
            result[resIndex++] = value === 0 ? 0 : value;
          }
        }

        return result;
      }

      function baseToNumber(value) {
        if (typeof value == 'number') {
          return value;
        }

        if (isSymbol(value)) {
          return NAN;
        }

        return +value;
      }

      function baseToString(value) {
        if (typeof value == 'string') {
          return value;
        }

        if (isArray(value)) {
          return arrayMap(value, baseToString) + '';
        }

        if (isSymbol(value)) {
          return symbolToString ? symbolToString.call(value) : '';
        }

        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      function baseUniq(array, iteratee, comparator) {
        var index = -1,
            includes = arrayIncludes,
            length = array.length,
            isCommon = true,
            result = [],
            seen = result;

        if (comparator) {
          isCommon = false;
          includes = arrayIncludesWith;
        } else if (length >= LARGE_ARRAY_SIZE) {
          var set = iteratee ? null : createSet(array);

          if (set) {
            return setToArray(set);
          }

          isCommon = false;
          includes = cacheHas;
          seen = new SetCache();
        } else {
          seen = iteratee ? [] : result;
        }

        outer: while (++index < length) {
          var value = array[index],
              computed = iteratee ? iteratee(value) : value;
          value = comparator || value !== 0 ? value : 0;

          if (isCommon && computed === computed) {
            var seenIndex = seen.length;

            while (seenIndex--) {
              if (seen[seenIndex] === computed) {
                continue outer;
              }
            }

            if (iteratee) {
              seen.push(computed);
            }

            result.push(value);
          } else if (!includes(seen, computed, comparator)) {
            if (seen !== result) {
              seen.push(computed);
            }

            result.push(value);
          }
        }

        return result;
      }

      function baseUnset(object, path) {
        path = castPath(path, object);
        object = parent(object, path);
        return object == null || delete object[toKey(last(path))];
      }

      function baseUpdate(object, path, updater, customizer) {
        return baseSet(object, path, updater(baseGet(object, path)), customizer);
      }

      function baseWhile(array, predicate, isDrop, fromRight) {
        var length = array.length,
            index = fromRight ? length : -1;

        while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}

        return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
      }

      function baseWrapperValue(value, actions) {
        var result = value;

        if (result instanceof LazyWrapper) {
          result = result.value();
        }

        return arrayReduce(actions, function (result, action) {
          return action.func.apply(action.thisArg, arrayPush([result], action.args));
        }, result);
      }

      function baseXor(arrays, iteratee, comparator) {
        var length = arrays.length;

        if (length < 2) {
          return length ? baseUniq(arrays[0]) : [];
        }

        var index = -1,
            result = Array(length);

        while (++index < length) {
          var array = arrays[index],
              othIndex = -1;

          while (++othIndex < length) {
            if (othIndex != index) {
              result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
            }
          }
        }

        return baseUniq(baseFlatten(result, 1), iteratee, comparator);
      }

      function baseZipObject(props, values, assignFunc) {
        var index = -1,
            length = props.length,
            valsLength = values.length,
            result = {};

        while (++index < length) {
          var value = index < valsLength ? values[index] : undefined$1;
          assignFunc(result, props[index], value);
        }

        return result;
      }

      function castArrayLikeObject(value) {
        return isArrayLikeObject(value) ? value : [];
      }

      function castFunction(value) {
        return typeof value == 'function' ? value : identity;
      }

      function castPath(value, object) {
        if (isArray(value)) {
          return value;
        }

        return isKey(value, object) ? [value] : stringToPath(toString(value));
      }

      var castRest = baseRest;

      function castSlice(array, start, end) {
        var length = array.length;
        end = end === undefined$1 ? length : end;
        return !start && end >= length ? array : baseSlice(array, start, end);
      }

      var clearTimeout = ctxClearTimeout || function (id) {
        return root.clearTimeout(id);
      };

      function cloneBuffer(buffer, isDeep) {
        if (isDeep) {
          return buffer.slice();
        }

        var length = buffer.length,
            result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
        buffer.copy(result);
        return result;
      }

      function cloneArrayBuffer(arrayBuffer) {
        var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
        new Uint8Array(result).set(new Uint8Array(arrayBuffer));
        return result;
      }

      function cloneDataView(dataView, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
        return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
      }

      function cloneRegExp(regexp) {
        var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
        result.lastIndex = regexp.lastIndex;
        return result;
      }

      function cloneSymbol(symbol) {
        return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
      }

      function cloneTypedArray(typedArray, isDeep) {
        var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
        return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
      }

      function compareAscending(value, other) {
        if (value !== other) {
          var valIsDefined = value !== undefined$1,
              valIsNull = value === null,
              valIsReflexive = value === value,
              valIsSymbol = isSymbol(value);
          var othIsDefined = other !== undefined$1,
              othIsNull = other === null,
              othIsReflexive = other === other,
              othIsSymbol = isSymbol(other);

          if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
            return 1;
          }

          if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
            return -1;
          }
        }

        return 0;
      }

      function compareMultiple(object, other, orders) {
        var index = -1,
            objCriteria = object.criteria,
            othCriteria = other.criteria,
            length = objCriteria.length,
            ordersLength = orders.length;

        while (++index < length) {
          var result = compareAscending(objCriteria[index], othCriteria[index]);

          if (result) {
            if (index >= ordersLength) {
              return result;
            }

            var order = orders[index];
            return result * (order == 'desc' ? -1 : 1);
          }
        }

        return object.index - other.index;
      }

      function composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1,
            argsLength = args.length,
            holdersLength = holders.length,
            leftIndex = -1,
            leftLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(leftLength + rangeLength),
            isUncurried = !isCurried;

        while (++leftIndex < leftLength) {
          result[leftIndex] = partials[leftIndex];
        }

        while (++argsIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[holders[argsIndex]] = args[argsIndex];
          }
        }

        while (rangeLength--) {
          result[leftIndex++] = args[argsIndex++];
        }

        return result;
      }

      function composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1,
            argsLength = args.length,
            holdersIndex = -1,
            holdersLength = holders.length,
            rightIndex = -1,
            rightLength = partials.length,
            rangeLength = nativeMax(argsLength - holdersLength, 0),
            result = Array(rangeLength + rightLength),
            isUncurried = !isCurried;

        while (++argsIndex < rangeLength) {
          result[argsIndex] = args[argsIndex];
        }

        var offset = argsIndex;

        while (++rightIndex < rightLength) {
          result[offset + rightIndex] = partials[rightIndex];
        }

        while (++holdersIndex < holdersLength) {
          if (isUncurried || argsIndex < argsLength) {
            result[offset + holders[holdersIndex]] = args[argsIndex++];
          }
        }

        return result;
      }

      function copyArray(source, array) {
        var index = -1,
            length = source.length;
        array || (array = Array(length));

        while (++index < length) {
          array[index] = source[index];
        }

        return array;
      }

      function copyObject(source, props, object, customizer) {
        var isNew = !object;
        object || (object = {});
        var index = -1,
            length = props.length;

        while (++index < length) {
          var key = props[index];
          var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined$1;

          if (newValue === undefined$1) {
            newValue = source[key];
          }

          if (isNew) {
            baseAssignValue(object, key, newValue);
          } else {
            assignValue(object, key, newValue);
          }
        }

        return object;
      }

      function copySymbols(source, object) {
        return copyObject(source, getSymbols(source), object);
      }

      function copySymbolsIn(source, object) {
        return copyObject(source, getSymbolsIn(source), object);
      }

      function createAggregator(setter, initializer) {
        return function (collection, iteratee) {
          var func = isArray(collection) ? arrayAggregator : baseAggregator,
              accumulator = initializer ? initializer() : {};
          return func(collection, setter, getIteratee(iteratee, 2), accumulator);
        };
      }

      function createAssigner(assigner) {
        return baseRest(function (object, sources) {
          var index = -1,
              length = sources.length,
              customizer = length > 1 ? sources[length - 1] : undefined$1,
              guard = length > 2 ? sources[2] : undefined$1;
          customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined$1;

          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            customizer = length < 3 ? undefined$1 : customizer;
            length = 1;
          }

          object = Object(object);

          while (++index < length) {
            var source = sources[index];

            if (source) {
              assigner(object, source, index, customizer);
            }
          }

          return object;
        });
      }

      function createBaseEach(eachFunc, fromRight) {
        return function (collection, iteratee) {
          if (collection == null) {
            return collection;
          }

          if (!isArrayLike(collection)) {
            return eachFunc(collection, iteratee);
          }

          var length = collection.length,
              index = fromRight ? length : -1,
              iterable = Object(collection);

          while (fromRight ? index-- : ++index < length) {
            if (iteratee(iterable[index], index, iterable) === false) {
              break;
            }
          }

          return collection;
        };
      }

      function createBaseFor(fromRight) {
        return function (object, iteratee, keysFunc) {
          var index = -1,
              iterable = Object(object),
              props = keysFunc(object),
              length = props.length;

          while (length--) {
            var key = props[fromRight ? length : ++index];

            if (iteratee(iterable[key], key, iterable) === false) {
              break;
            }
          }

          return object;
        };
      }

      function createBind(func, bitmask, thisArg) {
        var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);

        function wrapper() {
          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return fn.apply(isBind ? thisArg : this, arguments);
        }

        return wrapper;
      }

      function createCaseFirst(methodName) {
        return function (string) {
          string = toString(string);
          var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined$1;
          var chr = strSymbols ? strSymbols[0] : string.charAt(0);
          var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
          return chr[methodName]() + trailing;
        };
      }

      function createCompounder(callback) {
        return function (string) {
          return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
        };
      }

      function createCtor(Ctor) {
        return function () {
          var args = arguments;

          switch (args.length) {
            case 0:
              return new Ctor();

            case 1:
              return new Ctor(args[0]);

            case 2:
              return new Ctor(args[0], args[1]);

            case 3:
              return new Ctor(args[0], args[1], args[2]);

            case 4:
              return new Ctor(args[0], args[1], args[2], args[3]);

            case 5:
              return new Ctor(args[0], args[1], args[2], args[3], args[4]);

            case 6:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);

            case 7:
              return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
          }

          var thisBinding = baseCreate(Ctor.prototype),
              result = Ctor.apply(thisBinding, args);
          return isObject(result) ? result : thisBinding;
        };
      }

      function createCurry(func, bitmask, arity) {
        var Ctor = createCtor(func);

        function wrapper() {
          var length = arguments.length,
              args = Array(length),
              index = length,
              placeholder = getHolder(wrapper);

          while (index--) {
            args[index] = arguments[index];
          }

          var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
          length -= holders.length;

          if (length < arity) {
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined$1, args, holders, undefined$1, undefined$1, arity - length);
          }

          var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
          return apply(fn, this, args);
        }

        return wrapper;
      }

      function createFind(findIndexFunc) {
        return function (collection, predicate, fromIndex) {
          var iterable = Object(collection);

          if (!isArrayLike(collection)) {
            var iteratee = getIteratee(predicate, 3);
            collection = keys(collection);

            predicate = function predicate(key) {
              return iteratee(iterable[key], key, iterable);
            };
          }

          var index = findIndexFunc(collection, predicate, fromIndex);
          return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined$1;
        };
      }

      function createFlow(fromRight) {
        return flatRest(function (funcs) {
          var length = funcs.length,
              index = length,
              prereq = LodashWrapper.prototype.thru;

          if (fromRight) {
            funcs.reverse();
          }

          while (index--) {
            var func = funcs[index];

            if (typeof func != 'function') {
              throw new TypeError(FUNC_ERROR_TEXT);
            }

            if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
              var wrapper = new LodashWrapper([], true);
            }
          }

          index = wrapper ? index : length;

          while (++index < length) {
            func = funcs[index];
            var funcName = getFuncName(func),
                data = funcName == 'wrapper' ? getData(func) : undefined$1;

            if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
              wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
            } else {
              wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
            }
          }

          return function () {
            var args = arguments,
                value = args[0];

            if (wrapper && args.length == 1 && isArray(value)) {
              return wrapper.plant(value).value();
            }

            var index = 0,
                result = length ? funcs[index].apply(this, args) : value;

            while (++index < length) {
              result = funcs[index].call(this, result);
            }

            return result;
          };
        });
      }

      function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & WRAP_ARY_FLAG,
            isBind = bitmask & WRAP_BIND_FLAG,
            isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
            isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
            isFlip = bitmask & WRAP_FLIP_FLAG,
            Ctor = isBindKey ? undefined$1 : createCtor(func);

        function wrapper() {
          var length = arguments.length,
              args = Array(length),
              index = length;

          while (index--) {
            args[index] = arguments[index];
          }

          if (isCurried) {
            var placeholder = getHolder(wrapper),
                holdersCount = countHolders(args, placeholder);
          }

          if (partials) {
            args = composeArgs(args, partials, holders, isCurried);
          }

          if (partialsRight) {
            args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
          }

          length -= holdersCount;

          if (isCurried && length < arity) {
            var newHolders = replaceHolders(args, placeholder);
            return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
          }

          var thisBinding = isBind ? thisArg : this,
              fn = isBindKey ? thisBinding[func] : func;
          length = args.length;

          if (argPos) {
            args = reorder(args, argPos);
          } else if (isFlip && length > 1) {
            args.reverse();
          }

          if (isAry && ary < length) {
            args.length = ary;
          }

          if (this && this !== root && this instanceof wrapper) {
            fn = Ctor || createCtor(fn);
          }

          return fn.apply(thisBinding, args);
        }

        return wrapper;
      }

      function createInverter(setter, toIteratee) {
        return function (object, iteratee) {
          return baseInverter(object, setter, toIteratee(iteratee), {});
        };
      }

      function createMathOperation(operator, defaultValue) {
        return function (value, other) {
          var result;

          if (value === undefined$1 && other === undefined$1) {
            return defaultValue;
          }

          if (value !== undefined$1) {
            result = value;
          }

          if (other !== undefined$1) {
            if (result === undefined$1) {
              return other;
            }

            if (typeof value == 'string' || typeof other == 'string') {
              value = baseToString(value);
              other = baseToString(other);
            } else {
              value = baseToNumber(value);
              other = baseToNumber(other);
            }

            result = operator(value, other);
          }

          return result;
        };
      }

      function createOver(arrayFunc) {
        return flatRest(function (iteratees) {
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          return baseRest(function (args) {
            var thisArg = this;
            return arrayFunc(iteratees, function (iteratee) {
              return apply(iteratee, thisArg, args);
            });
          });
        });
      }

      function createPadding(length, chars) {
        chars = chars === undefined$1 ? ' ' : baseToString(chars);
        var charsLength = chars.length;

        if (charsLength < 2) {
          return charsLength ? baseRepeat(chars, length) : chars;
        }

        var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
        return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
      }

      function createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & WRAP_BIND_FLAG,
            Ctor = createCtor(func);

        function wrapper() {
          var argsIndex = -1,
              argsLength = arguments.length,
              leftIndex = -1,
              leftLength = partials.length,
              args = Array(leftLength + argsLength),
              fn = this && this !== root && this instanceof wrapper ? Ctor : func;

          while (++leftIndex < leftLength) {
            args[leftIndex] = partials[leftIndex];
          }

          while (argsLength--) {
            args[leftIndex++] = arguments[++argsIndex];
          }

          return apply(fn, isBind ? thisArg : this, args);
        }

        return wrapper;
      }

      function createRange(fromRight) {
        return function (start, end, step) {
          if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
            end = step = undefined$1;
          }

          start = toFinite(start);

          if (end === undefined$1) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }

          step = step === undefined$1 ? start < end ? 1 : -1 : toFinite(step);
          return baseRange(start, end, step, fromRight);
        };
      }

      function createRelationalOperation(operator) {
        return function (value, other) {
          if (!(typeof value == 'string' && typeof other == 'string')) {
            value = toNumber(value);
            other = toNumber(other);
          }

          return operator(value, other);
        };
      }

      function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & WRAP_CURRY_FLAG,
            newHolders = isCurry ? holders : undefined$1,
            newHoldersRight = isCurry ? undefined$1 : holders,
            newPartials = isCurry ? partials : undefined$1,
            newPartialsRight = isCurry ? undefined$1 : partials;
        bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

        if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
          bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
        }

        var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
        var result = wrapFunc.apply(undefined$1, newData);

        if (isLaziable(func)) {
          setData(result, newData);
        }

        result.placeholder = placeholder;
        return setWrapToString(result, func, bitmask);
      }

      function createRound(methodName) {
        var func = Math[methodName];
        return function (number, precision) {
          number = toNumber(number);
          precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);

          if (precision && nativeIsFinite(number)) {
            var pair = (toString(number) + 'e').split('e'),
                value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = (toString(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
          }

          return func(number);
        };
      }

      var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
        return new Set(values);
      };

      function createToPairs(keysFunc) {
        return function (object) {
          var tag = getTag(object);

          if (tag == mapTag) {
            return mapToArray(object);
          }

          if (tag == setTag) {
            return setToPairs(object);
          }

          return baseToPairs(object, keysFunc(object));
        };
      }

      function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;

        if (!isBindKey && typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        var length = partials ? partials.length : 0;

        if (!length) {
          bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
          partials = holders = undefined$1;
        }

        ary = ary === undefined$1 ? ary : nativeMax(toInteger(ary), 0);
        arity = arity === undefined$1 ? arity : toInteger(arity);
        length -= holders ? holders.length : 0;

        if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
          var partialsRight = partials,
              holdersRight = holders;
          partials = holders = undefined$1;
        }

        var data = isBindKey ? undefined$1 : getData(func);
        var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];

        if (data) {
          mergeData(newData, data);
        }

        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined$1 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);

        if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
          bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
        }

        if (!bitmask || bitmask == WRAP_BIND_FLAG) {
          var result = createBind(func, bitmask, thisArg);
        } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
          result = createCurry(func, bitmask, arity);
        } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
          result = createPartial(func, bitmask, thisArg, partials);
        } else {
          result = createHybrid.apply(undefined$1, newData);
        }

        var setter = data ? baseSetData : setData;
        return setWrapToString(setter(result, newData), func, bitmask);
      }

      function customDefaultsAssignIn(objValue, srcValue, key, object) {
        if (objValue === undefined$1 || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
          return srcValue;
        }

        return objValue;
      }

      function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
        if (isObject(objValue) && isObject(srcValue)) {
          stack.set(srcValue, objValue);
          baseMerge(objValue, srcValue, undefined$1, customDefaultsMerge, stack);
          stack['delete'](srcValue);
        }

        return objValue;
      }

      function customOmitClone(value) {
        return isPlainObject(value) ? undefined$1 : value;
      }

      function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            arrLength = array.length,
            othLength = other.length;

        if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
          return false;
        }

        var arrStacked = stack.get(array);
        var othStacked = stack.get(other);

        if (arrStacked && othStacked) {
          return arrStacked == other && othStacked == array;
        }

        var index = -1,
            result = true,
            seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined$1;
        stack.set(array, other);
        stack.set(other, array);

        while (++index < arrLength) {
          var arrValue = array[index],
              othValue = other[index];

          if (customizer) {
            var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
          }

          if (compared !== undefined$1) {
            if (compared) {
              continue;
            }

            result = false;
            break;
          }

          if (seen) {
            if (!arraySome(other, function (othValue, othIndex) {
              if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                return seen.push(othIndex);
              }
            })) {
              result = false;
              break;
            }
          } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
            result = false;
            break;
          }
        }

        stack['delete'](array);
        stack['delete'](other);
        return result;
      }

      function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
        switch (tag) {
          case dataViewTag:
            if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
              return false;
            }

            object = object.buffer;
            other = other.buffer;

          case arrayBufferTag:
            if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
              return false;
            }

            return true;

          case boolTag:
          case dateTag:
          case numberTag:
            return eq(+object, +other);

          case errorTag:
            return object.name == other.name && object.message == other.message;

          case regexpTag:
          case stringTag:
            return object == other + '';

          case mapTag:
            var convert = mapToArray;

          case setTag:
            var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
            convert || (convert = setToArray);

            if (object.size != other.size && !isPartial) {
              return false;
            }

            var stacked = stack.get(object);

            if (stacked) {
              return stacked == other;
            }

            bitmask |= COMPARE_UNORDERED_FLAG;
            stack.set(object, other);
            var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
            stack['delete'](object);
            return result;

          case symbolTag:
            if (symbolValueOf) {
              return symbolValueOf.call(object) == symbolValueOf.call(other);
            }

        }

        return false;
      }

      function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
        var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
            objProps = getAllKeys(object),
            objLength = objProps.length,
            othProps = getAllKeys(other),
            othLength = othProps.length;

        if (objLength != othLength && !isPartial) {
          return false;
        }

        var index = objLength;

        while (index--) {
          var key = objProps[index];

          if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
            return false;
          }
        }

        var objStacked = stack.get(object);
        var othStacked = stack.get(other);

        if (objStacked && othStacked) {
          return objStacked == other && othStacked == object;
        }

        var result = true;
        stack.set(object, other);
        stack.set(other, object);
        var skipCtor = isPartial;

        while (++index < objLength) {
          key = objProps[index];
          var objValue = object[key],
              othValue = other[key];

          if (customizer) {
            var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
          }

          if (!(compared === undefined$1 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
            result = false;
            break;
          }

          skipCtor || (skipCtor = key == 'constructor');
        }

        if (result && !skipCtor) {
          var objCtor = object.constructor,
              othCtor = other.constructor;

          if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
            result = false;
          }
        }

        stack['delete'](object);
        stack['delete'](other);
        return result;
      }

      function flatRest(func) {
        return setToString(overRest(func, undefined$1, flatten), func + '');
      }

      function getAllKeys(object) {
        return baseGetAllKeys(object, keys, getSymbols);
      }

      function getAllKeysIn(object) {
        return baseGetAllKeys(object, keysIn, getSymbolsIn);
      }

      var getData = !metaMap ? noop : function (func) {
        return metaMap.get(func);
      };

      function getFuncName(func) {
        var result = func.name + '',
            array = realNames[result],
            length = hasOwnProperty.call(realNames, result) ? array.length : 0;

        while (length--) {
          var data = array[length],
              otherFunc = data.func;

          if (otherFunc == null || otherFunc == func) {
            return data.name;
          }
        }

        return result;
      }

      function getHolder(func) {
        var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
        return object.placeholder;
      }

      function getIteratee() {
        var result = lodash.iteratee || iteratee;
        result = result === iteratee ? baseIteratee : result;
        return arguments.length ? result(arguments[0], arguments[1]) : result;
      }

      function getMapData(map, key) {
        var data = map.__data__;
        return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
      }

      function getMatchData(object) {
        var result = keys(object),
            length = result.length;

        while (length--) {
          var key = result[length],
              value = object[key];
          result[length] = [key, value, isStrictComparable(value)];
        }

        return result;
      }

      function getNative(object, key) {
        var value = getValue(object, key);
        return baseIsNative(value) ? value : undefined$1;
      }

      function getRawTag(value) {
        var isOwn = hasOwnProperty.call(value, symToStringTag),
            tag = value[symToStringTag];

        try {
          value[symToStringTag] = undefined$1;
          var unmasked = true;
        } catch (e) {}

        var result = nativeObjectToString.call(value);

        if (unmasked) {
          if (isOwn) {
            value[symToStringTag] = tag;
          } else {
            delete value[symToStringTag];
          }
        }

        return result;
      }

      var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
        if (object == null) {
          return [];
        }

        object = Object(object);
        return arrayFilter(nativeGetSymbols(object), function (symbol) {
          return propertyIsEnumerable.call(object, symbol);
        });
      };
      var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
        var result = [];

        while (object) {
          arrayPush(result, getSymbols(object));
          object = getPrototype(object);
        }

        return result;
      };
      var getTag = baseGetTag;

      if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
        getTag = function getTag(value) {
          var result = baseGetTag(value),
              Ctor = result == objectTag ? value.constructor : undefined$1,
              ctorString = Ctor ? toSource(Ctor) : '';

          if (ctorString) {
            switch (ctorString) {
              case dataViewCtorString:
                return dataViewTag;

              case mapCtorString:
                return mapTag;

              case promiseCtorString:
                return promiseTag;

              case setCtorString:
                return setTag;

              case weakMapCtorString:
                return weakMapTag;
            }
          }

          return result;
        };
      }

      function getView(start, end, transforms) {
        var index = -1,
            length = transforms.length;

        while (++index < length) {
          var data = transforms[index],
              size = data.size;

          switch (data.type) {
            case 'drop':
              start += size;
              break;

            case 'dropRight':
              end -= size;
              break;

            case 'take':
              end = nativeMin(end, start + size);
              break;

            case 'takeRight':
              start = nativeMax(start, end - size);
              break;
          }
        }

        return {
          'start': start,
          'end': end
        };
      }

      function getWrapDetails(source) {
        var match = source.match(reWrapDetails);
        return match ? match[1].split(reSplitDetails) : [];
      }

      function hasPath(object, path, hasFunc) {
        path = castPath(path, object);
        var index = -1,
            length = path.length,
            result = false;

        while (++index < length) {
          var key = toKey(path[index]);

          if (!(result = object != null && hasFunc(object, key))) {
            break;
          }

          object = object[key];
        }

        if (result || ++index != length) {
          return result;
        }

        length = object == null ? 0 : object.length;
        return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
      }

      function initCloneArray(array) {
        var length = array.length,
            result = new array.constructor(length);

        if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
          result.index = array.index;
          result.input = array.input;
        }

        return result;
      }

      function initCloneObject(object) {
        return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
      }

      function initCloneByTag(object, tag, isDeep) {
        var Ctor = object.constructor;

        switch (tag) {
          case arrayBufferTag:
            return cloneArrayBuffer(object);

          case boolTag:
          case dateTag:
            return new Ctor(+object);

          case dataViewTag:
            return cloneDataView(object, isDeep);

          case float32Tag:
          case float64Tag:
          case int8Tag:
          case int16Tag:
          case int32Tag:
          case uint8Tag:
          case uint8ClampedTag:
          case uint16Tag:
          case uint32Tag:
            return cloneTypedArray(object, isDeep);

          case mapTag:
            return new Ctor();

          case numberTag:
          case stringTag:
            return new Ctor(object);

          case regexpTag:
            return cloneRegExp(object);

          case setTag:
            return new Ctor();

          case symbolTag:
            return cloneSymbol(object);
        }
      }

      function insertWrapDetails(source, details) {
        var length = details.length;

        if (!length) {
          return source;
        }

        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
      }

      function isFlattenable(value) {
        return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
      }

      function isIndex(value, length) {
        var type = typeof value;
        length = length == null ? MAX_SAFE_INTEGER : length;
        return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
      }

      function isIterateeCall(value, index, object) {
        if (!isObject(object)) {
          return false;
        }

        var type = typeof index;

        if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
          return eq(object[index], value);
        }

        return false;
      }

      function isKey(value, object) {
        if (isArray(value)) {
          return false;
        }

        var type = typeof value;

        if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
          return true;
        }

        return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
      }

      function isKeyable(value) {
        var type = typeof value;
        return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
      }

      function isLaziable(func) {
        var funcName = getFuncName(func),
            other = lodash[funcName];

        if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
          return false;
        }

        if (func === other) {
          return true;
        }

        var data = getData(other);
        return !!data && func === data[0];
      }

      function isMasked(func) {
        return !!maskSrcKey && maskSrcKey in func;
      }

      var isMaskable = coreJsData ? isFunction : stubFalse;

      function isPrototype(value) {
        var Ctor = value && value.constructor,
            proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
        return value === proto;
      }

      function isStrictComparable(value) {
        return value === value && !isObject(value);
      }

      function matchesStrictComparable(key, srcValue) {
        return function (object) {
          if (object == null) {
            return false;
          }

          return object[key] === srcValue && (srcValue !== undefined$1 || key in Object(object));
        };
      }

      function memoizeCapped(func) {
        var result = memoize(func, function (key) {
          if (cache.size === MAX_MEMOIZE_SIZE) {
            cache.clear();
          }

          return key;
        });
        var cache = result.cache;
        return result;
      }

      function mergeData(data, source) {
        var bitmask = data[1],
            srcBitmask = source[1],
            newBitmask = bitmask | srcBitmask,
            isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
        var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

        if (!(isCommon || isCombo)) {
          return data;
        }

        if (srcBitmask & WRAP_BIND_FLAG) {
          data[2] = source[2];
          newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
        }

        var value = source[3];

        if (value) {
          var partials = data[3];
          data[3] = partials ? composeArgs(partials, value, source[4]) : value;
          data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
        }

        value = source[5];

        if (value) {
          partials = data[5];
          data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
          data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
        }

        value = source[7];

        if (value) {
          data[7] = value;
        }

        if (srcBitmask & WRAP_ARY_FLAG) {
          data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
        }

        if (data[9] == null) {
          data[9] = source[9];
        }

        data[0] = source[0];
        data[1] = newBitmask;
        return data;
      }

      function nativeKeysIn(object) {
        var result = [];

        if (object != null) {
          for (var key in Object(object)) {
            result.push(key);
          }
        }

        return result;
      }

      function objectToString(value) {
        return nativeObjectToString.call(value);
      }

      function overRest(func, start, transform) {
        start = nativeMax(start === undefined$1 ? func.length - 1 : start, 0);
        return function () {
          var args = arguments,
              index = -1,
              length = nativeMax(args.length - start, 0),
              array = Array(length);

          while (++index < length) {
            array[index] = args[start + index];
          }

          index = -1;
          var otherArgs = Array(start + 1);

          while (++index < start) {
            otherArgs[index] = args[index];
          }

          otherArgs[start] = transform(array);
          return apply(func, this, otherArgs);
        };
      }

      function parent(object, path) {
        return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
      }

      function reorder(array, indexes) {
        var arrLength = array.length,
            length = nativeMin(indexes.length, arrLength),
            oldArray = copyArray(array);

        while (length--) {
          var index = indexes[length];
          array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined$1;
        }

        return array;
      }

      function safeGet(object, key) {
        if (key === 'constructor' && typeof object[key] === 'function') {
          return;
        }

        if (key == '__proto__') {
          return;
        }

        return object[key];
      }

      var setData = shortOut(baseSetData);

      var setTimeout = ctxSetTimeout || function (func, wait) {
        return root.setTimeout(func, wait);
      };

      var setToString = shortOut(baseSetToString);

      function setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
      }

      function shortOut(func) {
        var count = 0,
            lastCalled = 0;
        return function () {
          var stamp = nativeNow(),
              remaining = HOT_SPAN - (stamp - lastCalled);
          lastCalled = stamp;

          if (remaining > 0) {
            if (++count >= HOT_COUNT) {
              return arguments[0];
            }
          } else {
            count = 0;
          }

          return func.apply(undefined$1, arguments);
        };
      }

      function shuffleSelf(array, size) {
        var index = -1,
            length = array.length,
            lastIndex = length - 1;
        size = size === undefined$1 ? length : size;

        while (++index < size) {
          var rand = baseRandom(index, lastIndex),
              value = array[rand];
          array[rand] = array[index];
          array[index] = value;
        }

        array.length = size;
        return array;
      }

      var stringToPath = memoizeCapped(function (string) {
        var result = [];

        if (string.charCodeAt(0) === 46) {
          result.push('');
        }

        string.replace(rePropName, function (match, number, quote, subString) {
          result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
        });
        return result;
      });

      function toKey(value) {
        if (typeof value == 'string' || isSymbol(value)) {
          return value;
        }

        var result = value + '';
        return result == '0' && 1 / value == -INFINITY ? '-0' : result;
      }

      function toSource(func) {
        if (func != null) {
          try {
            return funcToString.call(func);
          } catch (e) {}

          try {
            return func + '';
          } catch (e) {}
        }

        return '';
      }

      function updateWrapDetails(details, bitmask) {
        arrayEach(wrapFlags, function (pair) {
          var value = '_.' + pair[0];

          if (bitmask & pair[1] && !arrayIncludes(details, value)) {
            details.push(value);
          }
        });
        return details.sort();
      }

      function wrapperClone(wrapper) {
        if (wrapper instanceof LazyWrapper) {
          return wrapper.clone();
        }

        var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
        result.__actions__ = copyArray(wrapper.__actions__);
        result.__index__ = wrapper.__index__;
        result.__values__ = wrapper.__values__;
        return result;
      }

      function chunk(array, size, guard) {
        if (guard ? isIterateeCall(array, size, guard) : size === undefined$1) {
          size = 1;
        } else {
          size = nativeMax(toInteger(size), 0);
        }

        var length = array == null ? 0 : array.length;

        if (!length || size < 1) {
          return [];
        }

        var index = 0,
            resIndex = 0,
            result = Array(nativeCeil(length / size));

        while (index < length) {
          result[resIndex++] = baseSlice(array, index, index += size);
        }

        return result;
      }

      function compact(array) {
        var index = -1,
            length = array == null ? 0 : array.length,
            resIndex = 0,
            result = [];

        while (++index < length) {
          var value = array[index];

          if (value) {
            result[resIndex++] = value;
          }
        }

        return result;
      }

      function concat() {
        var length = arguments.length;

        if (!length) {
          return [];
        }

        var args = Array(length - 1),
            array = arguments[0],
            index = length;

        while (index--) {
          args[index - 1] = arguments[index];
        }

        return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
      }

      var difference = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
      });
      var differenceBy = baseRest(function (array, values) {
        var iteratee = last(values);

        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }

        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
      });
      var differenceWith = baseRest(function (array, values) {
        var comparator = last(values);

        if (isArrayLikeObject(comparator)) {
          comparator = undefined$1;
        }

        return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined$1, comparator) : [];
      });

      function drop(array, n, guard) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      function dropRight(array, n, guard) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      function dropRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
      }

      function dropWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
      }

      function fill(array, value, start, end) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
          start = 0;
          end = length;
        }

        return baseFill(array, value, start, end);
      }

      function findIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return -1;
        }

        var index = fromIndex == null ? 0 : toInteger(fromIndex);

        if (index < 0) {
          index = nativeMax(length + index, 0);
        }

        return baseFindIndex(array, getIteratee(predicate, 3), index);
      }

      function findLastIndex(array, predicate, fromIndex) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return -1;
        }

        var index = length - 1;

        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }

        return baseFindIndex(array, getIteratee(predicate, 3), index, true);
      }

      function flatten(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, 1) : [];
      }

      function flattenDeep(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseFlatten(array, INFINITY) : [];
      }

      function flattenDepth(array, depth) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(array, depth);
      }

      function fromPairs(pairs) {
        var index = -1,
            length = pairs == null ? 0 : pairs.length,
            result = {};

        while (++index < length) {
          var pair = pairs[index];
          result[pair[0]] = pair[1];
        }

        return result;
      }

      function head(array) {
        return array && array.length ? array[0] : undefined$1;
      }

      function indexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return -1;
        }

        var index = fromIndex == null ? 0 : toInteger(fromIndex);

        if (index < 0) {
          index = nativeMax(length + index, 0);
        }

        return baseIndexOf(array, value, index);
      }

      function initial(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 0, -1) : [];
      }

      var intersection = baseRest(function (arrays) {
        var mapped = arrayMap(arrays, castArrayLikeObject);
        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
      });
      var intersectionBy = baseRest(function (arrays) {
        var iteratee = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);

        if (iteratee === last(mapped)) {
          iteratee = undefined$1;
        } else {
          mapped.pop();
        }

        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
      });
      var intersectionWith = baseRest(function (arrays) {
        var comparator = last(arrays),
            mapped = arrayMap(arrays, castArrayLikeObject);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;

        if (comparator) {
          mapped.pop();
        }

        return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined$1, comparator) : [];
      });

      function join(array, separator) {
        return array == null ? '' : nativeJoin.call(array, separator);
      }

      function last(array) {
        var length = array == null ? 0 : array.length;
        return length ? array[length - 1] : undefined$1;
      }

      function lastIndexOf(array, value, fromIndex) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return -1;
        }

        var index = length;

        if (fromIndex !== undefined$1) {
          index = toInteger(fromIndex);
          index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
        }

        return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
      }

      function nth(array, n) {
        return array && array.length ? baseNth(array, toInteger(n)) : undefined$1;
      }

      var pull = baseRest(pullAll);

      function pullAll(array, values) {
        return array && array.length && values && values.length ? basePullAll(array, values) : array;
      }

      function pullAllBy(array, values, iteratee) {
        return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
      }

      function pullAllWith(array, values, comparator) {
        return array && array.length && values && values.length ? basePullAll(array, values, undefined$1, comparator) : array;
      }

      var pullAt = flatRest(function (array, indexes) {
        var length = array == null ? 0 : array.length,
            result = baseAt(array, indexes);
        basePullAt(array, arrayMap(indexes, function (index) {
          return isIndex(index, length) ? +index : index;
        }).sort(compareAscending));
        return result;
      });

      function remove(array, predicate) {
        var result = [];

        if (!(array && array.length)) {
          return result;
        }

        var index = -1,
            indexes = [],
            length = array.length;
        predicate = getIteratee(predicate, 3);

        while (++index < length) {
          var value = array[index];

          if (predicate(value, index, array)) {
            result.push(value);
            indexes.push(index);
          }
        }

        basePullAt(array, indexes);
        return result;
      }

      function reverse(array) {
        return array == null ? array : nativeReverse.call(array);
      }

      function slice(array, start, end) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
          start = 0;
          end = length;
        } else {
          start = start == null ? 0 : toInteger(start);
          end = end === undefined$1 ? length : toInteger(end);
        }

        return baseSlice(array, start, end);
      }

      function sortedIndex(array, value) {
        return baseSortedIndex(array, value);
      }

      function sortedIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
      }

      function sortedIndexOf(array, value) {
        var length = array == null ? 0 : array.length;

        if (length) {
          var index = baseSortedIndex(array, value);

          if (index < length && eq(array[index], value)) {
            return index;
          }
        }

        return -1;
      }

      function sortedLastIndex(array, value) {
        return baseSortedIndex(array, value, true);
      }

      function sortedLastIndexBy(array, value, iteratee) {
        return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
      }

      function sortedLastIndexOf(array, value) {
        var length = array == null ? 0 : array.length;

        if (length) {
          var index = baseSortedIndex(array, value, true) - 1;

          if (eq(array[index], value)) {
            return index;
          }
        }

        return -1;
      }

      function sortedUniq(array) {
        return array && array.length ? baseSortedUniq(array) : [];
      }

      function sortedUniqBy(array, iteratee) {
        return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
      }

      function tail(array) {
        var length = array == null ? 0 : array.length;
        return length ? baseSlice(array, 1, length) : [];
      }

      function take(array, n, guard) {
        if (!(array && array.length)) {
          return [];
        }

        n = guard || n === undefined$1 ? 1 : toInteger(n);
        return baseSlice(array, 0, n < 0 ? 0 : n);
      }

      function takeRight(array, n, guard) {
        var length = array == null ? 0 : array.length;

        if (!length) {
          return [];
        }

        n = guard || n === undefined$1 ? 1 : toInteger(n);
        n = length - n;
        return baseSlice(array, n < 0 ? 0 : n, length);
      }

      function takeRightWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
      }

      function takeWhile(array, predicate) {
        return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
      }

      var union = baseRest(function (arrays) {
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
      });
      var unionBy = baseRest(function (arrays) {
        var iteratee = last(arrays);

        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }

        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
      });
      var unionWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined$1, comparator);
      });

      function uniq(array) {
        return array && array.length ? baseUniq(array) : [];
      }

      function uniqBy(array, iteratee) {
        return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
      }

      function uniqWith(array, comparator) {
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return array && array.length ? baseUniq(array, undefined$1, comparator) : [];
      }

      function unzip(array) {
        if (!(array && array.length)) {
          return [];
        }

        var length = 0;
        array = arrayFilter(array, function (group) {
          if (isArrayLikeObject(group)) {
            length = nativeMax(group.length, length);
            return true;
          }
        });
        return baseTimes(length, function (index) {
          return arrayMap(array, baseProperty(index));
        });
      }

      function unzipWith(array, iteratee) {
        if (!(array && array.length)) {
          return [];
        }

        var result = unzip(array);

        if (iteratee == null) {
          return result;
        }

        return arrayMap(result, function (group) {
          return apply(iteratee, undefined$1, group);
        });
      }

      var without = baseRest(function (array, values) {
        return isArrayLikeObject(array) ? baseDifference(array, values) : [];
      });
      var xor = baseRest(function (arrays) {
        return baseXor(arrayFilter(arrays, isArrayLikeObject));
      });
      var xorBy = baseRest(function (arrays) {
        var iteratee = last(arrays);

        if (isArrayLikeObject(iteratee)) {
          iteratee = undefined$1;
        }

        return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
      });
      var xorWith = baseRest(function (arrays) {
        var comparator = last(arrays);
        comparator = typeof comparator == 'function' ? comparator : undefined$1;
        return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined$1, comparator);
      });
      var zip = baseRest(unzip);

      function zipObject(props, values) {
        return baseZipObject(props || [], values || [], assignValue);
      }

      function zipObjectDeep(props, values) {
        return baseZipObject(props || [], values || [], baseSet);
      }

      var zipWith = baseRest(function (arrays) {
        var length = arrays.length,
            iteratee = length > 1 ? arrays[length - 1] : undefined$1;
        iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined$1;
        return unzipWith(arrays, iteratee);
      });

      function chain(value) {
        var result = lodash(value);
        result.__chain__ = true;
        return result;
      }

      function tap(value, interceptor) {
        interceptor(value);
        return value;
      }

      function thru(value, interceptor) {
        return interceptor(value);
      }

      var wrapperAt = flatRest(function (paths) {
        var length = paths.length,
            start = length ? paths[0] : 0,
            value = this.__wrapped__,
            interceptor = function interceptor(object) {
          return baseAt(object, paths);
        };

        if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
          return this.thru(interceptor);
        }

        value = value.slice(start, +start + (length ? 1 : 0));

        value.__actions__.push({
          'func': thru,
          'args': [interceptor],
          'thisArg': undefined$1
        });

        return new LodashWrapper(value, this.__chain__).thru(function (array) {
          if (length && !array.length) {
            array.push(undefined$1);
          }

          return array;
        });
      });

      function wrapperChain() {
        return chain(this);
      }

      function wrapperCommit() {
        return new LodashWrapper(this.value(), this.__chain__);
      }

      function wrapperNext() {
        if (this.__values__ === undefined$1) {
          this.__values__ = toArray(this.value());
        }

        var done = this.__index__ >= this.__values__.length,
            value = done ? undefined$1 : this.__values__[this.__index__++];
        return {
          'done': done,
          'value': value
        };
      }

      function wrapperToIterator() {
        return this;
      }

      function wrapperPlant(value) {
        var result,
            parent = this;

        while (parent instanceof baseLodash) {
          var clone = wrapperClone(parent);
          clone.__index__ = 0;
          clone.__values__ = undefined$1;

          if (result) {
            previous.__wrapped__ = clone;
          } else {
            result = clone;
          }

          var previous = clone;
          parent = parent.__wrapped__;
        }

        previous.__wrapped__ = value;
        return result;
      }

      function wrapperReverse() {
        var value = this.__wrapped__;

        if (value instanceof LazyWrapper) {
          var wrapped = value;

          if (this.__actions__.length) {
            wrapped = new LazyWrapper(this);
          }

          wrapped = wrapped.reverse();

          wrapped.__actions__.push({
            'func': thru,
            'args': [reverse],
            'thisArg': undefined$1
          });

          return new LodashWrapper(wrapped, this.__chain__);
        }

        return this.thru(reverse);
      }

      function wrapperValue() {
        return baseWrapperValue(this.__wrapped__, this.__actions__);
      }

      var countBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          ++result[key];
        } else {
          baseAssignValue(result, key, 1);
        }
      });

      function every(collection, predicate, guard) {
        var func = isArray(collection) ? arrayEvery : baseEvery;

        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }

        return func(collection, getIteratee(predicate, 3));
      }

      function filter(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, getIteratee(predicate, 3));
      }

      var find = createFind(findIndex);
      var findLast = createFind(findLastIndex);

      function flatMap(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), 1);
      }

      function flatMapDeep(collection, iteratee) {
        return baseFlatten(map(collection, iteratee), INFINITY);
      }

      function flatMapDepth(collection, iteratee, depth) {
        depth = depth === undefined$1 ? 1 : toInteger(depth);
        return baseFlatten(map(collection, iteratee), depth);
      }

      function forEach(collection, iteratee) {
        var func = isArray(collection) ? arrayEach : baseEach;
        return func(collection, getIteratee(iteratee, 3));
      }

      function forEachRight(collection, iteratee) {
        var func = isArray(collection) ? arrayEachRight : baseEachRight;
        return func(collection, getIteratee(iteratee, 3));
      }

      var groupBy = createAggregator(function (result, value, key) {
        if (hasOwnProperty.call(result, key)) {
          result[key].push(value);
        } else {
          baseAssignValue(result, key, [value]);
        }
      });

      function includes(collection, value, fromIndex, guard) {
        collection = isArrayLike(collection) ? collection : values(collection);
        fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
        var length = collection.length;

        if (fromIndex < 0) {
          fromIndex = nativeMax(length + fromIndex, 0);
        }

        return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
      }

      var invokeMap = baseRest(function (collection, path, args) {
        var index = -1,
            isFunc = typeof path == 'function',
            result = isArrayLike(collection) ? Array(collection.length) : [];
        baseEach(collection, function (value) {
          result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
        });
        return result;
      });
      var keyBy = createAggregator(function (result, value, key) {
        baseAssignValue(result, key, value);
      });

      function map(collection, iteratee) {
        var func = isArray(collection) ? arrayMap : baseMap;
        return func(collection, getIteratee(iteratee, 3));
      }

      function orderBy(collection, iteratees, orders, guard) {
        if (collection == null) {
          return [];
        }

        if (!isArray(iteratees)) {
          iteratees = iteratees == null ? [] : [iteratees];
        }

        orders = guard ? undefined$1 : orders;

        if (!isArray(orders)) {
          orders = orders == null ? [] : [orders];
        }

        return baseOrderBy(collection, iteratees, orders);
      }

      var partition = createAggregator(function (result, value, key) {
        result[key ? 0 : 1].push(value);
      }, function () {
        return [[], []];
      });

      function reduce(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduce : baseReduce,
            initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
      }

      function reduceRight(collection, iteratee, accumulator) {
        var func = isArray(collection) ? arrayReduceRight : baseReduce,
            initAccum = arguments.length < 3;
        return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
      }

      function reject(collection, predicate) {
        var func = isArray(collection) ? arrayFilter : baseFilter;
        return func(collection, negate(getIteratee(predicate, 3)));
      }

      function sample(collection) {
        var func = isArray(collection) ? arraySample : baseSample;
        return func(collection);
      }

      function sampleSize(collection, n, guard) {
        if (guard ? isIterateeCall(collection, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }

        var func = isArray(collection) ? arraySampleSize : baseSampleSize;
        return func(collection, n);
      }

      function shuffle(collection) {
        var func = isArray(collection) ? arrayShuffle : baseShuffle;
        return func(collection);
      }

      function size(collection) {
        if (collection == null) {
          return 0;
        }

        if (isArrayLike(collection)) {
          return isString(collection) ? stringSize(collection) : collection.length;
        }

        var tag = getTag(collection);

        if (tag == mapTag || tag == setTag) {
          return collection.size;
        }

        return baseKeys(collection).length;
      }

      function some(collection, predicate, guard) {
        var func = isArray(collection) ? arraySome : baseSome;

        if (guard && isIterateeCall(collection, predicate, guard)) {
          predicate = undefined$1;
        }

        return func(collection, getIteratee(predicate, 3));
      }

      var sortBy = baseRest(function (collection, iteratees) {
        if (collection == null) {
          return [];
        }

        var length = iteratees.length;

        if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
          iteratees = [];
        } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
          iteratees = [iteratees[0]];
        }

        return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
      });

      var now = ctxNow || function () {
        return root.Date.now();
      };

      function after(n, func) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        n = toInteger(n);
        return function () {
          if (--n < 1) {
            return func.apply(this, arguments);
          }
        };
      }

      function ary(func, n, guard) {
        n = guard ? undefined$1 : n;
        n = func && n == null ? func.length : n;
        return createWrap(func, WRAP_ARY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, n);
      }

      function before(n, func) {
        var result;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        n = toInteger(n);
        return function () {
          if (--n > 0) {
            result = func.apply(this, arguments);
          }

          if (n <= 1) {
            func = undefined$1;
          }

          return result;
        };
      }

      var bind = baseRest(function (func, thisArg, partials) {
        var bitmask = WRAP_BIND_FLAG;

        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bind));
          bitmask |= WRAP_PARTIAL_FLAG;
        }

        return createWrap(func, bitmask, thisArg, partials, holders);
      });
      var bindKey = baseRest(function (object, key, partials) {
        var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;

        if (partials.length) {
          var holders = replaceHolders(partials, getHolder(bindKey));
          bitmask |= WRAP_PARTIAL_FLAG;
        }

        return createWrap(key, bitmask, object, partials, holders);
      });

      function curry(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curry.placeholder;
        return result;
      }

      function curryRight(func, arity, guard) {
        arity = guard ? undefined$1 : arity;
        var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined$1, undefined$1, undefined$1, undefined$1, undefined$1, arity);
        result.placeholder = curryRight.placeholder;
        return result;
      }

      function debounce(func, wait, options) {
        var lastArgs,
            lastThis,
            maxWait,
            result,
            timerId,
            lastCallTime,
            lastInvokeTime = 0,
            leading = false,
            maxing = false,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        wait = toNumber(wait) || 0;

        if (isObject(options)) {
          leading = !!options.leading;
          maxing = 'maxWait' in options;
          maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        function invokeFunc(time) {
          var args = lastArgs,
              thisArg = lastThis;
          lastArgs = lastThis = undefined$1;
          lastInvokeTime = time;
          result = func.apply(thisArg, args);
          return result;
        }

        function leadingEdge(time) {
          lastInvokeTime = time;
          timerId = setTimeout(timerExpired, wait);
          return leading ? invokeFunc(time) : result;
        }

        function remainingWait(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime,
              timeWaiting = wait - timeSinceLastCall;
          return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
        }

        function shouldInvoke(time) {
          var timeSinceLastCall = time - lastCallTime,
              timeSinceLastInvoke = time - lastInvokeTime;
          return lastCallTime === undefined$1 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
        }

        function timerExpired() {
          var time = now();

          if (shouldInvoke(time)) {
            return trailingEdge(time);
          }

          timerId = setTimeout(timerExpired, remainingWait(time));
        }

        function trailingEdge(time) {
          timerId = undefined$1;

          if (trailing && lastArgs) {
            return invokeFunc(time);
          }

          lastArgs = lastThis = undefined$1;
          return result;
        }

        function cancel() {
          if (timerId !== undefined$1) {
            clearTimeout(timerId);
          }

          lastInvokeTime = 0;
          lastArgs = lastCallTime = lastThis = timerId = undefined$1;
        }

        function flush() {
          return timerId === undefined$1 ? result : trailingEdge(now());
        }

        function debounced() {
          var time = now(),
              isInvoking = shouldInvoke(time);
          lastArgs = arguments;
          lastThis = this;
          lastCallTime = time;

          if (isInvoking) {
            if (timerId === undefined$1) {
              return leadingEdge(lastCallTime);
            }

            if (maxing) {
              clearTimeout(timerId);
              timerId = setTimeout(timerExpired, wait);
              return invokeFunc(lastCallTime);
            }
          }

          if (timerId === undefined$1) {
            timerId = setTimeout(timerExpired, wait);
          }

          return result;
        }

        debounced.cancel = cancel;
        debounced.flush = flush;
        return debounced;
      }

      var defer = baseRest(function (func, args) {
        return baseDelay(func, 1, args);
      });
      var delay = baseRest(function (func, wait, args) {
        return baseDelay(func, toNumber(wait) || 0, args);
      });

      function flip(func) {
        return createWrap(func, WRAP_FLIP_FLAG);
      }

      function memoize(func, resolver) {
        if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        var memoized = function memoized() {
          var args = arguments,
              key = resolver ? resolver.apply(this, args) : args[0],
              cache = memoized.cache;

          if (cache.has(key)) {
            return cache.get(key);
          }

          var result = func.apply(this, args);
          memoized.cache = cache.set(key, result) || cache;
          return result;
        };

        memoized.cache = new (memoize.Cache || MapCache)();
        return memoized;
      }

      memoize.Cache = MapCache;

      function negate(predicate) {
        if (typeof predicate != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        return function () {
          var args = arguments;

          switch (args.length) {
            case 0:
              return !predicate.call(this);

            case 1:
              return !predicate.call(this, args[0]);

            case 2:
              return !predicate.call(this, args[0], args[1]);

            case 3:
              return !predicate.call(this, args[0], args[1], args[2]);
          }

          return !predicate.apply(this, args);
        };
      }

      function once(func) {
        return before(2, func);
      }

      var overArgs = castRest(function (func, transforms) {
        transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
        var funcsLength = transforms.length;
        return baseRest(function (args) {
          var index = -1,
              length = nativeMin(args.length, funcsLength);

          while (++index < length) {
            args[index] = transforms[index].call(this, args[index]);
          }

          return apply(func, this, args);
        });
      });
      var partial = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partial));
        return createWrap(func, WRAP_PARTIAL_FLAG, undefined$1, partials, holders);
      });
      var partialRight = baseRest(function (func, partials) {
        var holders = replaceHolders(partials, getHolder(partialRight));
        return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined$1, partials, holders);
      });
      var rearg = flatRest(function (func, indexes) {
        return createWrap(func, WRAP_REARG_FLAG, undefined$1, undefined$1, undefined$1, indexes);
      });

      function rest(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        start = start === undefined$1 ? start : toInteger(start);
        return baseRest(func, start);
      }

      function spread(func, start) {
        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        start = start == null ? 0 : nativeMax(toInteger(start), 0);
        return baseRest(function (args) {
          var array = args[start],
              otherArgs = castSlice(args, 0, start);

          if (array) {
            arrayPush(otherArgs, array);
          }

          return apply(func, this, otherArgs);
        });
      }

      function throttle(func, wait, options) {
        var leading = true,
            trailing = true;

        if (typeof func != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }

        if (isObject(options)) {
          leading = 'leading' in options ? !!options.leading : leading;
          trailing = 'trailing' in options ? !!options.trailing : trailing;
        }

        return debounce(func, wait, {
          'leading': leading,
          'maxWait': wait,
          'trailing': trailing
        });
      }

      function unary(func) {
        return ary(func, 1);
      }

      function wrap(value, wrapper) {
        return partial(castFunction(wrapper), value);
      }

      function castArray() {
        if (!arguments.length) {
          return [];
        }

        var value = arguments[0];
        return isArray(value) ? value : [value];
      }

      function clone(value) {
        return baseClone(value, CLONE_SYMBOLS_FLAG);
      }

      function cloneWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
      }

      function cloneDeep(value) {
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
      }

      function cloneDeepWith(value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
      }

      function conformsTo(object, source) {
        return source == null || baseConformsTo(object, source, keys(source));
      }

      function eq(value, other) {
        return value === other || value !== value && other !== other;
      }

      var gt = createRelationalOperation(baseGt);
      var gte = createRelationalOperation(function (value, other) {
        return value >= other;
      });
      var isArguments = baseIsArguments(function () {
        return arguments;
      }()) ? baseIsArguments : function (value) {
        return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
      };
      var isArray = Array.isArray;
      var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

      function isArrayLike(value) {
        return value != null && isLength(value.length) && !isFunction(value);
      }

      function isArrayLikeObject(value) {
        return isObjectLike(value) && isArrayLike(value);
      }

      function isBoolean(value) {
        return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
      }

      var isBuffer = nativeIsBuffer || stubFalse;
      var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

      function isElement(value) {
        return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
      }

      function isEmpty(value) {
        if (value == null) {
          return true;
        }

        if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
          return !value.length;
        }

        var tag = getTag(value);

        if (tag == mapTag || tag == setTag) {
          return !value.size;
        }

        if (isPrototype(value)) {
          return !baseKeys(value).length;
        }

        for (var key in value) {
          if (hasOwnProperty.call(value, key)) {
            return false;
          }
        }

        return true;
      }

      function isEqual(value, other) {
        return baseIsEqual(value, other);
      }

      function isEqualWith(value, other, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        var result = customizer ? customizer(value, other) : undefined$1;
        return result === undefined$1 ? baseIsEqual(value, other, undefined$1, customizer) : !!result;
      }

      function isError(value) {
        if (!isObjectLike(value)) {
          return false;
        }

        var tag = baseGetTag(value);
        return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
      }

      function isFinite(value) {
        return typeof value == 'number' && nativeIsFinite(value);
      }

      function isFunction(value) {
        if (!isObject(value)) {
          return false;
        }

        var tag = baseGetTag(value);
        return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
      }

      function isInteger(value) {
        return typeof value == 'number' && value == toInteger(value);
      }

      function isLength(value) {
        return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
      }

      function isObject(value) {
        var type = typeof value;
        return value != null && (type == 'object' || type == 'function');
      }

      function isObjectLike(value) {
        return value != null && typeof value == 'object';
      }

      var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

      function isMatch(object, source) {
        return object === source || baseIsMatch(object, source, getMatchData(source));
      }

      function isMatchWith(object, source, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return baseIsMatch(object, source, getMatchData(source), customizer);
      }

      function isNaN(value) {
        return isNumber(value) && value != +value;
      }

      function isNative(value) {
        if (isMaskable(value)) {
          throw new Error(CORE_ERROR_TEXT);
        }

        return baseIsNative(value);
      }

      function isNull(value) {
        return value === null;
      }

      function isNil(value) {
        return value == null;
      }

      function isNumber(value) {
        return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
      }

      function isPlainObject(value) {
        if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
          return false;
        }

        var proto = getPrototype(value);

        if (proto === null) {
          return true;
        }

        var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
        return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
      }

      var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

      function isSafeInteger(value) {
        return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
      }

      var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

      function isString(value) {
        return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
      }

      function isSymbol(value) {
        return typeof value == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
      }

      var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

      function isUndefined(value) {
        return value === undefined$1;
      }

      function isWeakMap(value) {
        return isObjectLike(value) && getTag(value) == weakMapTag;
      }

      function isWeakSet(value) {
        return isObjectLike(value) && baseGetTag(value) == weakSetTag;
      }

      var lt = createRelationalOperation(baseLt);
      var lte = createRelationalOperation(function (value, other) {
        return value <= other;
      });

      function toArray(value) {
        if (!value) {
          return [];
        }

        if (isArrayLike(value)) {
          return isString(value) ? stringToArray(value) : copyArray(value);
        }

        if (symIterator && value[symIterator]) {
          return iteratorToArray(value[symIterator]());
        }

        var tag = getTag(value),
            func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
        return func(value);
      }

      function toFinite(value) {
        if (!value) {
          return value === 0 ? value : 0;
        }

        value = toNumber(value);

        if (value === INFINITY || value === -INFINITY) {
          var sign = value < 0 ? -1 : 1;
          return sign * MAX_INTEGER;
        }

        return value === value ? value : 0;
      }

      function toInteger(value) {
        var result = toFinite(value),
            remainder = result % 1;
        return result === result ? remainder ? result - remainder : result : 0;
      }

      function toLength(value) {
        return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
      }

      function toNumber(value) {
        if (typeof value == 'number') {
          return value;
        }

        if (isSymbol(value)) {
          return NAN;
        }

        if (isObject(value)) {
          var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
          value = isObject(other) ? other + '' : other;
        }

        if (typeof value != 'string') {
          return value === 0 ? value : +value;
        }

        value = baseTrim(value);
        var isBinary = reIsBinary.test(value);
        return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
      }

      function toPlainObject(value) {
        return copyObject(value, keysIn(value));
      }

      function toSafeInteger(value) {
        return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
      }

      function toString(value) {
        return value == null ? '' : baseToString(value);
      }

      var assign = createAssigner(function (object, source) {
        if (isPrototype(source) || isArrayLike(source)) {
          copyObject(source, keys(source), object);
          return;
        }

        for (var key in source) {
          if (hasOwnProperty.call(source, key)) {
            assignValue(object, key, source[key]);
          }
        }
      });
      var assignIn = createAssigner(function (object, source) {
        copyObject(source, keysIn(source), object);
      });
      var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keysIn(source), object, customizer);
      });
      var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
        copyObject(source, keys(source), object, customizer);
      });
      var at = flatRest(baseAt);

      function create(prototype, properties) {
        var result = baseCreate(prototype);
        return properties == null ? result : baseAssign(result, properties);
      }

      var defaults = baseRest(function (object, sources) {
        object = Object(object);
        var index = -1;
        var length = sources.length;
        var guard = length > 2 ? sources[2] : undefined$1;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          length = 1;
        }

        while (++index < length) {
          var source = sources[index];
          var props = keysIn(source);
          var propsIndex = -1;
          var propsLength = props.length;

          while (++propsIndex < propsLength) {
            var key = props[propsIndex];
            var value = object[key];

            if (value === undefined$1 || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
              object[key] = source[key];
            }
          }
        }

        return object;
      });
      var defaultsDeep = baseRest(function (args) {
        args.push(undefined$1, customDefaultsMerge);
        return apply(mergeWith, undefined$1, args);
      });

      function findKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
      }

      function findLastKey(object, predicate) {
        return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
      }

      function forIn(object, iteratee) {
        return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
      }

      function forInRight(object, iteratee) {
        return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
      }

      function forOwn(object, iteratee) {
        return object && baseForOwn(object, getIteratee(iteratee, 3));
      }

      function forOwnRight(object, iteratee) {
        return object && baseForOwnRight(object, getIteratee(iteratee, 3));
      }

      function functions(object) {
        return object == null ? [] : baseFunctions(object, keys(object));
      }

      function functionsIn(object) {
        return object == null ? [] : baseFunctions(object, keysIn(object));
      }

      function get(object, path, defaultValue) {
        var result = object == null ? undefined$1 : baseGet(object, path);
        return result === undefined$1 ? defaultValue : result;
      }

      function has(object, path) {
        return object != null && hasPath(object, path, baseHas);
      }

      function hasIn(object, path) {
        return object != null && hasPath(object, path, baseHasIn);
      }

      var invert = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }

        result[value] = key;
      }, constant(identity));
      var invertBy = createInverter(function (result, value, key) {
        if (value != null && typeof value.toString != 'function') {
          value = nativeObjectToString.call(value);
        }

        if (hasOwnProperty.call(result, value)) {
          result[value].push(key);
        } else {
          result[value] = [key];
        }
      }, getIteratee);
      var invoke = baseRest(baseInvoke);

      function keys(object) {
        return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
      }

      function keysIn(object) {
        return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
      }

      function mapKeys(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, iteratee(value, key, object), value);
        });
        return result;
      }

      function mapValues(object, iteratee) {
        var result = {};
        iteratee = getIteratee(iteratee, 3);
        baseForOwn(object, function (value, key, object) {
          baseAssignValue(result, key, iteratee(value, key, object));
        });
        return result;
      }

      var merge = createAssigner(function (object, source, srcIndex) {
        baseMerge(object, source, srcIndex);
      });
      var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
        baseMerge(object, source, srcIndex, customizer);
      });
      var omit = flatRest(function (object, paths) {
        var result = {};

        if (object == null) {
          return result;
        }

        var isDeep = false;
        paths = arrayMap(paths, function (path) {
          path = castPath(path, object);
          isDeep || (isDeep = path.length > 1);
          return path;
        });
        copyObject(object, getAllKeysIn(object), result);

        if (isDeep) {
          result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
        }

        var length = paths.length;

        while (length--) {
          baseUnset(result, paths[length]);
        }

        return result;
      });

      function omitBy(object, predicate) {
        return pickBy(object, negate(getIteratee(predicate)));
      }

      var pick = flatRest(function (object, paths) {
        return object == null ? {} : basePick(object, paths);
      });

      function pickBy(object, predicate) {
        if (object == null) {
          return {};
        }

        var props = arrayMap(getAllKeysIn(object), function (prop) {
          return [prop];
        });
        predicate = getIteratee(predicate);
        return basePickBy(object, props, function (value, path) {
          return predicate(value, path[0]);
        });
      }

      function result(object, path, defaultValue) {
        path = castPath(path, object);
        var index = -1,
            length = path.length;

        if (!length) {
          length = 1;
          object = undefined$1;
        }

        while (++index < length) {
          var value = object == null ? undefined$1 : object[toKey(path[index])];

          if (value === undefined$1) {
            index = length;
            value = defaultValue;
          }

          object = isFunction(value) ? value.call(object) : value;
        }

        return object;
      }

      function set(object, path, value) {
        return object == null ? object : baseSet(object, path, value);
      }

      function setWith(object, path, value, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseSet(object, path, value, customizer);
      }

      var toPairs = createToPairs(keys);
      var toPairsIn = createToPairs(keysIn);

      function transform(object, iteratee, accumulator) {
        var isArr = isArray(object),
            isArrLike = isArr || isBuffer(object) || isTypedArray(object);
        iteratee = getIteratee(iteratee, 4);

        if (accumulator == null) {
          var Ctor = object && object.constructor;

          if (isArrLike) {
            accumulator = isArr ? new Ctor() : [];
          } else if (isObject(object)) {
            accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
          } else {
            accumulator = {};
          }
        }

        (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
          return iteratee(accumulator, value, index, object);
        });
        return accumulator;
      }

      function unset(object, path) {
        return object == null ? true : baseUnset(object, path);
      }

      function update(object, path, updater) {
        return object == null ? object : baseUpdate(object, path, castFunction(updater));
      }

      function updateWith(object, path, updater, customizer) {
        customizer = typeof customizer == 'function' ? customizer : undefined$1;
        return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
      }

      function values(object) {
        return object == null ? [] : baseValues(object, keys(object));
      }

      function valuesIn(object) {
        return object == null ? [] : baseValues(object, keysIn(object));
      }

      function clamp(number, lower, upper) {
        if (upper === undefined$1) {
          upper = lower;
          lower = undefined$1;
        }

        if (upper !== undefined$1) {
          upper = toNumber(upper);
          upper = upper === upper ? upper : 0;
        }

        if (lower !== undefined$1) {
          lower = toNumber(lower);
          lower = lower === lower ? lower : 0;
        }

        return baseClamp(toNumber(number), lower, upper);
      }

      function inRange(number, start, end) {
        start = toFinite(start);

        if (end === undefined$1) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }

        number = toNumber(number);
        return baseInRange(number, start, end);
      }

      function random(lower, upper, floating) {
        if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
          upper = floating = undefined$1;
        }

        if (floating === undefined$1) {
          if (typeof upper == 'boolean') {
            floating = upper;
            upper = undefined$1;
          } else if (typeof lower == 'boolean') {
            floating = lower;
            lower = undefined$1;
          }
        }

        if (lower === undefined$1 && upper === undefined$1) {
          lower = 0;
          upper = 1;
        } else {
          lower = toFinite(lower);

          if (upper === undefined$1) {
            upper = lower;
            lower = 0;
          } else {
            upper = toFinite(upper);
          }
        }

        if (lower > upper) {
          var temp = lower;
          lower = upper;
          upper = temp;
        }

        if (floating || lower % 1 || upper % 1) {
          var rand = nativeRandom();
          return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
        }

        return baseRandom(lower, upper);
      }

      var camelCase = createCompounder(function (result, word, index) {
        word = word.toLowerCase();
        return result + (index ? capitalize(word) : word);
      });

      function capitalize(string) {
        return upperFirst(toString(string).toLowerCase());
      }

      function deburr(string) {
        string = toString(string);
        return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
      }

      function endsWith(string, target, position) {
        string = toString(string);
        target = baseToString(target);
        var length = string.length;
        position = position === undefined$1 ? length : baseClamp(toInteger(position), 0, length);
        var end = position;
        position -= target.length;
        return position >= 0 && string.slice(position, end) == target;
      }

      function escape(string) {
        string = toString(string);
        return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
      }

      function escapeRegExp(string) {
        string = toString(string);
        return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
      }

      var kebabCase = createCompounder(function (result, word, index) {
        return result + (index ? '-' : '') + word.toLowerCase();
      });
      var lowerCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toLowerCase();
      });
      var lowerFirst = createCaseFirst('toLowerCase');

      function pad(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;

        if (!length || strLength >= length) {
          return string;
        }

        var mid = (length - strLength) / 2;
        return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
      }

      function padEnd(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
      }

      function padStart(string, length, chars) {
        string = toString(string);
        length = toInteger(length);
        var strLength = length ? stringSize(string) : 0;
        return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
      }

      function parseInt(string, radix, guard) {
        if (guard || radix == null) {
          radix = 0;
        } else if (radix) {
          radix = +radix;
        }

        return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
      }

      function repeat(string, n, guard) {
        if (guard ? isIterateeCall(string, n, guard) : n === undefined$1) {
          n = 1;
        } else {
          n = toInteger(n);
        }

        return baseRepeat(toString(string), n);
      }

      function replace() {
        var args = arguments,
            string = toString(args[0]);
        return args.length < 3 ? string : string.replace(args[1], args[2]);
      }

      var snakeCase = createCompounder(function (result, word, index) {
        return result + (index ? '_' : '') + word.toLowerCase();
      });

      function split(string, separator, limit) {
        if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
          separator = limit = undefined$1;
        }

        limit = limit === undefined$1 ? MAX_ARRAY_LENGTH : limit >>> 0;

        if (!limit) {
          return [];
        }

        string = toString(string);

        if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
          separator = baseToString(separator);

          if (!separator && hasUnicode(string)) {
            return castSlice(stringToArray(string), 0, limit);
          }
        }

        return string.split(separator, limit);
      }

      var startCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + upperFirst(word);
      });

      function startsWith(string, target, position) {
        string = toString(string);
        position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
        target = baseToString(target);
        return string.slice(position, position + target.length) == target;
      }

      function template(string, options, guard) {
        var settings = lodash.templateSettings;

        if (guard && isIterateeCall(string, options, guard)) {
          options = undefined$1;
        }

        string = toString(string);
        options = assignInWith({}, options, settings, customDefaultsAssignIn);
        var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
            importsKeys = keys(imports),
            importsValues = baseValues(imports, importsKeys);
        var isEscaping,
            isEvaluating,
            index = 0,
            interpolate = options.interpolate || reNoMatch,
            source = "__p += '";
        var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');
        var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
        string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
          interpolateValue || (interpolateValue = esTemplateValue);
          source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

          if (escapeValue) {
            isEscaping = true;
            source += "' +\n__e(" + escapeValue + ") +\n'";
          }

          if (evaluateValue) {
            isEvaluating = true;
            source += "';\n" + evaluateValue + ";\n__p += '";
          }

          if (interpolateValue) {
            source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
          }

          index = offset + match.length;
          return match;
        });
        source += "';\n";
        var variable = hasOwnProperty.call(options, 'variable') && options.variable;

        if (!variable) {
          source = 'with (obj) {\n' + source + '\n}\n';
        } else if (reForbiddenIdentifierChars.test(variable)) {
          throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
        }

        source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');
        source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
        var result = attempt(function () {
          return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined$1, importsValues);
        });
        result.source = source;

        if (isError(result)) {
          throw result;
        }

        return result;
      }

      function toLower(value) {
        return toString(value).toLowerCase();
      }

      function toUpper(value) {
        return toString(value).toUpperCase();
      }

      function trim(string, chars, guard) {
        string = toString(string);

        if (string && (guard || chars === undefined$1)) {
          return baseTrim(string);
        }

        if (!string || !(chars = baseToString(chars))) {
          return string;
        }

        var strSymbols = stringToArray(string),
            chrSymbols = stringToArray(chars),
            start = charsStartIndex(strSymbols, chrSymbols),
            end = charsEndIndex(strSymbols, chrSymbols) + 1;
        return castSlice(strSymbols, start, end).join('');
      }

      function trimEnd(string, chars, guard) {
        string = toString(string);

        if (string && (guard || chars === undefined$1)) {
          return string.slice(0, trimmedEndIndex(string) + 1);
        }

        if (!string || !(chars = baseToString(chars))) {
          return string;
        }

        var strSymbols = stringToArray(string),
            end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
        return castSlice(strSymbols, 0, end).join('');
      }

      function trimStart(string, chars, guard) {
        string = toString(string);

        if (string && (guard || chars === undefined$1)) {
          return string.replace(reTrimStart, '');
        }

        if (!string || !(chars = baseToString(chars))) {
          return string;
        }

        var strSymbols = stringToArray(string),
            start = charsStartIndex(strSymbols, stringToArray(chars));
        return castSlice(strSymbols, start).join('');
      }

      function truncate(string, options) {
        var length = DEFAULT_TRUNC_LENGTH,
            omission = DEFAULT_TRUNC_OMISSION;

        if (isObject(options)) {
          var separator = 'separator' in options ? options.separator : separator;
          length = 'length' in options ? toInteger(options.length) : length;
          omission = 'omission' in options ? baseToString(options.omission) : omission;
        }

        string = toString(string);
        var strLength = string.length;

        if (hasUnicode(string)) {
          var strSymbols = stringToArray(string);
          strLength = strSymbols.length;
        }

        if (length >= strLength) {
          return string;
        }

        var end = length - stringSize(omission);

        if (end < 1) {
          return omission;
        }

        var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);

        if (separator === undefined$1) {
          return result + omission;
        }

        if (strSymbols) {
          end += result.length - end;
        }

        if (isRegExp(separator)) {
          if (string.slice(end).search(separator)) {
            var match,
                substring = result;

            if (!separator.global) {
              separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
            }

            separator.lastIndex = 0;

            while (match = separator.exec(substring)) {
              var newEnd = match.index;
            }

            result = result.slice(0, newEnd === undefined$1 ? end : newEnd);
          }
        } else if (string.indexOf(baseToString(separator), end) != end) {
          var index = result.lastIndexOf(separator);

          if (index > -1) {
            result = result.slice(0, index);
          }
        }

        return result + omission;
      }

      function unescape(string) {
        string = toString(string);
        return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
      }

      var upperCase = createCompounder(function (result, word, index) {
        return result + (index ? ' ' : '') + word.toUpperCase();
      });
      var upperFirst = createCaseFirst('toUpperCase');

      function words(string, pattern, guard) {
        string = toString(string);
        pattern = guard ? undefined$1 : pattern;

        if (pattern === undefined$1) {
          return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
        }

        return string.match(pattern) || [];
      }

      var attempt = baseRest(function (func, args) {
        try {
          return apply(func, undefined$1, args);
        } catch (e) {
          return isError(e) ? e : new Error(e);
        }
      });
      var bindAll = flatRest(function (object, methodNames) {
        arrayEach(methodNames, function (key) {
          key = toKey(key);
          baseAssignValue(object, key, bind(object[key], object));
        });
        return object;
      });

      function cond(pairs) {
        var length = pairs == null ? 0 : pairs.length,
            toIteratee = getIteratee();
        pairs = !length ? [] : arrayMap(pairs, function (pair) {
          if (typeof pair[1] != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }

          return [toIteratee(pair[0]), pair[1]];
        });
        return baseRest(function (args) {
          var index = -1;

          while (++index < length) {
            var pair = pairs[index];

            if (apply(pair[0], this, args)) {
              return apply(pair[1], this, args);
            }
          }
        });
      }

      function conforms(source) {
        return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
      }

      function constant(value) {
        return function () {
          return value;
        };
      }

      function defaultTo(value, defaultValue) {
        return value == null || value !== value ? defaultValue : value;
      }

      var flow = createFlow();
      var flowRight = createFlow(true);

      function identity(value) {
        return value;
      }

      function iteratee(func) {
        return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
      }

      function matches(source) {
        return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
      }

      function matchesProperty(path, srcValue) {
        return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
      }

      var method = baseRest(function (path, args) {
        return function (object) {
          return baseInvoke(object, path, args);
        };
      });
      var methodOf = baseRest(function (object, args) {
        return function (path) {
          return baseInvoke(object, path, args);
        };
      });

      function mixin(object, source, options) {
        var props = keys(source),
            methodNames = baseFunctions(source, props);

        if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
          options = source;
          source = object;
          object = this;
          methodNames = baseFunctions(source, keys(source));
        }

        var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
            isFunc = isFunction(object);
        arrayEach(methodNames, function (methodName) {
          var func = source[methodName];
          object[methodName] = func;

          if (isFunc) {
            object.prototype[methodName] = function () {
              var chainAll = this.__chain__;

              if (chain || chainAll) {
                var result = object(this.__wrapped__),
                    actions = result.__actions__ = copyArray(this.__actions__);
                actions.push({
                  'func': func,
                  'args': arguments,
                  'thisArg': object
                });
                result.__chain__ = chainAll;
                return result;
              }

              return func.apply(object, arrayPush([this.value()], arguments));
            };
          }
        });
        return object;
      }

      function noConflict() {
        if (root._ === this) {
          root._ = oldDash;
        }

        return this;
      }

      function noop() {}

      function nthArg(n) {
        n = toInteger(n);
        return baseRest(function (args) {
          return baseNth(args, n);
        });
      }

      var over = createOver(arrayMap);
      var overEvery = createOver(arrayEvery);
      var overSome = createOver(arraySome);

      function property(path) {
        return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
      }

      function propertyOf(object) {
        return function (path) {
          return object == null ? undefined$1 : baseGet(object, path);
        };
      }

      var range = createRange();
      var rangeRight = createRange(true);

      function stubArray() {
        return [];
      }

      function stubFalse() {
        return false;
      }

      function stubObject() {
        return {};
      }

      function stubString() {
        return '';
      }

      function stubTrue() {
        return true;
      }

      function times(n, iteratee) {
        n = toInteger(n);

        if (n < 1 || n > MAX_SAFE_INTEGER) {
          return [];
        }

        var index = MAX_ARRAY_LENGTH,
            length = nativeMin(n, MAX_ARRAY_LENGTH);
        iteratee = getIteratee(iteratee);
        n -= MAX_ARRAY_LENGTH;
        var result = baseTimes(length, iteratee);

        while (++index < n) {
          iteratee(index);
        }

        return result;
      }

      function toPath(value) {
        if (isArray(value)) {
          return arrayMap(value, toKey);
        }

        return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
      }

      function uniqueId(prefix) {
        var id = ++idCounter;
        return toString(prefix) + id;
      }

      var add = createMathOperation(function (augend, addend) {
        return augend + addend;
      }, 0);
      var ceil = createRound('ceil');
      var divide = createMathOperation(function (dividend, divisor) {
        return dividend / divisor;
      }, 1);
      var floor = createRound('floor');

      function max(array) {
        return array && array.length ? baseExtremum(array, identity, baseGt) : undefined$1;
      }

      function maxBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined$1;
      }

      function mean(array) {
        return baseMean(array, identity);
      }

      function meanBy(array, iteratee) {
        return baseMean(array, getIteratee(iteratee, 2));
      }

      function min(array) {
        return array && array.length ? baseExtremum(array, identity, baseLt) : undefined$1;
      }

      function minBy(array, iteratee) {
        return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined$1;
      }

      var multiply = createMathOperation(function (multiplier, multiplicand) {
        return multiplier * multiplicand;
      }, 1);
      var round = createRound('round');
      var subtract = createMathOperation(function (minuend, subtrahend) {
        return minuend - subtrahend;
      }, 0);

      function sum(array) {
        return array && array.length ? baseSum(array, identity) : 0;
      }

      function sumBy(array, iteratee) {
        return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
      }

      lodash.after = after;
      lodash.ary = ary;
      lodash.assign = assign;
      lodash.assignIn = assignIn;
      lodash.assignInWith = assignInWith;
      lodash.assignWith = assignWith;
      lodash.at = at;
      lodash.before = before;
      lodash.bind = bind;
      lodash.bindAll = bindAll;
      lodash.bindKey = bindKey;
      lodash.castArray = castArray;
      lodash.chain = chain;
      lodash.chunk = chunk;
      lodash.compact = compact;
      lodash.concat = concat;
      lodash.cond = cond;
      lodash.conforms = conforms;
      lodash.constant = constant;
      lodash.countBy = countBy;
      lodash.create = create;
      lodash.curry = curry;
      lodash.curryRight = curryRight;
      lodash.debounce = debounce;
      lodash.defaults = defaults;
      lodash.defaultsDeep = defaultsDeep;
      lodash.defer = defer;
      lodash.delay = delay;
      lodash.difference = difference;
      lodash.differenceBy = differenceBy;
      lodash.differenceWith = differenceWith;
      lodash.drop = drop;
      lodash.dropRight = dropRight;
      lodash.dropRightWhile = dropRightWhile;
      lodash.dropWhile = dropWhile;
      lodash.fill = fill;
      lodash.filter = filter;
      lodash.flatMap = flatMap;
      lodash.flatMapDeep = flatMapDeep;
      lodash.flatMapDepth = flatMapDepth;
      lodash.flatten = flatten;
      lodash.flattenDeep = flattenDeep;
      lodash.flattenDepth = flattenDepth;
      lodash.flip = flip;
      lodash.flow = flow;
      lodash.flowRight = flowRight;
      lodash.fromPairs = fromPairs;
      lodash.functions = functions;
      lodash.functionsIn = functionsIn;
      lodash.groupBy = groupBy;
      lodash.initial = initial;
      lodash.intersection = intersection;
      lodash.intersectionBy = intersectionBy;
      lodash.intersectionWith = intersectionWith;
      lodash.invert = invert;
      lodash.invertBy = invertBy;
      lodash.invokeMap = invokeMap;
      lodash.iteratee = iteratee;
      lodash.keyBy = keyBy;
      lodash.keys = keys;
      lodash.keysIn = keysIn;
      lodash.map = map;
      lodash.mapKeys = mapKeys;
      lodash.mapValues = mapValues;
      lodash.matches = matches;
      lodash.matchesProperty = matchesProperty;
      lodash.memoize = memoize;
      lodash.merge = merge;
      lodash.mergeWith = mergeWith;
      lodash.method = method;
      lodash.methodOf = methodOf;
      lodash.mixin = mixin;
      lodash.negate = negate;
      lodash.nthArg = nthArg;
      lodash.omit = omit;
      lodash.omitBy = omitBy;
      lodash.once = once;
      lodash.orderBy = orderBy;
      lodash.over = over;
      lodash.overArgs = overArgs;
      lodash.overEvery = overEvery;
      lodash.overSome = overSome;
      lodash.partial = partial;
      lodash.partialRight = partialRight;
      lodash.partition = partition;
      lodash.pick = pick;
      lodash.pickBy = pickBy;
      lodash.property = property;
      lodash.propertyOf = propertyOf;
      lodash.pull = pull;
      lodash.pullAll = pullAll;
      lodash.pullAllBy = pullAllBy;
      lodash.pullAllWith = pullAllWith;
      lodash.pullAt = pullAt;
      lodash.range = range;
      lodash.rangeRight = rangeRight;
      lodash.rearg = rearg;
      lodash.reject = reject;
      lodash.remove = remove;
      lodash.rest = rest;
      lodash.reverse = reverse;
      lodash.sampleSize = sampleSize;
      lodash.set = set;
      lodash.setWith = setWith;
      lodash.shuffle = shuffle;
      lodash.slice = slice;
      lodash.sortBy = sortBy;
      lodash.sortedUniq = sortedUniq;
      lodash.sortedUniqBy = sortedUniqBy;
      lodash.split = split;
      lodash.spread = spread;
      lodash.tail = tail;
      lodash.take = take;
      lodash.takeRight = takeRight;
      lodash.takeRightWhile = takeRightWhile;
      lodash.takeWhile = takeWhile;
      lodash.tap = tap;
      lodash.throttle = throttle;
      lodash.thru = thru;
      lodash.toArray = toArray;
      lodash.toPairs = toPairs;
      lodash.toPairsIn = toPairsIn;
      lodash.toPath = toPath;
      lodash.toPlainObject = toPlainObject;
      lodash.transform = transform;
      lodash.unary = unary;
      lodash.union = union;
      lodash.unionBy = unionBy;
      lodash.unionWith = unionWith;
      lodash.uniq = uniq;
      lodash.uniqBy = uniqBy;
      lodash.uniqWith = uniqWith;
      lodash.unset = unset;
      lodash.unzip = unzip;
      lodash.unzipWith = unzipWith;
      lodash.update = update;
      lodash.updateWith = updateWith;
      lodash.values = values;
      lodash.valuesIn = valuesIn;
      lodash.without = without;
      lodash.words = words;
      lodash.wrap = wrap;
      lodash.xor = xor;
      lodash.xorBy = xorBy;
      lodash.xorWith = xorWith;
      lodash.zip = zip;
      lodash.zipObject = zipObject;
      lodash.zipObjectDeep = zipObjectDeep;
      lodash.zipWith = zipWith;
      lodash.entries = toPairs;
      lodash.entriesIn = toPairsIn;
      lodash.extend = assignIn;
      lodash.extendWith = assignInWith;
      mixin(lodash, lodash);
      lodash.add = add;
      lodash.attempt = attempt;
      lodash.camelCase = camelCase;
      lodash.capitalize = capitalize;
      lodash.ceil = ceil;
      lodash.clamp = clamp;
      lodash.clone = clone;
      lodash.cloneDeep = cloneDeep;
      lodash.cloneDeepWith = cloneDeepWith;
      lodash.cloneWith = cloneWith;
      lodash.conformsTo = conformsTo;
      lodash.deburr = deburr;
      lodash.defaultTo = defaultTo;
      lodash.divide = divide;
      lodash.endsWith = endsWith;
      lodash.eq = eq;
      lodash.escape = escape;
      lodash.escapeRegExp = escapeRegExp;
      lodash.every = every;
      lodash.find = find;
      lodash.findIndex = findIndex;
      lodash.findKey = findKey;
      lodash.findLast = findLast;
      lodash.findLastIndex = findLastIndex;
      lodash.findLastKey = findLastKey;
      lodash.floor = floor;
      lodash.forEach = forEach;
      lodash.forEachRight = forEachRight;
      lodash.forIn = forIn;
      lodash.forInRight = forInRight;
      lodash.forOwn = forOwn;
      lodash.forOwnRight = forOwnRight;
      lodash.get = get;
      lodash.gt = gt;
      lodash.gte = gte;
      lodash.has = has;
      lodash.hasIn = hasIn;
      lodash.head = head;
      lodash.identity = identity;
      lodash.includes = includes;
      lodash.indexOf = indexOf;
      lodash.inRange = inRange;
      lodash.invoke = invoke;
      lodash.isArguments = isArguments;
      lodash.isArray = isArray;
      lodash.isArrayBuffer = isArrayBuffer;
      lodash.isArrayLike = isArrayLike;
      lodash.isArrayLikeObject = isArrayLikeObject;
      lodash.isBoolean = isBoolean;
      lodash.isBuffer = isBuffer;
      lodash.isDate = isDate;
      lodash.isElement = isElement;
      lodash.isEmpty = isEmpty;
      lodash.isEqual = isEqual;
      lodash.isEqualWith = isEqualWith;
      lodash.isError = isError;
      lodash.isFinite = isFinite;
      lodash.isFunction = isFunction;
      lodash.isInteger = isInteger;
      lodash.isLength = isLength;
      lodash.isMap = isMap;
      lodash.isMatch = isMatch;
      lodash.isMatchWith = isMatchWith;
      lodash.isNaN = isNaN;
      lodash.isNative = isNative;
      lodash.isNil = isNil;
      lodash.isNull = isNull;
      lodash.isNumber = isNumber;
      lodash.isObject = isObject;
      lodash.isObjectLike = isObjectLike;
      lodash.isPlainObject = isPlainObject;
      lodash.isRegExp = isRegExp;
      lodash.isSafeInteger = isSafeInteger;
      lodash.isSet = isSet;
      lodash.isString = isString;
      lodash.isSymbol = isSymbol;
      lodash.isTypedArray = isTypedArray;
      lodash.isUndefined = isUndefined;
      lodash.isWeakMap = isWeakMap;
      lodash.isWeakSet = isWeakSet;
      lodash.join = join;
      lodash.kebabCase = kebabCase;
      lodash.last = last;
      lodash.lastIndexOf = lastIndexOf;
      lodash.lowerCase = lowerCase;
      lodash.lowerFirst = lowerFirst;
      lodash.lt = lt;
      lodash.lte = lte;
      lodash.max = max;
      lodash.maxBy = maxBy;
      lodash.mean = mean;
      lodash.meanBy = meanBy;
      lodash.min = min;
      lodash.minBy = minBy;
      lodash.stubArray = stubArray;
      lodash.stubFalse = stubFalse;
      lodash.stubObject = stubObject;
      lodash.stubString = stubString;
      lodash.stubTrue = stubTrue;
      lodash.multiply = multiply;
      lodash.nth = nth;
      lodash.noConflict = noConflict;
      lodash.noop = noop;
      lodash.now = now;
      lodash.pad = pad;
      lodash.padEnd = padEnd;
      lodash.padStart = padStart;
      lodash.parseInt = parseInt;
      lodash.random = random;
      lodash.reduce = reduce;
      lodash.reduceRight = reduceRight;
      lodash.repeat = repeat;
      lodash.replace = replace;
      lodash.result = result;
      lodash.round = round;
      lodash.runInContext = runInContext;
      lodash.sample = sample;
      lodash.size = size;
      lodash.snakeCase = snakeCase;
      lodash.some = some;
      lodash.sortedIndex = sortedIndex;
      lodash.sortedIndexBy = sortedIndexBy;
      lodash.sortedIndexOf = sortedIndexOf;
      lodash.sortedLastIndex = sortedLastIndex;
      lodash.sortedLastIndexBy = sortedLastIndexBy;
      lodash.sortedLastIndexOf = sortedLastIndexOf;
      lodash.startCase = startCase;
      lodash.startsWith = startsWith;
      lodash.subtract = subtract;
      lodash.sum = sum;
      lodash.sumBy = sumBy;
      lodash.template = template;
      lodash.times = times;
      lodash.toFinite = toFinite;
      lodash.toInteger = toInteger;
      lodash.toLength = toLength;
      lodash.toLower = toLower;
      lodash.toNumber = toNumber;
      lodash.toSafeInteger = toSafeInteger;
      lodash.toString = toString;
      lodash.toUpper = toUpper;
      lodash.trim = trim;
      lodash.trimEnd = trimEnd;
      lodash.trimStart = trimStart;
      lodash.truncate = truncate;
      lodash.unescape = unescape;
      lodash.uniqueId = uniqueId;
      lodash.upperCase = upperCase;
      lodash.upperFirst = upperFirst;
      lodash.each = forEach;
      lodash.eachRight = forEachRight;
      lodash.first = head;
      mixin(lodash, function () {
        var source = {};
        baseForOwn(lodash, function (func, methodName) {
          if (!hasOwnProperty.call(lodash.prototype, methodName)) {
            source[methodName] = func;
          }
        });
        return source;
      }(), {
        'chain': false
      });
      lodash.VERSION = VERSION;
      arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
        lodash[methodName].placeholder = lodash;
      });
      arrayEach(['drop', 'take'], function (methodName, index) {
        LazyWrapper.prototype[methodName] = function (n) {
          n = n === undefined$1 ? 1 : nativeMax(toInteger(n), 0);
          var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();

          if (result.__filtered__) {
            result.__takeCount__ = nativeMin(n, result.__takeCount__);
          } else {
            result.__views__.push({
              'size': nativeMin(n, MAX_ARRAY_LENGTH),
              'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
            });
          }

          return result;
        };

        LazyWrapper.prototype[methodName + 'Right'] = function (n) {
          return this.reverse()[methodName](n).reverse();
        };
      });
      arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
        var type = index + 1,
            isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

        LazyWrapper.prototype[methodName] = function (iteratee) {
          var result = this.clone();

          result.__iteratees__.push({
            'iteratee': getIteratee(iteratee, 3),
            'type': type
          });

          result.__filtered__ = result.__filtered__ || isFilter;
          return result;
        };
      });
      arrayEach(['head', 'last'], function (methodName, index) {
        var takeName = 'take' + (index ? 'Right' : '');

        LazyWrapper.prototype[methodName] = function () {
          return this[takeName](1).value()[0];
        };
      });
      arrayEach(['initial', 'tail'], function (methodName, index) {
        var dropName = 'drop' + (index ? '' : 'Right');

        LazyWrapper.prototype[methodName] = function () {
          return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
        };
      });

      LazyWrapper.prototype.compact = function () {
        return this.filter(identity);
      };

      LazyWrapper.prototype.find = function (predicate) {
        return this.filter(predicate).head();
      };

      LazyWrapper.prototype.findLast = function (predicate) {
        return this.reverse().find(predicate);
      };

      LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
        if (typeof path == 'function') {
          return new LazyWrapper(this);
        }

        return this.map(function (value) {
          return baseInvoke(value, path, args);
        });
      });

      LazyWrapper.prototype.reject = function (predicate) {
        return this.filter(negate(getIteratee(predicate)));
      };

      LazyWrapper.prototype.slice = function (start, end) {
        start = toInteger(start);
        var result = this;

        if (result.__filtered__ && (start > 0 || end < 0)) {
          return new LazyWrapper(result);
        }

        if (start < 0) {
          result = result.takeRight(-start);
        } else if (start) {
          result = result.drop(start);
        }

        if (end !== undefined$1) {
          end = toInteger(end);
          result = end < 0 ? result.dropRight(-end) : result.take(end - start);
        }

        return result;
      };

      LazyWrapper.prototype.takeRightWhile = function (predicate) {
        return this.reverse().takeWhile(predicate).reverse();
      };

      LazyWrapper.prototype.toArray = function () {
        return this.take(MAX_ARRAY_LENGTH);
      };

      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
            isTaker = /^(?:head|last)$/.test(methodName),
            lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
            retUnwrapped = isTaker || /^find/.test(methodName);

        if (!lodashFunc) {
          return;
        }

        lodash.prototype[methodName] = function () {
          var value = this.__wrapped__,
              args = isTaker ? [1] : arguments,
              isLazy = value instanceof LazyWrapper,
              iteratee = args[0],
              useLazy = isLazy || isArray(value);

          var interceptor = function interceptor(value) {
            var result = lodashFunc.apply(lodash, arrayPush([value], args));
            return isTaker && chainAll ? result[0] : result;
          };

          if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
            isLazy = useLazy = false;
          }

          var chainAll = this.__chain__,
              isHybrid = !!this.__actions__.length,
              isUnwrapped = retUnwrapped && !chainAll,
              onlyLazy = isLazy && !isHybrid;

          if (!retUnwrapped && useLazy) {
            value = onlyLazy ? value : new LazyWrapper(this);
            var result = func.apply(value, args);

            result.__actions__.push({
              'func': thru,
              'args': [interceptor],
              'thisArg': undefined$1
            });

            return new LodashWrapper(result, chainAll);
          }

          if (isUnwrapped && onlyLazy) {
            return func.apply(this, args);
          }

          result = this.thru(interceptor);
          return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
        };
      });
      arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
        var func = arrayProto[methodName],
            chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
            retUnwrapped = /^(?:pop|shift)$/.test(methodName);

        lodash.prototype[methodName] = function () {
          var args = arguments;

          if (retUnwrapped && !this.__chain__) {
            var value = this.value();
            return func.apply(isArray(value) ? value : [], args);
          }

          return this[chainName](function (value) {
            return func.apply(isArray(value) ? value : [], args);
          });
        };
      });
      baseForOwn(LazyWrapper.prototype, function (func, methodName) {
        var lodashFunc = lodash[methodName];

        if (lodashFunc) {
          var key = lodashFunc.name + '';

          if (!hasOwnProperty.call(realNames, key)) {
            realNames[key] = [];
          }

          realNames[key].push({
            'name': methodName,
            'func': lodashFunc
          });
        }
      });
      realNames[createHybrid(undefined$1, WRAP_BIND_KEY_FLAG).name] = [{
        'name': 'wrapper',
        'func': undefined$1
      }];
      LazyWrapper.prototype.clone = lazyClone;
      LazyWrapper.prototype.reverse = lazyReverse;
      LazyWrapper.prototype.value = lazyValue;
      lodash.prototype.at = wrapperAt;
      lodash.prototype.chain = wrapperChain;
      lodash.prototype.commit = wrapperCommit;
      lodash.prototype.next = wrapperNext;
      lodash.prototype.plant = wrapperPlant;
      lodash.prototype.reverse = wrapperReverse;
      lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
      lodash.prototype.first = lodash.prototype.head;

      if (symIterator) {
        lodash.prototype[symIterator] = wrapperToIterator;
      }

      return lodash;
    };

    var _ = runInContext();

    if (freeModule) {
      (freeModule.exports = _)._ = _;
      freeExports._ = _;
    } else {
      root._ = _;
    }
  }).call(commonjsGlobal);
});

var visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }

  if (b[orderBy] > a[orderBy]) {
    return 1;
  }

  return 0;
}
function getComparator(order, orderBy) {
  return order === 'desc' ? function (a, b) {
    return descendingComparator(a, b, orderBy);
  } : function (a, b) {
    return -descendingComparator(a, b, orderBy);
  };
}
function stableSort(array, comparator) {
  var stabilizedThis = array.map(function (el, index) {
    return [el, index];
  });
  stabilizedThis.sort(function (a, b) {
    var order = comparator(a[0], b[0]);

    if (order !== 0) {
      return order;
    }

    return a[1] - b[1];
  });
  return stabilizedThis.map(function (el) {
    return el[0];
  });
}

var resizeObservers = [];

var hasActiveObservations = function hasActiveObservations() {
  return resizeObservers.some(function (ro) {
    return ro.activeTargets.length > 0;
  });
};

var hasSkippedObservations = function hasSkippedObservations() {
  return resizeObservers.some(function (ro) {
    return ro.skippedTargets.length > 0;
  });
};

var msg = 'ResizeObserver loop completed with undelivered notifications.';

var deliverResizeLoopError = function deliverResizeLoopError() {
  var event;

  if (typeof ErrorEvent === 'function') {
    event = new ErrorEvent('error', {
      message: msg
    });
  } else {
    event = document.createEvent('Event');
    event.initEvent('error', false, false);
    event.message = msg;
  }

  window.dispatchEvent(event);
};

var ResizeObserverBoxOptions;

(function (ResizeObserverBoxOptions) {
  ResizeObserverBoxOptions["BORDER_BOX"] = "border-box";
  ResizeObserverBoxOptions["CONTENT_BOX"] = "content-box";
  ResizeObserverBoxOptions["DEVICE_PIXEL_CONTENT_BOX"] = "device-pixel-content-box";
})(ResizeObserverBoxOptions || (ResizeObserverBoxOptions = {}));

var freeze = function freeze(obj) {
  return Object.freeze(obj);
};

var ResizeObserverSize = function () {
  function ResizeObserverSize(inlineSize, blockSize) {
    this.inlineSize = inlineSize;
    this.blockSize = blockSize;
    freeze(this);
  }

  return ResizeObserverSize;
}();

var DOMRectReadOnly = function () {
  function DOMRectReadOnly(x, y, width, height) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.top = this.y;
    this.left = this.x;
    this.bottom = this.top + this.height;
    this.right = this.left + this.width;
    return freeze(this);
  }

  DOMRectReadOnly.prototype.toJSON = function () {
    var _a = this,
        x = _a.x,
        y = _a.y,
        top = _a.top,
        right = _a.right,
        bottom = _a.bottom,
        left = _a.left,
        width = _a.width,
        height = _a.height;

    return {
      x: x,
      y: y,
      top: top,
      right: right,
      bottom: bottom,
      left: left,
      width: width,
      height: height
    };
  };

  DOMRectReadOnly.fromRect = function (rectangle) {
    return new DOMRectReadOnly(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
  };

  return DOMRectReadOnly;
}();

var isSVG = function isSVG(target) {
  return target instanceof SVGElement && 'getBBox' in target;
};

var isHidden = function isHidden(target) {
  if (isSVG(target)) {
    var _a = target.getBBox(),
        width = _a.width,
        height = _a.height;

    return !width && !height;
  }

  var _b = target,
      offsetWidth = _b.offsetWidth,
      offsetHeight = _b.offsetHeight;
  return !(offsetWidth || offsetHeight || target.getClientRects().length);
};

var isElement = function isElement(obj) {
  var _a, _b;

  if (obj instanceof Element) {
    return true;
  }

  var scope = (_b = (_a = obj) === null || _a === void 0 ? void 0 : _a.ownerDocument) === null || _b === void 0 ? void 0 : _b.defaultView;
  return !!(scope && obj instanceof scope.Element);
};

var isReplacedElement = function isReplacedElement(target) {
  switch (target.tagName) {
    case 'INPUT':
      if (target.type !== 'image') {
        break;
      }

    case 'VIDEO':
    case 'AUDIO':
    case 'EMBED':
    case 'OBJECT':
    case 'CANVAS':
    case 'IFRAME':
    case 'IMG':
      return true;
  }

  return false;
};

var global$1 = typeof window !== 'undefined' ? window : {};

var cache = new WeakMap();
var scrollRegexp = /auto|scroll/;
var verticalRegexp = /^tb|vertical/;
var IE = /msie|trident/i.test(global$1.navigator && global$1.navigator.userAgent);

var parseDimension = function parseDimension(pixel) {
  return parseFloat(pixel || '0');
};

var size = function size(inlineSize, blockSize, switchSizes) {
  if (inlineSize === void 0) {
    inlineSize = 0;
  }

  if (blockSize === void 0) {
    blockSize = 0;
  }

  if (switchSizes === void 0) {
    switchSizes = false;
  }

  return new ResizeObserverSize((switchSizes ? blockSize : inlineSize) || 0, (switchSizes ? inlineSize : blockSize) || 0);
};

var zeroBoxes = freeze({
  devicePixelContentBoxSize: size(),
  borderBoxSize: size(),
  contentBoxSize: size(),
  contentRect: new DOMRectReadOnly(0, 0, 0, 0)
});

var calculateBoxSizes = function calculateBoxSizes(target, forceRecalculation) {
  if (forceRecalculation === void 0) {
    forceRecalculation = false;
  }

  if (cache.has(target) && !forceRecalculation) {
    return cache.get(target);
  }

  if (isHidden(target)) {
    cache.set(target, zeroBoxes);
    return zeroBoxes;
  }

  var cs = getComputedStyle(target);
  var svg = isSVG(target) && target.ownerSVGElement && target.getBBox();
  var removePadding = !IE && cs.boxSizing === 'border-box';
  var switchSizes = verticalRegexp.test(cs.writingMode || '');
  var canScrollVertically = !svg && scrollRegexp.test(cs.overflowY || '');
  var canScrollHorizontally = !svg && scrollRegexp.test(cs.overflowX || '');
  var paddingTop = svg ? 0 : parseDimension(cs.paddingTop);
  var paddingRight = svg ? 0 : parseDimension(cs.paddingRight);
  var paddingBottom = svg ? 0 : parseDimension(cs.paddingBottom);
  var paddingLeft = svg ? 0 : parseDimension(cs.paddingLeft);
  var borderTop = svg ? 0 : parseDimension(cs.borderTopWidth);
  var borderRight = svg ? 0 : parseDimension(cs.borderRightWidth);
  var borderBottom = svg ? 0 : parseDimension(cs.borderBottomWidth);
  var borderLeft = svg ? 0 : parseDimension(cs.borderLeftWidth);
  var horizontalPadding = paddingLeft + paddingRight;
  var verticalPadding = paddingTop + paddingBottom;
  var horizontalBorderArea = borderLeft + borderRight;
  var verticalBorderArea = borderTop + borderBottom;
  var horizontalScrollbarThickness = !canScrollHorizontally ? 0 : target.offsetHeight - verticalBorderArea - target.clientHeight;
  var verticalScrollbarThickness = !canScrollVertically ? 0 : target.offsetWidth - horizontalBorderArea - target.clientWidth;
  var widthReduction = removePadding ? horizontalPadding + horizontalBorderArea : 0;
  var heightReduction = removePadding ? verticalPadding + verticalBorderArea : 0;
  var contentWidth = svg ? svg.width : parseDimension(cs.width) - widthReduction - verticalScrollbarThickness;
  var contentHeight = svg ? svg.height : parseDimension(cs.height) - heightReduction - horizontalScrollbarThickness;
  var borderBoxWidth = contentWidth + horizontalPadding + verticalScrollbarThickness + horizontalBorderArea;
  var borderBoxHeight = contentHeight + verticalPadding + horizontalScrollbarThickness + verticalBorderArea;
  var boxes = freeze({
    devicePixelContentBoxSize: size(Math.round(contentWidth * devicePixelRatio), Math.round(contentHeight * devicePixelRatio), switchSizes),
    borderBoxSize: size(borderBoxWidth, borderBoxHeight, switchSizes),
    contentBoxSize: size(contentWidth, contentHeight, switchSizes),
    contentRect: new DOMRectReadOnly(paddingLeft, paddingTop, contentWidth, contentHeight)
  });
  cache.set(target, boxes);
  return boxes;
};

var calculateBoxSize = function calculateBoxSize(target, observedBox, forceRecalculation) {
  var _a = calculateBoxSizes(target, forceRecalculation),
      borderBoxSize = _a.borderBoxSize,
      contentBoxSize = _a.contentBoxSize,
      devicePixelContentBoxSize = _a.devicePixelContentBoxSize;

  switch (observedBox) {
    case ResizeObserverBoxOptions.DEVICE_PIXEL_CONTENT_BOX:
      return devicePixelContentBoxSize;

    case ResizeObserverBoxOptions.BORDER_BOX:
      return borderBoxSize;

    default:
      return contentBoxSize;
  }
};

var ResizeObserverEntry = function () {
  function ResizeObserverEntry(target) {
    var boxes = calculateBoxSizes(target);
    this.target = target;
    this.contentRect = boxes.contentRect;
    this.borderBoxSize = freeze([boxes.borderBoxSize]);
    this.contentBoxSize = freeze([boxes.contentBoxSize]);
    this.devicePixelContentBoxSize = freeze([boxes.devicePixelContentBoxSize]);
  }

  return ResizeObserverEntry;
}();

var calculateDepthForNode = function calculateDepthForNode(node) {
  if (isHidden(node)) {
    return Infinity;
  }

  var depth = 0;
  var parent = node.parentNode;

  while (parent) {
    depth += 1;
    parent = parent.parentNode;
  }

  return depth;
};

var broadcastActiveObservations = function broadcastActiveObservations() {
  var shallowestDepth = Infinity;
  var callbacks = [];
  resizeObservers.forEach(function processObserver(ro) {
    if (ro.activeTargets.length === 0) {
      return;
    }

    var entries = [];
    ro.activeTargets.forEach(function processTarget(ot) {
      var entry = new ResizeObserverEntry(ot.target);
      var targetDepth = calculateDepthForNode(ot.target);
      entries.push(entry);
      ot.lastReportedSize = calculateBoxSize(ot.target, ot.observedBox);

      if (targetDepth < shallowestDepth) {
        shallowestDepth = targetDepth;
      }
    });
    callbacks.push(function resizeObserverCallback() {
      ro.callback.call(ro.observer, entries, ro.observer);
    });
    ro.activeTargets.splice(0, ro.activeTargets.length);
  });

  for (var _i = 0, callbacks_1 = callbacks; _i < callbacks_1.length; _i++) {
    var callback = callbacks_1[_i];
    callback();
  }

  return shallowestDepth;
};

var gatherActiveObservationsAtDepth = function gatherActiveObservationsAtDepth(depth) {
  resizeObservers.forEach(function processObserver(ro) {
    ro.activeTargets.splice(0, ro.activeTargets.length);
    ro.skippedTargets.splice(0, ro.skippedTargets.length);
    ro.observationTargets.forEach(function processTarget(ot) {
      if (ot.isActive()) {
        if (calculateDepthForNode(ot.target) > depth) {
          ro.activeTargets.push(ot);
        } else {
          ro.skippedTargets.push(ot);
        }
      }
    });
  });
};

var process = function process() {
  var depth = 0;
  gatherActiveObservationsAtDepth(depth);

  while (hasActiveObservations()) {
    depth = broadcastActiveObservations();
    gatherActiveObservationsAtDepth(depth);
  }

  if (hasSkippedObservations()) {
    deliverResizeLoopError();
  }

  return depth > 0;
};

var trigger;
var callbacks = [];

var notify = function notify() {
  return callbacks.splice(0).forEach(function (cb) {
    return cb();
  });
};

var queueMicroTask = function queueMicroTask(callback) {
  if (!trigger) {
    var toggle_1 = 0;
    var el_1 = document.createTextNode('');
    var config = {
      characterData: true
    };
    new MutationObserver(function () {
      return notify();
    }).observe(el_1, config);

    trigger = function trigger() {
      el_1.textContent = "" + (toggle_1 ? toggle_1-- : toggle_1++);
    };
  }

  callbacks.push(callback);
  trigger();
};

var queueResizeObserver = function queueResizeObserver(cb) {
  queueMicroTask(function ResizeObserver() {
    requestAnimationFrame(cb);
  });
};

var watching = 0;

var isWatching = function isWatching() {
  return !!watching;
};

var CATCH_PERIOD = 250;
var observerConfig = {
  attributes: true,
  characterData: true,
  childList: true,
  subtree: true
};
var events = ['resize', 'load', 'transitionend', 'animationend', 'animationstart', 'animationiteration', 'keyup', 'keydown', 'mouseup', 'mousedown', 'mouseover', 'mouseout', 'blur', 'focus'];

var time = function time(timeout) {
  if (timeout === void 0) {
    timeout = 0;
  }

  return Date.now() + timeout;
};

var scheduled = false;

var Scheduler = function () {
  function Scheduler() {
    var _this = this;

    this.stopped = true;

    this.listener = function () {
      return _this.schedule();
    };
  }

  Scheduler.prototype.run = function (timeout) {
    var _this = this;

    if (timeout === void 0) {
      timeout = CATCH_PERIOD;
    }

    if (scheduled) {
      return;
    }

    scheduled = true;
    var until = time(timeout);
    queueResizeObserver(function () {
      var elementsHaveResized = false;

      try {
        elementsHaveResized = process();
      } finally {
        scheduled = false;
        timeout = until - time();

        if (!isWatching()) {
          return;
        }

        if (elementsHaveResized) {
          _this.run(1000);
        } else if (timeout > 0) {
          _this.run(timeout);
        } else {
          _this.start();
        }
      }
    });
  };

  Scheduler.prototype.schedule = function () {
    this.stop();
    this.run();
  };

  Scheduler.prototype.observe = function () {
    var _this = this;

    var cb = function cb() {
      return _this.observer && _this.observer.observe(document.body, observerConfig);
    };

    document.body ? cb() : global$1.addEventListener('DOMContentLoaded', cb);
  };

  Scheduler.prototype.start = function () {
    var _this = this;

    if (this.stopped) {
      this.stopped = false;
      this.observer = new MutationObserver(this.listener);
      this.observe();
      events.forEach(function (name) {
        return global$1.addEventListener(name, _this.listener, true);
      });
    }
  };

  Scheduler.prototype.stop = function () {
    var _this = this;

    if (!this.stopped) {
      this.observer && this.observer.disconnect();
      events.forEach(function (name) {
        return global$1.removeEventListener(name, _this.listener, true);
      });
      this.stopped = true;
    }
  };

  return Scheduler;
}();

var scheduler = new Scheduler();

var updateCount = function updateCount(n) {
  !watching && n > 0 && scheduler.start();
  watching += n;
  !watching && scheduler.stop();
};

var skipNotifyOnElement = function skipNotifyOnElement(target) {
  return !isSVG(target) && !isReplacedElement(target) && getComputedStyle(target).display === 'inline';
};

var ResizeObservation = function () {
  function ResizeObservation(target, observedBox) {
    this.target = target;
    this.observedBox = observedBox || ResizeObserverBoxOptions.CONTENT_BOX;
    this.lastReportedSize = {
      inlineSize: 0,
      blockSize: 0
    };
  }

  ResizeObservation.prototype.isActive = function () {
    var size = calculateBoxSize(this.target, this.observedBox, true);

    if (skipNotifyOnElement(this.target)) {
      this.lastReportedSize = size;
    }

    if (this.lastReportedSize.inlineSize !== size.inlineSize || this.lastReportedSize.blockSize !== size.blockSize) {
      return true;
    }

    return false;
  };

  return ResizeObservation;
}();

var ResizeObserverDetail = function () {
  function ResizeObserverDetail(resizeObserver, callback) {
    this.activeTargets = [];
    this.skippedTargets = [];
    this.observationTargets = [];
    this.observer = resizeObserver;
    this.callback = callback;
  }

  return ResizeObserverDetail;
}();

var observerMap = new WeakMap();

var getObservationIndex = function getObservationIndex(observationTargets, target) {
  for (var i = 0; i < observationTargets.length; i += 1) {
    if (observationTargets[i].target === target) {
      return i;
    }
  }

  return -1;
};

var ResizeObserverController = function () {
  function ResizeObserverController() {}

  ResizeObserverController.connect = function (resizeObserver, callback) {
    var detail = new ResizeObserverDetail(resizeObserver, callback);
    observerMap.set(resizeObserver, detail);
  };

  ResizeObserverController.observe = function (resizeObserver, target, options) {
    var detail = observerMap.get(resizeObserver);
    var firstObservation = detail.observationTargets.length === 0;

    if (getObservationIndex(detail.observationTargets, target) < 0) {
      firstObservation && resizeObservers.push(detail);
      detail.observationTargets.push(new ResizeObservation(target, options && options.box));
      updateCount(1);
      scheduler.schedule();
    }
  };

  ResizeObserverController.unobserve = function (resizeObserver, target) {
    var detail = observerMap.get(resizeObserver);
    var index = getObservationIndex(detail.observationTargets, target);
    var lastObservation = detail.observationTargets.length === 1;

    if (index >= 0) {
      lastObservation && resizeObservers.splice(resizeObservers.indexOf(detail), 1);
      detail.observationTargets.splice(index, 1);
      updateCount(-1);
    }
  };

  ResizeObserverController.disconnect = function (resizeObserver) {
    var _this = this;

    var detail = observerMap.get(resizeObserver);
    detail.observationTargets.slice().forEach(function (ot) {
      return _this.unobserve(resizeObserver, ot.target);
    });
    detail.activeTargets.splice(0, detail.activeTargets.length);
  };

  return ResizeObserverController;
}();

var ResizeObserver = function () {
  function ResizeObserver(callback) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to construct 'ResizeObserver': 1 argument required, but only 0 present.");
    }

    if (typeof callback !== 'function') {
      throw new TypeError("Failed to construct 'ResizeObserver': The callback provided as parameter 1 is not a function.");
    }

    ResizeObserverController.connect(this, callback);
  }

  ResizeObserver.prototype.observe = function (target, options) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }

    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'observe' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }

    ResizeObserverController.observe(this, target, options);
  };

  ResizeObserver.prototype.unobserve = function (target) {
    if (arguments.length === 0) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': 1 argument required, but only 0 present.");
    }

    if (!isElement(target)) {
      throw new TypeError("Failed to execute 'unobserve' on 'ResizeObserver': parameter 1 is not of type 'Element");
    }

    ResizeObserverController.unobserve(this, target);
  };

  ResizeObserver.prototype.disconnect = function () {
    ResizeObserverController.disconnect(this);
  };

  ResizeObserver.toString = function () {
    return 'function ResizeObserver () { [polyfill code] }';
  };

  return ResizeObserver;
}();



var resizeObserver = {
  __proto__: null,
  ResizeObserver: ResizeObserver,
  ResizeObserverEntry: ResizeObserverEntry,
  ResizeObserverSize: ResizeObserverSize
};

var resizeObserver$1 = getCjsExportFromNamespace(resizeObserver);

function useResolvedElement(subscriber, refOrElement) {
  var callbackRefElement = React__default.useRef(null);
  var lastReportRef = React__default.useRef(null);
  var cleanupRef = React__default.useRef();
  var callSubscriber = React__default.useCallback(function () {
    var element = null;

    if (callbackRefElement.current) {
      element = callbackRefElement.current;
    } else if (refOrElement) {
      if (refOrElement instanceof HTMLElement) {
        element = refOrElement;
      } else {
        element = refOrElement.current;
      }
    }

    if (lastReportRef.current && lastReportRef.current.element === element && lastReportRef.current.reporter === callSubscriber) {
      return;
    }

    if (cleanupRef.current) {
      cleanupRef.current();
      cleanupRef.current = null;
    }

    lastReportRef.current = {
      reporter: callSubscriber,
      element: element
    };

    if (element) {
      cleanupRef.current = subscriber(element);
    }
  }, [refOrElement, subscriber]);
  React__default.useEffect(function () {
    callSubscriber();
  }, [callSubscriber]);
  return React__default.useCallback(function (element) {
    callbackRefElement.current = element;
    callSubscriber();
  }, [callSubscriber]);
}

var extractSize = function extractSize(entry, boxProp, sizeType) {
  if (!entry[boxProp]) {
    if (boxProp === "contentBoxSize") {
      return entry.contentRect[sizeType === "inlineSize" ? "width" : "height"];
    }

    return undefined;
  }

  return entry[boxProp][0] ? entry[boxProp][0][sizeType] : entry[boxProp][sizeType];
};

function useResizeObserver(opts) {
  if (opts === void 0) {
    opts = {};
  }

  var onResize = opts.onResize;
  var onResizeRef = React__default.useRef(undefined);
  onResizeRef.current = onResize;
  var round = opts.round || Math.round;
  var resizeObserverRef = React__default.useRef();

  var _useState = React__default.useState({
    width: undefined,
    height: undefined
  }),
      size = _useState[0],
      setSize = _useState[1];

  var didUnmount = React__default.useRef(false);
  React__default.useEffect(function () {
    return function () {
      didUnmount.current = true;
    };
  }, []);
  var previous = React__default.useRef({
    width: undefined,
    height: undefined
  });
  var refCallback = useResolvedElement(React__default.useCallback(function (element) {
    if (!resizeObserverRef.current || resizeObserverRef.current.box !== opts.box || resizeObserverRef.current.round !== round) {
      resizeObserverRef.current = {
        box: opts.box,
        round: round,
        instance: new resizeObserver$1.ResizeObserver(function (entries) {
          var entry = entries[0];
          var boxProp = opts.box === "border-box" ? "borderBoxSize" : opts.box === "device-pixel-content-box" ? "devicePixelContentBoxSize" : "contentBoxSize";
          var reportedWidth = extractSize(entry, boxProp, "inlineSize");
          var reportedHeight = extractSize(entry, boxProp, "blockSize");
          var newWidth = reportedWidth ? round(reportedWidth) : undefined;
          var newHeight = reportedHeight ? round(reportedHeight) : undefined;

          if (previous.current.width !== newWidth || previous.current.height !== newHeight) {
            var newSize = {
              width: newWidth,
              height: newHeight
            };
            previous.current.width = newWidth;
            previous.current.height = newHeight;

            if (onResizeRef.current) {
              onResizeRef.current(newSize);
            } else {
              if (!didUnmount.current) {
                setSize(newSize);
              }
            }
          }
        })
      };
    }

    resizeObserverRef.current.instance.observe(element, {
      box: opts.box
    });
    return function () {
      if (resizeObserverRef.current) {
        resizeObserverRef.current.instance.unobserve(element);
      }
    };
  }, [opts.box, round]), opts.ref);
  return React__default.useMemo(function () {
    return {
      ref: refCallback,
      width: size.width,
      height: size.height
    };
  }, [refCallback, size ? size.width : null, size ? size.height : null]);
}

var polyfilled = useResizeObserver;

var useThrottledResizeObserver = function useThrottledResizeObserver(wait) {
  var _useState = useState({
    height: 0,
    width: 0
  }),
      size = _useState[0],
      setSize = _useState[1];

  var onResize = useMemo(function () {
    return lodash.throttle(setSize, wait);
  }, [wait]);

  var _useResizeObserver = polyfilled({
    onResize: onResize,
    box: 'border-box',
    round: Math.floor
  }),
      ref = _useResizeObserver.ref;

  return _extends({
    ref: ref
  }, size);
};

var PREFIX$6 = "MediaTable";
var classes$6 = {
  thumbCell: PREFIX$6 + "-thumbCell"
};
var Root$6 = styled('div', {})(function (_ref) {
  var _ref2, _ref3;

  var theme = _ref.theme;
  return _ref3 = {}, _ref3["& ." + classes$6.thumbCell] = (_ref2 = {
    width: '0'
  }, _ref2[theme.breakpoints.up('md')] = {}, _ref2), _ref3["& .MuiCard-root"] = {
    display: 'inline-block'
  }, _ref3;
});

function Status(props) {
  var status = props.status,
      description = props.description;

  if (status === 'uploading') {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "Uploading\u2026 Keep the tab browser open for now\u2026"
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      color: "error",
      size: 16
    }));
  } else if (['uploaded', 'transcribing'].includes(status)) {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "Processing your media. Please check back later."
    }, /*#__PURE__*/React__default.createElement(CircularProgress, {
      color: "primary",
      size: 16
    }));
  } else if (status === 'published') {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "This media has been published"
    }, /*#__PURE__*/React__default.createElement("span", null, /*#__PURE__*/React__default.createElement(IconButton, {
      disabled: true
    }, /*#__PURE__*/React__default.createElement(PublicIcon, {
      fontSize: "small",
      sx: {
        color: 'primary.light'
      }
    }))));
  } else if (status === 'corrected') {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "Media marked as corrected"
    }, /*#__PURE__*/React__default.createElement(CheckCircleIcon, {
      fontSize: "small",
      color: "disabled"
    }));
  } else if (status === 'error') {
    return /*#__PURE__*/React__default.createElement(Tooltip, {
      title: "Processing failed. Try adding this media again." + (description ? " [" + description + "]" : '')
    }, /*#__PURE__*/React__default.createElement(ErrorIcon, {
      fontSize: "small",
      color: "error"
    }));
  }

  return null;
}

function MediaTable(props) {
  var media = props.media,
      onDeleteMedia = props.onDeleteMedia,
      onEditMedia = props.onEditMedia,
      onTranslateMedia = props.onTranslateMedia,
      onClickMedia = props.onClickMedia;
  var flatMedia = media.map(function (o) {
    var _o$channel;

    return _extends({}, o, {
      channelId: (_o$channel = o.channel) === null || _o$channel === void 0 ? void 0 : _o$channel.id
    });
  });

  var _useState = useState(),
      focused = _useState[0],
      setFocused = _useState[1];

  var _useState2 = useState(null),
      itemMoreMenuAnchor = _useState2[0],
      setItemMoreMenuAnchor = _useState2[1];

  var _useState3 = useState('asc'),
      order = _useState3[0],
      setOrder = _useState3[1];

  var _useState4 = useState('created'),
      orderBy = _useState4[0],
      setOrderBy = _useState4[1];

  var _useState5 = useState(0),
      page = _useState5[0],
      setPage = _useState5[1];

  var _useState6 = useState(150),
      rowsPerPage = _useState6[0],
      setRowsPerPage = _useState6[1];

  var _useState7 = useState([]),
      selected = _useState7[0],
      setSelected = _useState7[1];

  var openItemMoreMenu = Boolean(itemMoreMenuAnchor);

  var handleSelectClick = function handleSelectClick(id) {
    return function () {
      var selectedIndex = selected.indexOf(id);
      var newSelected = [];

      if (selectedIndex === -1) {
        newSelected = newSelected.concat(selected, id);
      } else if (selectedIndex === 0) {
        newSelected = newSelected.concat(selected.slice(1));
      } else if (selectedIndex === selected.length - 1) {
        newSelected = newSelected.concat(selected.slice(0, -1));
      } else if (selectedIndex > 0) {
        newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
      }

      setSelected(newSelected);
    };
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newSelecteds = media.map(function (n) {
        return n.id;
      });
      setSelected(newSelecteds);
      return;
    }

    setSelected([]);
  };

  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  var handleChangeSort = function handleChangeSort(property) {
    return function (event) {
      var isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  };

  var handleEdit = function handleEdit(ids) {
    onEditMedia(ids);
    setItemMoreMenuAnchor(null);
    setFocused(null);
    setSelected([]);
  };

  var handleTranslate = function handleTranslate(ids) {
    onTranslateMedia(ids);
    setItemMoreMenuAnchor(null);
    setFocused(null);
    setSelected([]);
  };

  var handleDelete = function handleDelete(ids) {
    onDeleteMedia(ids);
    setItemMoreMenuAnchor(null);
    setFocused(null);
    setSelected([]);
  };

  var emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - media.length) : 0;
  var headCells = [{
    id: 'title',
    label: 'Media',
    span: 2
  }, {
    hide: true,
    id: 'createdAt',
    label: 'Created'
  }, {
    hide: true,
    id: 'updatedAt',
    label: 'Updated'
  }, {
    hide: true,
    id: 'channelId',
    label: 'Channel'
  }];
  return /*#__PURE__*/React__default.createElement(Root$6, null, /*#__PURE__*/React__default.createElement(Toolbar, {
    disableGutters: true
  }, selected.length > 0 ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: "inherit",
    component: "div",
    display: "inline-block",
    sx: {
      mr: 2
    },
    variant: "h6",
    noWrap: true
  }, selected.length, " selected:"), /*#__PURE__*/React__default.createElement(Button, {
    color: "error",
    onClick: function onClick() {
      return handleDelete(selected);
    },
    size: "small",
    startIcon: /*#__PURE__*/React__default.createElement(DeleteIcon, null),
    disabled: true
  }, "Delete")) : /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    component: "div",
    id: "tableTitle",
    variant: "h6"
  }, "All media")), /*#__PURE__*/React__default.createElement(TablePagination, {
    component: "div",
    count: (media === null || media === void 0 ? void 0 : media.length) || 0,
    labelRowsPerPage: "Rows:",
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 25, 50, 100, 150, 200]
  })), /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, {
    "aria-labelledby": "tableTitle",
    size: "medium",
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox"
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    checked: (media === null || media === void 0 ? void 0 : media.length) > 0 && selected.length === media.length,
    color: "primary",
    indeterminate: selected.length > 0 && selected.length < media.length,
    inputProps: {
      'aria-label': 'select all media'
    },
    onChange: handleSelectAllClick,
    size: "small"
  })), headCells.map(function (headCell) {
    return /*#__PURE__*/React__default.createElement(TableCell, {
      colSpan: headCell.span || 1,
      key: headCell.id,
      sortDirection: orderBy === headCell.id ? order : false,
      sx: {
        display: {
          xs: headCell.hide ? 'none' : 'table-cell',
          lg: 'table-cell'
        }
      }
    }, !headCell.silent && /*#__PURE__*/React__default.createElement(TableSortLabel, {
      active: orderBy === headCell.id,
      direction: orderBy === headCell.id ? order : 'asc',
      onClick: handleChangeSort(headCell.id)
    }, headCell.label, orderBy === headCell.id ? /*#__PURE__*/React__default.createElement(Box, {
      component: "span",
      sx: visuallyHidden
    }, order === 'desc' ? 'sorted descending' : 'sorted ascending') : null));
  }), /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox"
  }), /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox"
  }))), /*#__PURE__*/React__default.createElement(TableBody, null, stableSort(flatMedia, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (row, index) {
    var _row$channel$name, _row$channel, _row$status, _row$status2;

    var isItemSelected = selected.indexOf(row.id) !== -1;
    var labelId = "enhanced-table-checkbox-" + index;
    console.log({
      row: row
    });
    var dateFormat = {
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    };
    var cDate = new Date(row.createdAt);
    var cFormattedDate = new Intl.DateTimeFormat('en', dateFormat).format(cDate);
    var uDate = new Date(row.updatedAt);
    var uFormattedDate = new Intl.DateTimeFormat('en', dateFormat).format(uDate);
    return /*#__PURE__*/React__default.createElement(TableRow, {
      hover: true,
      tabIndex: -1,
      key: row.id,
      onClick: function onClick() {
        return console.log('open');
      },
      selected: isItemSelected,
      sx: row.isProcessing && {
        opacity: 0.5
      }
    }, /*#__PURE__*/React__default.createElement(TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      "aria-checked": isItemSelected,
      checked: isItemSelected,
      color: "primary",
      inputProps: {
        'aria-labelledby': labelId
      },
      onClick: handleSelectClick(row.id),
      role: "checkbox",
      size: "small"
    })), /*#__PURE__*/React__default.createElement(TableCell, {
      id: labelId,
      className: classes$6.thumbCell,
      sx: {
        lineHeight: 0
      }
    }, /*#__PURE__*/React__default.createElement(Card, {
      sx: {
        width: {
          xs: 64,
          lg: 82
        }
      }
    }, /*#__PURE__*/React__default.createElement(CardActionArea, {
      onClick: function onClick(e) {
        e.stopPropagation();
        onClickMedia(row.id);
      }
    }, /*#__PURE__*/React__default.createElement(CardMedia, {
      component: "img",
      height: "100%",
      image: row.poster.replace('poster.png', 'thumb.jpg')
    })))), /*#__PURE__*/React__default.createElement(TableCell, {
      component: "th",
      id: labelId,
      padding: "none",
      scope: "row"
    }, /*#__PURE__*/React__default.createElement(Link, {
      disabled: row.isProcessing,
      underline: row.isProcessing ? 'none' : 'hover',
      display: "block",
      sx: {
        cursor: 'pointer',
        fontWeight: 500,
        py: {
          xs: 1,
          md: 2
        }
      },
      onClick: function onClick(e) {
        e.stopPropagation();
        onClickMedia(row.id);
      },
      color: row.isProcessing ? 'text.disabled' : 'primary',
      variant: "body2"
    }, row.title)), /*#__PURE__*/React__default.createElement(TableCell, {
      sx: {
        display: {
          xs: 'none',
          lg: 'table-cell'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: "textSecondary",
      display: "block",
      noWrap: true,
      variant: "caption"
    }, row.createdAt ? cFormattedDate : '—')), /*#__PURE__*/React__default.createElement(TableCell, {
      sx: {
        display: {
          xs: 'none',
          lg: 'table-cell'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: "textSecondary",
      display: "block",
      noWrap: true,
      variant: "caption"
    }, row.updatedAt ? uFormattedDate : '—')), /*#__PURE__*/React__default.createElement(TableCell, {
      sx: {
        display: {
          xs: 'none',
          lg: 'table-cell'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      color: "textSecondary",
      display: "block",
      noWrap: true,
      variant: "caption"
    }, (_row$channel$name = (_row$channel = row.channel) === null || _row$channel === void 0 ? void 0 : _row$channel.name) != null ? _row$channel$name : '—')), /*#__PURE__*/React__default.createElement(TableCell, {
      padding: "checkbox",
      align: "center"
    }, /*#__PURE__*/React__default.createElement(Status, {
      status: (_row$status = row.status) === null || _row$status === void 0 ? void 0 : _row$status.label,
      description: (_row$status2 = row.status) === null || _row$status2 === void 0 ? void 0 : _row$status2.description
    })), /*#__PURE__*/React__default.createElement(TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      disabled: row.isProcessing,
      fontSize: "small",
      onClick: function onClick(e) {
        e.stopPropagation();
        setFocused(row.id);
        setItemMoreMenuAnchor(e.currentTarget);
        setSelected([row.id]);
      }
    }, /*#__PURE__*/React__default.createElement(MoreHorizIcon, {
      fontSize: "small"
    }))));
  }), emptyRows > 0 && /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      height: 83 * emptyRows
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  }))))), Boolean(focused) && /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: itemMoreMenuAnchor,
    id: "itemMoreMenu",
    MenuListProps: {
      'aria-labelledby': 'openItemMoreButton',
      dense: true
    },
    onClose: function onClose() {
      return setItemMoreMenuAnchor(null);
    },
    open: openItemMoreMenu,
    variant: "menu",
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: function onClick() {
      handleEdit([focused]);
      setItemMoreMenuAnchor(null);
      setFocused(null);
      setSelected([]);
    }
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(EditIcon, {
    color: "primary",
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primaryTypographyProps: {
      color: 'primary'
    }
  }, "Edit")), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: function onClick() {
      handleTranslate([focused]);
      setItemMoreMenuAnchor(null);
      setFocused(null);
      setSelected([]);
    },
    disabled: true
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(TranslateIcon, {
    color: "primary",
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primaryTypographyProps: {
      color: 'primary'
    }
  }, "Translate")), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: function onClick() {
      handleDelete([focused]);
    },
    disabled: true
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(DeleteIcon, {
    color: "error",
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primaryTypographyProps: {
      color: 'error'
    }
  }, "Delete"))));
}

function InviteTeamMemberDialog(_ref) {
  var onClose = _ref.onClose,
      onSubmit = _ref.onSubmit;

  var _useState = useState(''),
      email = _useState[0],
      setEmail = _useState[1];

  return /*#__PURE__*/React__default.createElement(Dialog, {
    open: true,
    onClose: onClose,
    maxWidth: "xs"
  }, /*#__PURE__*/React__default.createElement(DialogTitle, null, "Add team member"), /*#__PURE__*/React__default.createElement(DialogContent, null, /*#__PURE__*/React__default.createElement(DialogContentText, {
    gutterBottom: true
  }, "Your new team member needs to have an active Hyperaudio account. We use emails to identify active users."), /*#__PURE__*/React__default.createElement(TextField, {
    autoFocus: true,
    fullWidth: true,
    id: "email",
    label: "New members\u2019 email",
    margin: "dense",
    onChange: function onChange(e) {
      return setEmail(e.target.value);
    },
    required: true,
    type: "email",
    value: email,
    variant: "standard"
  })), /*#__PURE__*/React__default.createElement(DialogActions, null, /*#__PURE__*/React__default.createElement(Button, {
    onClick: onClose
  }, "Cancel"), /*#__PURE__*/React__default.createElement(Button, {
    variant: "contained",
    onClick: function onClick() {
      return onSubmit(email);
    }
  }, "Add")));
}

var PREFIX$7 = "RolesTable";
var classes$7 = {
  root: PREFIX$7 + "-Root",
  pagination: PREFIX$7 + "-Pagination"
};
var Root$7 = styled('div', {})(function (_ref) {
  var _MuiTablePaginatio, _ref2, _ref3;

  var theme = _ref.theme;
  return _ref3 = {}, _ref3["& ." + classes$7.pagination] = (_ref2 = {}, _ref2["& .MuiTablePagination-spacer, & .MuiTablePagination-selectLabel"] = (_MuiTablePaginatio = {
    display: 'none'
  }, _MuiTablePaginatio[theme.breakpoints.up('md')] = {
    display: 'block'
  }, _MuiTablePaginatio), _ref2), _ref3;
});
function RolesTable(props) {
  var team = props.team,
      onDeleteMembers = props.onDeleteMembers,
      onChangeMemberRole = props.onChangeMemberRole,
      onAddMember = props.onAddMember;
  var members = team.members;

  var _useState = useState(false),
      adding = _useState[0],
      setAdding = _useState[1];

  var _useState2 = useState(),
      focused = _useState2[0],
      setFocused = _useState2[1];

  var _useState3 = useState(null),
      itemMoreMenuAnchor = _useState3[0],
      setItemMoreMenuAnchor = _useState3[1];

  var _useState4 = useState('asc'),
      order = _useState4[0],
      setOrder = _useState4[1];

  var _useState5 = useState('created'),
      orderBy = _useState5[0],
      setOrderBy = _useState5[1];

  var _useState6 = useState(0),
      page = _useState6[0],
      setPage = _useState6[1];

  var _useState7 = useState(25),
      rowsPerPage = _useState7[0],
      setRowsPerPage = _useState7[1];

  var _useState8 = useState([]),
      selected = _useState8[0],
      setSelected = _useState8[1];

  var openItemMoreMenu = Boolean(itemMoreMenuAnchor);

  var handleSelectClick = function handleSelectClick(event, name) {
    var selectedIndex = selected.indexOf(name);
    var newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }

    setSelected(newSelected);
  };

  var handleSelectAllClick = function handleSelectAllClick(event) {
    if (event.target.checked) {
      var newSelecteds = members.map(function (n) {
        return n.userId;
      });
      setSelected(newSelecteds);
      return;
    }

    setSelected([]);
  };

  var handleChangePage = function handleChangePage(event, newPage) {
    setPage(newPage);
  };

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(event) {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  var handleChangeSort = function handleChangeSort(property) {
    return function (event) {
      var isAsc = orderBy === property && order === 'asc';
      setOrder(isAsc ? 'desc' : 'asc');
      setOrderBy(property);
    };
  };

  var handleRemove = function handleRemove(ids) {
    onDeleteMembers(ids);
    setSelected([]);
  };

  var emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - members.length) : 0;
  var headCells = [{
    id: 'displayName',
    label: 'Member'
  }, {
    hide: true,
    id: 'isOrganiser',
    label: 'Organiser'
  }, {
    hide: true,
    id: 'isEditor',
    label: 'Editor'
  }, {
    hide: true,
    id: 'isRemixer',
    label: 'Remixer'
  }, {
    hide: true,
    id: 'isViewer',
    label: 'Viewer'
  }, {
    hide: true,
    id: 'isSpeaker',
    label: 'Speaker'
  }, {
    hide: true,
    id: 'pointer',
    label: 'Payment pointer'
  }];
  var flatMembers = members.map(function (_ref4) {
    var displayName = _ref4.displayName,
        userId = _ref4.userId,
        userStatus = _ref4.userStatus,
        email = _ref4.email,
        payment = _ref4.payment,
        roles = _ref4.roles;
    return {
      displayName: displayName,
      email: email,
      isEditor: roles.editor,
      isOrganiser: roles.organiser,
      isRemixer: roles.remixer,
      isSpeaker: roles.speaker,
      isViewer: roles.viewer,
      pointer: payment.pointer || '—',
      userId: userId,
      userStatus: userStatus
    };
  });

  var getRoles = function getRoles(id) {
    var keys = ['Organiser', 'Editor', 'Remixer', 'Viewer', 'Speaker'];
    return keys.map(function (key) {
      return {
        key: "is" + key,
        label: key,
        value: lodash.find(flatMembers, function (o) {
          return o.userId === id;
        })["is" + key]
      };
    });
  };

  return /*#__PURE__*/React__default.createElement(React__default.Fragment, null, /*#__PURE__*/React__default.createElement(Root$7, {
    className: classes$7.root
  }, /*#__PURE__*/React__default.createElement(Toolbar, {
    disableGutters: true
  }, selected.length > 0 ? /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    color: "inherit",
    component: "div",
    display: "inline-block",
    sx: {
      mr: 2
    },
    variant: "h6"
  }, selected.length, " selected:"), /*#__PURE__*/React__default.createElement(Button, {
    color: "error",
    onClick: function onClick() {
      return handleRemove(selected);
    },
    size: "small",
    startIcon: /*#__PURE__*/React__default.createElement(PersonRemoveIcon, null)
  }, "Remove")) : /*#__PURE__*/React__default.createElement(Box, {
    sx: {
      flex: '1 1 auto',
      display: 'flex',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React__default.createElement(Typography, {
    component: "div",
    id: "tableTitle",
    sx: {
      mr: 2
    },
    variant: "h6"
  }, "All members"), /*#__PURE__*/React__default.createElement(Button, {
    color: "primary",
    onClick: function onClick() {
      return setAdding(true);
    },
    size: "small",
    startIcon: /*#__PURE__*/React__default.createElement(PersonAddIcon, null)
  }, "Add new")), /*#__PURE__*/React__default.createElement(TablePagination, {
    className: classes$7.pagination,
    component: "div",
    count: members.length,
    labelRowsPerPage: "Rows:",
    onPageChange: handleChangePage,
    onRowsPerPageChange: handleChangeRowsPerPage,
    page: page,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 25]
  })), /*#__PURE__*/React__default.createElement(TableContainer, null, /*#__PURE__*/React__default.createElement(Table, {
    "aria-labelledby": "tableTitle",
    size: "medium",
    sx: {
      width: '100%'
    }
  }, /*#__PURE__*/React__default.createElement(TableHead, null, /*#__PURE__*/React__default.createElement(TableRow, null, /*#__PURE__*/React__default.createElement(TableCell, {
    padding: "checkbox"
  }, /*#__PURE__*/React__default.createElement(Checkbox, {
    color: "primary",
    indeterminate: selected.length > 0 && selected.length < members.length,
    checked: members.length > 0 && selected.length === members.length,
    onChange: handleSelectAllClick,
    inputProps: {
      'aria-label': 'select all desserts'
    }
  })), headCells.map(function (headCell) {
    return /*#__PURE__*/React__default.createElement(TableCell, {
      colSpan: headCell.span || 1,
      key: headCell.id,
      sortDirection: orderBy === headCell.id ? order : false,
      sx: {
        display: {
          xs: headCell.hide ? 'none' : 'table-cell',
          lg: 'table-cell'
        }
      }
    }, /*#__PURE__*/React__default.createElement(TableSortLabel, {
      active: orderBy === headCell.id,
      direction: orderBy === headCell.id ? order : 'asc',
      onClick: handleChangeSort(headCell.id)
    }, headCell.label, orderBy === headCell.id ? /*#__PURE__*/React__default.createElement(Box, {
      component: "span",
      sx: visuallyHidden
    }, order === 'desc' ? 'sorted descending' : 'sorted ascending') : null));
  }), /*#__PURE__*/React__default.createElement(TableCell, null))), /*#__PURE__*/React__default.createElement(TableBody, null, stableSort(flatMembers, getComparator(order, orderBy)).slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(function (o, index) {
    var isItemSelected = selected.indexOf(o.userId) !== -1;
    var labelId = "enhanced-table-checkbox-" + index;
    var allRoles = getRoles(o.userId);
    return /*#__PURE__*/React__default.createElement(TableRow, {
      hover: true,
      key: o.userId,
      selected: isItemSelected,
      tabIndex: -1
    }, /*#__PURE__*/React__default.createElement(TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/React__default.createElement(Checkbox, {
      color: "primary",
      checked: isItemSelected,
      role: "checkbox",
      "aria-checked": isItemSelected,
      onClick: function onClick(event) {
        return handleSelectClick(event, o.userId);
      },
      inputProps: {
        'aria-labelledby': labelId
      }
    })), /*#__PURE__*/React__default.createElement(TableCell, {
      component: "th",
      id: labelId,
      scope: "row"
    }, /*#__PURE__*/React__default.createElement(Typography, {
      display: "block",
      noWrap: true,
      variant: "subtitle2"
    }, o.displayName), /*#__PURE__*/React__default.createElement(Typography, {
      display: "block",
      noWrap: true,
      variant: "caption"
    }, o.email)), allRoles.map(function (role) {
      return /*#__PURE__*/React__default.createElement(TableCell, {
        key: role.key,
        sx: {
          display: {
            xs: 'none',
            lg: 'table-cell'
          }
        },
        padding: "checkbox"
      }, /*#__PURE__*/React__default.createElement(Checkbox, {
        checked: role.value,
        checkedIcon: /*#__PURE__*/React__default.createElement(CheckCircleIcon, null),
        disabled: role.key === 'isOrganiser',
        icon: /*#__PURE__*/React__default.createElement(RadioButtonUncheckedIcon, null),
        onChange: function onChange(e) {
          return onChangeMemberRole({
            id: o.userId,
            role: role.label.toLowerCase(),
            value: e.target.checked
          });
        }
      }));
    }), /*#__PURE__*/React__default.createElement(TableCell, {
      sx: {
        display: {
          xs: 'none',
          lg: 'table-cell'
        }
      }
    }, /*#__PURE__*/React__default.createElement(Typography, {
      variant: "caption"
    }, o.pointer)), /*#__PURE__*/React__default.createElement(TableCell, {
      padding: "checkbox"
    }, /*#__PURE__*/React__default.createElement(IconButton, {
      disabled: o.isProcessing,
      fontSize: "small",
      onClick: function onClick(e) {
        e.stopPropagation();
        setFocused(o.userId);
        setItemMoreMenuAnchor(e.currentTarget);
        setSelected([o.userId]);
      }
    }, /*#__PURE__*/React__default.createElement(MoreHorizIcon, {
      fontSize: "small"
    }))));
  }), emptyRows > 0 && /*#__PURE__*/React__default.createElement(TableRow, {
    style: {
      height: 83 * emptyRows
    }
  }, /*#__PURE__*/React__default.createElement(TableCell, {
    colSpan: 8
  })))))), Boolean(focused) && /*#__PURE__*/React__default.createElement(Menu, {
    anchorEl: itemMoreMenuAnchor,
    id: "itemMoreMenu",
    MenuListProps: {
      'aria-labelledby': 'openItemMoreButton',
      dense: true,
      subheader: /*#__PURE__*/React__default.createElement(ListSubheader, {
        component: "div",
        id: "nested-list-subheader"
      }, "Edit user roles:")
    },
    onClose: function onClose() {
      setFocused();
      setItemMoreMenuAnchor();
      setSelected([]);
    },
    open: openItemMoreMenu,
    variant: "menu",
    transformOrigin: {
      horizontal: 'right',
      vertical: 'top'
    },
    anchorOrigin: {
      horizontal: 'right',
      vertical: 'bottom'
    }
  }, getRoles(focused).map(function (role) {
    if (role.key === 'isOrganiser') return null;
    return /*#__PURE__*/React__default.createElement(MenuItem, {
      key: role.key,
      onClick: function onClick(e) {
        onChangeMemberRole({
          id: focused,
          role: role.label.toLowerCase(),
          value: !role.value
        });
        e.stopPropagation();
      }
    }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(Checkbox, {
      checked: role.value,
      checkedIcon: /*#__PURE__*/React__default.createElement(CheckCircleIcon, null),
      edge: "start",
      icon: /*#__PURE__*/React__default.createElement(RadioButtonUncheckedIcon, null),
      inputProps: {
        'aria-labelledby': "label-" + role.key
      },
      size: "small"
    })), /*#__PURE__*/React__default.createElement(ListItemText, {
      id: role.key,
      primary: role.label,
      primaryTypographyProps: {
        color: 'primary'
      }
    }));
  }), /*#__PURE__*/React__default.createElement(Divider, null), /*#__PURE__*/React__default.createElement(MenuItem, {
    onClick: function onClick() {
      handleRemove([focused]);
      setItemMoreMenuAnchor(null);
      setFocused(null);
    }
  }, /*#__PURE__*/React__default.createElement(ListItemIcon, null, /*#__PURE__*/React__default.createElement(PersonRemoveIcon, {
    color: "error",
    fontSize: "small"
  })), /*#__PURE__*/React__default.createElement(ListItemText, {
    primaryTypographyProps: {
      color: 'error'
    }
  }, "Remove from team"))), adding && /*#__PURE__*/React__default.createElement(InviteTeamMemberDialog, {
    onClose: function onClose() {
      return setAdding(false);
    },
    onSubmit: onAddMember
  }));
}

var mui = createTheme();
var sizes = {
  h1: {
    xs: '2.4rem',
    md: '3.2rem',
    xl: '3.8rem'
  },
  h2: {
    xs: '2.2rem',
    md: '2.9rem',
    xl: '3.3rem'
  },
  h3: {
    xs: '2.0rem',
    md: '2.6rem',
    xl: '2.8rem'
  },
  h4: {
    xs: '1.8rem',
    md: '2.3rem',
    xl: '2.3rem'
  },
  h5: {
    xs: '1.6rem',
    md: '1.7rem',
    xl: '1.8rem'
  },
  h6: {
    xs: '1.4rem',
    md: '1.5rem',
    xl: '1.6rem'
  },
  subtitle1: {
    xs: '1.2rem',
    md: '1.4rem',
    xl: '1.6rem'
  },
  subtitle2: {
    xs: '1.1rem',
    md: '1.3rem',
    xl: '1.5rem'
  },
  body1: {
    xs: '1.2rem',
    md: '1.3rem',
    xl: '1.4rem'
  },
  body2: {
    xs: '1.0rem',
    md: '1.1rem',
    xl: '1.2rem'
  },
  button: {
    xs: '0.88rem',
    md: '0.90rem',
    xl: '0.92rem'
  },
  overline: {
    xs: '0.7rem',
    md: '0.75rem',
    xl: '0.8rem'
  },
  caption: {
    xs: '0.8rem',
    md: '0.85rem',
    xl: '0.9rem'
  }
};
var body = 'Inter, Helvetica, Arial, sans-serif';

var getSizes = function getSizes(variant, mode, responsive) {
  if (responsive === void 0) {
    responsive = false;
  }

  var base = {
    fontSize: sizes[variant].xs
  };
  var extension;

  if (mode === 'responsive' || responsive) {
    var _extension;

    extension = (_extension = {}, _extension[mui.breakpoints.up('md')] = {
      fontSize: sizes[variant].md
    }, _extension[mui.breakpoints.up('xl')] = {
      fontSize: sizes[variant].xl
    }, _extension);
  }

  return _extends({}, base, extension);
};

var getTypography = function getTypography(mode) {
  return _extends({}, mui.typography, {
    fontFamily: body,
    h1: _extends({}, getSizes('h1', mode), {
      fontWeight: '600',
      letterSpacing: '-0.011em',
      lineHeight: '1.22em'
    }),
    h2: _extends({}, getSizes('h2', mode), {
      fontWeight: '700',
      letterSpacing: '-0.022em',
      lineHeight: '1.22em'
    }),
    h3: _extends({}, getSizes('h3', mode), {
      fontWeight: '500',
      letterSpacing: '-0.022em',
      lineHeight: '1.22em'
    }),
    h4: _extends({}, getSizes('h4', mode), {
      fontWeight: '600',
      lineHeight: '1.33em'
    }),
    h5: _extends({}, getSizes('h5', mode), {
      fontWeight: '600',
      lineHeight: '1.33em'
    }),
    h6: _extends({}, getSizes('h6', mode), {
      fontWeight: '600',
      lineHeight: '1.44em'
    }),
    subtitle1: _extends({}, getSizes('subtitle1', mode), {
      fontWeight: 600,
      lineHeight: '1.33em'
    }),
    subtitle2: _extends({}, getSizes('subtitle2', mode, true), {
      fontWeight: 600,
      lineHeight: '1.33em'
    }),
    body1: _extends({}, getSizes('body1', mode), {
      letterSpacing: 'none',
      lineHeight: '1.44em'
    }),
    body2: _extends({}, getSizes('body2', mode), {
      letterSpacing: 'none',
      lineHeight: '1.44em'
    }),
    button: _extends({}, getSizes('button', mode), {
      letterSpacing: '0.044em',
      fontWeight: '600'
    }),
    overline: _extends({}, getSizes('overline', mode), {
      fontWeight: '700',
      letterSpacing: '0.044em',
      lineHeight: '1.44em'
    }),
    caption: _extends({}, getSizes('caption', mode), {
      fontWeight: '400',
      letterSpacing: 0,
      lineHeight: '1.44em'
    })
  });
};

var _body, _html;
var mui$1 = createTheme();
var components = {
  MuiCssBaseline: {
    styleOverrides: {
      body: (_body = {}, _body["& > div"] = {
        minHeight: '100%'
      }, _body),
      html: (_html = {
        minHeight: '100%',
        scrollBehavior: 'smooth'
      }, _html["& *::selection"] = {
        backgroundColor: deepPurple[100]
      }, _html)
    }
  },
  MuiButtonBase: {
    defaultProps: {
      disableRipple: true
    }
  },
  MuiButton: {
    defaultProps: {
      disableElevation: true
    },
    styleOverrides: {
      root: {
        borderRadius: mui$1.spacing(3)
      }
    }
  },
  MuiCard: {
    defaultProps: {
      square: false
    },
    styleOverrides: {
      root: {
        borderRadius: mui$1.shape.borderRadius
      }
    }
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        padding: mui$1.spacing(2)
      }
    }
  },
  MuiDialogTitle: {
    styleOverrides: {
      root: {
        padding: mui$1.spacing(3)
      }
    }
  },
  MuiDialogContent: {
    styleOverrides: {
      root: {
        padding: mui$1.spacing(3, 3)
      }
    }
  },
  MuiDialogActions: {
    styleOverrides: {
      root: {
        padding: mui$1.spacing(3)
      }
    }
  },
  MuiIconButton: {
    defaultProps: {
      color: 'primary'
    },
    styleOverrides: {
      root: {
        borderRadius: 100
      }
    }
  },
  MuiInputBase: {
    styleOverrides: {
      root: _extends({}, getTypography().body2)
    }
  },
  MuiFilledInput: {
    defaultProps: {
      disableUnderline: true
    },
    styleOverrides: {
      root: {
        backgroundColor: 'rgba(0,0,0,0.033)',
        borderRadius: mui$1.shape.borderRadius,
        '&.Mui-disabled': {
          backgroundColor: 'rgba(0,0,0,0.022)'
        }
      },
      input: {
        borderRadius: mui$1.shape.borderRadius,
        '&:focus': {
          borderRadius: mui$1.shape.borderRadius
        }
      }
    }
  },
  MuiTablePagination: {
    styleOverrides: {
      actions: {
        marginLeft: mui$1.spacing(1)
      },
      selectLabel: {
        display: {
          sx: 'none',
          lg: 'block'
        }
      },
      displayedRows: {
        display: 'none'
      },
      selectRoot: {
        marginRight: 0
      }
    }
  },
  MuiPaper: {
    styleOverrides: {
      rounded: {
        borderRadius: mui$1.spacing(1)
      }
    }
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: _extends({}, getTypography().caption, {
        background: deepPurple[700],
        boxShadow: mui$1.shadows[1],
        color: deepPurple[50]
      })
    }
  }
};

var shadows = ['none', "0px 1.4px 3.1px rgba(0, 0, 0, 0.003), 0px 3.5px 7.8px rgba(0, 0, 0, 0.004), 0px 7.1px 15.9px rgba(0, 0, 0, 0.006), 0px 14.6px 32.9px rgba(0, 0, 0, 0.007), 0px 40px 90px rgba(0, 0, 0, 0.01)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.006), 0px 3.5px 7.8px rgba(0, 0, 0, 0.009), 0px 7.1px 15.9px rgba(0, 0, 0, 0.011), 0px 14.6px 32.9px rgba(0, 0, 0, 0.014), 0px 40px 90px rgba(0, 0, 0, 0.02)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.009), 0px 3.5px 7.8px rgba(0, 0, 0, 0.013), 0px 7.1px 15.9px rgba(0, 0, 0, 0.017), 0px 14.6px 32.9px rgba(0, 0, 0, 0.021), 0px 40px 90px rgba(0, 0, 0, 0.03)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.012), 0px 3.5px 7.8px rgba(0, 0, 0, 0.018), 0px 7.1px 15.9px rgba(0, 0, 0, 0.022), 0px 14.6px 32.9px rgba(0, 0, 0, 0.028), 0px 40px 90px rgba(0, 0, 0, 0.04)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.016), 0px 3.5px 7.8px rgba(0, 0, 0, 0.022), 0px 7.1px 15.9px rgba(0, 0, 0, 0.028), 0px 14.6px 32.9px rgba(0, 0, 0, 0.034), 0px 40px 90px rgba(0, 0, 0, 0.05)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.019), 0px 3.5px 7.8px rgba(0, 0, 0, 0.027), 0px 7.1px 15.9px rgba(0, 0, 0, 0.033), 0px 14.6px 32.9px rgba(0, 0, 0, 0.041), 0px 40px 90px rgba(0, 0, 0, 0.06)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.022), 0px 3.5px 7.8px rgba(0, 0, 0, 0.031), 0px 7.1px 15.9px rgba(0, 0, 0, 0.039), 0px 14.6px 32.9px rgba(0, 0, 0, 0.048), 0px 40px 90px rgba(0, 0, 0, 0.07)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.025), 0px 3.5px 7.8px rgba(0, 0, 0, 0.035), 0px 7.1px 15.9px rgba(0, 0, 0, 0.045), 0px 14.6px 32.9px rgba(0, 0, 0, 0.055), 0px 40px 90px rgba(0, 0, 0, 0.08)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.028), 0px 3.5px 7.8px rgba(0, 0, 0, 0.04), 0px 7.1px 15.9px rgba(0, 0, 0, 0.05), 0px 14.6px 32.9px rgba(0, 0, 0, 0.062), 0px 40px 90px rgba(0, 0, 0, 0.09)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.031), 0px 3.5px 7.8px rgba(0, 0, 0, 0.044), 0px 7.1px 15.9px rgba(0, 0, 0, 0.056), 0px 14.6px 32.9px rgba(0, 0, 0, 0.069), 0px 40px 90px rgba(0, 0, 0, 0.1)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.034), 0px 3.5px 7.8px rgba(0, 0, 0, 0.049), 0px 7.1px 15.9px rgba(0, 0, 0, 0.061), 0px 14.6px 32.9px rgba(0, 0, 0, 0.076), 0px 40px 90px rgba(0, 0, 0, 0.11)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.037), 0px 3.5px 7.8px rgba(0, 0, 0, 0.053), 0px 7.1px 15.9px rgba(0, 0, 0, 0.067), 0px 14.6px 32.9px rgba(0, 0, 0, 0.083), 0px 40px 90px rgba(0, 0, 0, 0.12)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.04), 0px 3.5px 7.8px rgba(0, 0, 0, 0.058), 0px 7.1px 15.9px rgba(0, 0, 0, 0.072), 0px 14.6px 32.9px rgba(0, 0, 0, 0.09), 0px 40px 90px rgba(0, 0, 0, 0.13)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.043), 0px 3.5px 7.8px rgba(0, 0, 0, 0.062), 0px 7.1px 15.9px rgba(0, 0, 0, 0.078), 0px 14.6px 32.9px rgba(0, 0, 0, 0.097), 0px 40px 90px rgba(0, 0, 0, 0.14)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.047), 0px 3.5px 7.8px rgba(0, 0, 0, 0.067), 0px 7.1px 15.9px rgba(0, 0, 0, 0.083), 0px 14.6px 32.9px rgba(0, 0, 0, 0.103), 0px 40px 90px rgba(0, 0, 0, 0.15)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.05), 0px 3.5px 7.8px rgba(0, 0, 0, 0.071), 0px 7.1px 15.9px rgba(0, 0, 0, 0.089), 0px 14.6px 32.9px rgba(0, 0, 0, 0.11), 0px 40px 90px rgba(0, 0, 0, 0.16)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.053), 0px 3.5px 7.8px rgba(0, 0, 0, 0.075), 0px 7.1px 15.9px rgba(0, 0, 0, 0.095), 0px 14.6px 32.9px rgba(0, 0, 0, 0.117), 0px 40px 90px rgba(0, 0, 0, 0.17)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.056), 0px 3.5px 7.8px rgba(0, 0, 0, 0.08), 0px 7.1px 15.9px rgba(0, 0, 0, 0.1), 0px 14.6px 32.9px rgba(0, 0, 0, 0.124), 0px 40px 90px rgba(0, 0, 0, 0.18)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.059), 0px 3.5px 7.8px rgba(0, 0, 0, 0.084), 0px 7.1px 15.9px rgba(0, 0, 0, 0.106), 0px 14.6px 32.9px rgba(0, 0, 0, 0.131), 0px 40px 90px rgba(0, 0, 0, 0.19)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.062), 0px 3.5px 7.8px rgba(0, 0, 0, 0.089), 0px 7.1px 15.9px rgba(0, 0, 0, 0.111), 0px 14.6px 32.9px rgba(0, 0, 0, 0.138), 0px 40px 90px rgba(0, 0, 0, 0.2)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.065), 0px 3.5px 7.8px rgba(0, 0, 0, 0.093), 0px 7.1px 15.9px rgba(0, 0, 0, 0.117), 0px 14.6px 32.9px rgba(0, 0, 0, 0.145), 0px 40px 90px rgba(0, 0, 0, 0.21)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.068), 0px 3.5px 7.8px rgba(0, 0, 0, 0.098), 0px 7.1px 15.9px rgba(0, 0, 0, 0.122), 0px 14.6px 32.9px rgba(0, 0, 0, 0.152), 0px 40px 90px rgba(0, 0, 0, 0.22)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.071), 0px 3.5px 7.8px rgba(0, 0, 0, 0.102), 0px 7.1px 15.9px rgba(0, 0, 0, 0.128), 0px 14.6px 32.9px rgba(0, 0, 0, 0.159), 0px 40px 90px rgba(0, 0, 0, 0.23)", "0px 1.4px 3.1px rgba(0, 0, 0, 0.074), 0px 3.5px 7.8px rgba(0, 0, 0, 0.106), 0px 7.1px 15.9px rgba(0, 0, 0, 0.134), 0px 14.6px 32.9px rgba(0, 0, 0, 0.166), 0px 40px 90px rgba(0, 0, 0, 0.24)"];

var nmfPink = {
  900: '#93218E',
  800: '#A2319E',
  700: '#AA39A6',
  600: '#B242AF',
  500: '#B949B6',
  400: '#C464C1',
  300: '#CE80CC',
  200: '#DCA4DB',
  100: '#EAC8E9',
  50: '#F7E9F6',
  A400: '#C464C1'
};
var nmfCyan = {
  900: '#1198B0',
  800: '#1CA6BC',
  700: '#22AEC2',
  600: '#28B7C9',
  500: '#2DBDCE',
  400: '#4DC7D5',
  300: '#6CD1DD',
  200: '#96DEE7',
  100: '#C0EBF0',
  50: '#E6F7F9',
  A400: '#4DC7D5'
};
var mui$2 = createTheme();
var lightPalette = _extends({}, mui$2.palette, {
  mode: 'light',
  background: _extends({}, mui$2.palette.background, {
    "default": '#F5F5F7',
    paper: '#fff'
  }),
  text: {
    primary: grey[900],
    secondary: grey[700],
    disabled: grey[600]
  },
  divider: 'rgba(0,0,0,0.088)',
  primary: nmfPink,
  secondary: nmfCyan
});
var darkPalette = _extends({}, mui$2.palette, {
  mode: 'dark',
  background: _extends({}, mui$2.palette.background, {
    "default": '#1c1c1c',
    paper: '#363636'
  }),
  text: {
    primary: grey[100],
    secondary: grey[200],
    disabled: grey[300]
  },
  divider: 'rgba(255,255,255,0.088)',
  primary: nmfPink,
  secondary: nmfCyan
});

var getTheme = function getTheme(options) {
  return createTheme({
    components: components,
    palette: (options === null || options === void 0 ? void 0 : options.mode) === 'dark' ? darkPalette : lightPalette,
    shadows: shadows,
    typography: getTypography(options === null || options === void 0 ? void 0 : options.typography)
  });
};

var TODO = 'todo';

export { Brandmark, FullSizeIcon, HideSourceIcon, HyperaudioConferences, HyperaudioIcon, HyperaudioMain, HyperaudioPodcasts, HyperaudioSchools, LowerThirdsIcon, MediaTable, MoveDownIcon, MoveUpIcon, RecursiveMenuItem, RolesTable, Share1Pane, Share2Panes, ShareIcon, ShowContextIcon, ShowSourceIcon, StartDropIcon, TODO, Thumb, descendingComparator, getComparator, getTheme, stableSort, useThrottledResizeObserver, useWindowSize };
//# sourceMappingURL=index.modern.js.map
